/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccountLocationDto
 */
export interface AccountLocationDto {
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'facebook'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'restaurantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {Array<BrandLogoDto>}
     * @memberof AccountLocationDto
     */
    'brandLogos'?: Array<BrandLogoDto>;
    /**
     * 
     * @type {Array<BrandUploadedFontDto>}
     * @memberof AccountLocationDto
     */
    'brandUploadedFonts'?: Array<BrandUploadedFontDto>;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'type'?: AccountLocationDtoTypeEnum;
    /**
     * 
     * @type {Array<AccountMemberDto>}
     * @memberof AccountLocationDto
     */
    'managers'?: Array<AccountMemberDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLocationDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'designCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'qrCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'lpCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'omCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLocationDto
     */
    'primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLocationDto
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLocationDto
     */
    'drdAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountLocationDto
     */
    'billingExempt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'profitCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'shamrockCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'toastLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'squareLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'popmenuLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'communityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLocationDto
     */
    'treezLocationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'managersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountLocationDto
     */
    'availableScreens'?: number;
}

export const AccountLocationDtoTypeEnum = {
    Restaurant: 'Restaurant',
    Spa: 'Spa',
    Dispensary: 'Dispensary',
    Designer: 'Designer',
    Other: 'Other'
} as const;

export type AccountLocationDtoTypeEnum = typeof AccountLocationDtoTypeEnum[keyof typeof AccountLocationDtoTypeEnum];

/**
 * 
 * @export
 * @interface AccountMemberDto
 */
export interface AccountMemberDto {
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountMemberDto
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'friendlyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {Set<AccountLocationDto>}
     * @memberof AccountMemberDto
     */
    'locations'?: Set<AccountLocationDto>;
    /**
     * 
     * @type {number}
     * @memberof AccountMemberDto
     */
    'paymentStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'invitationStatus'?: AccountMemberDtoInvitationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'memberStatus'?: AccountMemberDtoMemberStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AccountMemberDto
     */
    'primaryLocationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountMemberDto
     */
    'availableSeats'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'role'?: AccountMemberDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'ga4id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountMemberDto
     */
    'numLogins'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'downloads'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'templates'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'printing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'partner'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'subscriptionInvoicing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'diningRDIntegration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'diningRDAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'enterpriseDisplayAccount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountMemberDto
     */
    'ssoMicrosoft'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccountMemberDto
     */
    'ssoProvider'?: string;
}

export const AccountMemberDtoInvitationStatusEnum = {
    Invited: 'Invited',
    Active: 'Active',
    Revoked: 'Revoked'
} as const;

export type AccountMemberDtoInvitationStatusEnum = typeof AccountMemberDtoInvitationStatusEnum[keyof typeof AccountMemberDtoInvitationStatusEnum];
export const AccountMemberDtoMemberStatusEnum = {
    Active: 'Active',
    Hold: 'Hold',
    Cancelled: 'Cancelled',
    Declined: 'Declined',
    Freemium: 'Freemium',
    Paused: 'Paused',
    PastDue: 'PastDue',
    Removed: 'Removed'
} as const;

export type AccountMemberDtoMemberStatusEnum = typeof AccountMemberDtoMemberStatusEnum[keyof typeof AccountMemberDtoMemberStatusEnum];
export const AccountMemberDtoRoleEnum = {
    User: 'User',
    Owner: 'Owner',
    Admin: 'Admin'
} as const;

export type AccountMemberDtoRoleEnum = typeof AccountMemberDtoRoleEnum[keyof typeof AccountMemberDtoRoleEnum];

/**
 * 
 * @export
 * @interface AccountPastDueStatusDto
 */
export interface AccountPastDueStatusDto {
    /**
     * 
     * @type {string}
     * @memberof AccountPastDueStatusDto
     */
    'invoice'?: string;
}
/**
 * 
 * @export
 * @interface AddOnDto
 */
export interface AddOnDto {
    /**
     * 
     * @type {string}
     * @memberof AddOnDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOnDto
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddOnDto
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddOnDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddOnDto
     */
    'type'?: AddOnDtoTypeEnum;
}

export const AddOnDtoTypeEnum = {
    Location: 'LOCATION',
    Dsa: 'DSA',
    Listings: 'LISTINGS'
} as const;

export type AddOnDtoTypeEnum = typeof AddOnDtoTypeEnum[keyof typeof AddOnDtoTypeEnum];

/**
 * 
 * @export
 * @interface AddonExpirationDto
 */
export interface AddonExpirationDto {
    /**
     * 
     * @type {string}
     * @memberof AddonExpirationDto
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface AffiliateDto
 */
export interface AffiliateDto {
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'business'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AffiliateDto
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface AssetDto
 */
export interface AssetDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'category'?: AssetDtoCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetDto
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'fileType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'altText'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetDto
     */
    'brandKitNames'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDto
     */
    'updatedDate'?: string;
}

export const AssetDtoCategoryEnum = {
    Logos: 'LOGOS',
    Fonts: 'FONTS',
    Icons: 'ICONS',
    Photos: 'PHOTOS',
    Graphics: 'GRAPHICS'
} as const;

export type AssetDtoCategoryEnum = typeof AssetDtoCategoryEnum[keyof typeof AssetDtoCategoryEnum];

/**
 * 
 * @export
 * @interface AssignPosLocation
 */
export interface AssignPosLocation {
    /**
     * 
     * @type {number}
     * @memberof AssignPosLocation
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignPosLocation
     */
    'posLocationId'?: string;
}
/**
 * 
 * @export
 * @interface BillingAddressDto
 */
export interface BillingAddressDto {
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'first'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'last'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingAddressDto
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface BrandBackgroundImageDto
 */
export interface BrandBackgroundImageDto {
    /**
     * 
     * @type {string}
     * @memberof BrandBackgroundImageDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBackgroundImageDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBackgroundImageDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandBackgroundImageDto
     */
    'brandId'?: string;
}
/**
 * 
 * @export
 * @interface BrandColorDto
 */
export interface BrandColorDto {
    /**
     * 
     * @type {string}
     * @memberof BrandColorDto
     */
    'colorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandColorDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandColorDto
     */
    'brandId'?: string;
}
/**
 * 
 * @export
 * @interface BrandDto
 */
export interface BrandDto {
    /**
     * 
     * @type {string}
     * @memberof BrandDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandDto
     */
    'memberId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandDto
     */
    'draft'?: boolean;
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandDto
     */
    'fontHeader'?: BrandFontDto;
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandDto
     */
    'fontSubheader'?: BrandFontDto;
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandDto
     */
    'fontBodyText'?: BrandFontDto;
    /**
     * 
     * @type {Array<BrandLogoDto>}
     * @memberof BrandDto
     */
    'logos'?: Array<BrandLogoDto>;
    /**
     * 
     * @type {Array<BrandBackgroundImageDto>}
     * @memberof BrandDto
     */
    'backgroundImages'?: Array<BrandBackgroundImageDto>;
    /**
     * 
     * @type {Array<BrandBackgroundImageDto>}
     * @memberof BrandDto
     */
    'graphics'?: Array<BrandBackgroundImageDto>;
    /**
     * 
     * @type {Array<BrandBackgroundImageDto>}
     * @memberof BrandDto
     */
    'icons'?: Array<BrandBackgroundImageDto>;
    /**
     * 
     * @type {Array<BrandColorDto>}
     * @memberof BrandDto
     */
    'colors'?: Array<BrandColorDto>;
    /**
     * 
     * @type {Array<BrandProFontDto>}
     * @memberof BrandDto
     */
    'proFonts'?: Array<BrandProFontDto>;
    /**
     * 
     * @type {Array<BrandUploadedFontDto>}
     * @memberof BrandDto
     */
    'uploadedFonts'?: Array<BrandUploadedFontDto>;
}
/**
 * 
 * @export
 * @interface BrandFontDto
 */
export interface BrandFontDto {
    /**
     * 
     * @type {string}
     * @memberof BrandFontDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandFontDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandFontDto
     */
    'size'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandFontDto
     */
    'bold'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandFontDto
     */
    'italic'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandFontDto
     */
    'underline'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandFontDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandFontDto
     */
    'textType'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandFontDto
     */
    'fontName'?: string;
}
/**
 * 
 * @export
 * @interface BrandFontsDto
 */
export interface BrandFontsDto {
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandFontsDto
     */
    'fontHeader'?: BrandFontDto;
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandFontsDto
     */
    'fontSubheader'?: BrandFontDto;
    /**
     * 
     * @type {BrandFontDto}
     * @memberof BrandFontsDto
     */
    'fontBodyText'?: BrandFontDto;
    /**
     * 
     * @type {Array<BrandProFontDto>}
     * @memberof BrandFontsDto
     */
    'proFonts'?: Array<BrandProFontDto>;
    /**
     * 
     * @type {Array<BrandUploadedFontDto>}
     * @memberof BrandFontsDto
     */
    'uploadedFonts'?: Array<BrandUploadedFontDto>;
}
/**
 * 
 * @export
 * @interface BrandKitDrdIconDto
 */
export interface BrandKitDrdIconDto {
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'attribute'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'type'?: BrandKitDrdIconDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'iconKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'iconType'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'fill'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDrdIconDto
     */
    'altText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandKitDrdIconDto
     */
    'hidden'?: boolean;
}

export const BrandKitDrdIconDtoTypeEnum = {
    Allergen: 'ALLERGEN',
    Tag: 'TAG'
} as const;

export type BrandKitDrdIconDtoTypeEnum = typeof BrandKitDrdIconDtoTypeEnum[keyof typeof BrandKitDrdIconDtoTypeEnum];

/**
 * 
 * @export
 * @interface BrandKitDto
 */
export interface BrandKitDto {
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BrandKitDto
     */
    'locationIds'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof BrandKitDto
     */
    'assetCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandKitDto
     */
    'templateCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandKitDto
     */
    'firstLogoPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandKitDto
     */
    'default'?: boolean;
}
/**
 * 
 * @export
 * @interface BrandLogoDto
 */
export interface BrandLogoDto {
    /**
     * 
     * @type {string}
     * @memberof BrandLogoDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandLogoDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandLogoDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandLogoDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandLogoDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandLogoDto
     */
    'altText'?: string;
}
/**
 * 
 * @export
 * @interface BrandProFontDto
 */
export interface BrandProFontDto {
    /**
     * 
     * @type {string}
     * @memberof BrandProFontDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandProFontDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandProFontDto
     */
    'brandId'?: string;
}
/**
 * 
 * @export
 * @interface BrandTemplateDto
 */
export interface BrandTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'brandKitId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'productType'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandTemplateDto
     */
    'createdById'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandTemplateDto
     */
    'updatedById'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandTemplateDto
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandTemplateDto
     */
    'height'?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'sizeUnit'?: BrandTemplateDtoSizeUnitEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandTemplateDto
     */
    'lastEditorName'?: string;
}

export const BrandTemplateDtoSizeUnitEnum = {
    In: 'IN',
    Cm: 'CM',
    Mm: 'MM',
    Px: 'PX'
} as const;

export type BrandTemplateDtoSizeUnitEnum = typeof BrandTemplateDtoSizeUnitEnum[keyof typeof BrandTemplateDtoSizeUnitEnum];

/**
 * 
 * @export
 * @interface BrandUploadedFontDto
 */
export interface BrandUploadedFontDto {
    /**
     * 
     * @type {string}
     * @memberof BrandUploadedFontDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandUploadedFontDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandUploadedFontDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandUploadedFontDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandUploadedFontDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BrandUploadedFontDto
     */
    'createdDate'?: string;
}
/**
 * 
 * @export
 * @interface BulkBrandKitItem
 */
export interface BulkBrandKitItem {
    /**
     * 
     * @type {string}
     * @memberof BulkBrandKitItem
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof BulkBrandKitItem
     */
    'locationId'?: number;
}
/**
 * 
 * @export
 * @interface BulkBrandKitRequest
 */
export interface BulkBrandKitRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkBrandKitRequest
     */
    'teamId'?: string;
    /**
     * 
     * @type {Array<BulkBrandKitItem>}
     * @memberof BulkBrandKitRequest
     */
    'items'?: Array<BulkBrandKitItem>;
}
/**
 * 
 * @export
 * @interface BulkInviteDto
 */
export interface BulkInviteDto {
    /**
     * 
     * @type {string}
     * @memberof BulkInviteDto
     */
    'ownerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkInviteDto
     */
    'role'?: string;
    /**
     * 
     * @type {Array<BulkInviteRowDto>}
     * @memberof BulkInviteDto
     */
    'rows'?: Array<BulkInviteRowDto>;
}
/**
 * 
 * @export
 * @interface BulkInviteEmailIssueDto
 */
export interface BulkInviteEmailIssueDto {
    /**
     * 
     * @type {string}
     * @memberof BulkInviteEmailIssueDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkInviteEmailIssueDto
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface BulkInviteResultDto
 */
export interface BulkInviteResultDto {
    /**
     * 
     * @type {number}
     * @memberof BulkInviteResultDto
     */
    'sent'?: number;
    /**
     * 
     * @type {Array<BulkInviteSkippedRowDto>}
     * @memberof BulkInviteResultDto
     */
    'skipped'?: Array<BulkInviteSkippedRowDto>;
}
/**
 * 
 * @export
 * @interface BulkInviteRowDto
 */
export interface BulkInviteRowDto {
    /**
     * 
     * @type {string}
     * @memberof BulkInviteRowDto
     */
    'email'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkInviteRowDto
     */
    'locations'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkInviteRowDto
     */
    'preset'?: string;
}
/**
 * 
 * @export
 * @interface BulkInviteSkippedRowDto
 */
export interface BulkInviteSkippedRowDto {
    /**
     * 
     * @type {string}
     * @memberof BulkInviteSkippedRowDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkInviteSkippedRowDto
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface BulkInviteValidateDto
 */
export interface BulkInviteValidateDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkInviteValidateDto
     */
    'emails'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BulkUploadResultDto
 */
export interface BulkUploadResultDto {
    /**
     * 
     * @type {Array<FileUploadResult>}
     * @memberof BulkUploadResultDto
     */
    'results'?: Array<FileUploadResult>;
    /**
     * 
     * @type {number}
     * @memberof BulkUploadResultDto
     */
    'totalFiles'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUploadResultDto
     */
    'successCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BulkUploadResultDto
     */
    'failureCount'?: number;
}
/**
 * 
 * @export
 * @interface CardDto
 */
export interface CardDto {
    /**
     * 
     * @type {string}
     * @memberof CardDto
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDto
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDto
     */
    'cvv'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDto
     */
    'year'?: string;
    /**
     * 
     * @type {string}
     * @memberof CardDto
     */
    'month'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CardDto
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * 
     * @type {number}
     * @memberof CategoryDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryDto
     */
    'visible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CategoryDto
     */
    'parentId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ChangeFolderRequest
 */
export interface ChangeFolderRequest {
    /**
     * 
     * @type {number}
     * @memberof ChangeFolderRequest
     */
    'folderId'?: number;
}
/**
 * 
 * @export
 * @interface ChangeLocationRequest
 */
export interface ChangeLocationRequest {
    /**
     * 
     * @type {number}
     * @memberof ChangeLocationRequest
     */
    'locationId'?: number;
}
/**
 * 
 * @export
 * @interface CopyDesignRequest
 */
export interface CopyDesignRequest {
    /**
     * 
     * @type {string}
     * @memberof CopyDesignRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CreateUserWithLocationPermissions
 */
export interface CreateUserWithLocationPermissions {
    /**
     * 
     * @type {string}
     * @memberof CreateUserWithLocationPermissions
     */
    'ownerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserWithLocationPermissions
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserWithLocationPermissions
     */
    'role'?: string;
    /**
     * 
     * @type {{ [key: string]: UserLocationPermission; }}
     * @memberof CreateUserWithLocationPermissions
     */
    'locations'?: { [key: string]: UserLocationPermission; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserWithLocationPermissions
     */
    'activate'?: boolean;
}
/**
 * 
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
    /**
     * 
     * @type {MemberDto}
     * @memberof DashboardDto
     */
    'member'?: MemberDto;
    /**
     * 
     * @type {Array<LocationDto>}
     * @memberof DashboardDto
     */
    'locations'?: Array<LocationDto>;
    /**
     * 
     * @type {string}
     * @memberof DashboardDto
     */
    'oldLoginKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'pos'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardDto
     */
    'toastEmail'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'square'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'treez'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'popmenu'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'dsaBeta'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DashboardDto
     */
    'stripePlanType'?: DashboardDtoStripePlanTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardDto
     */
    'enterpriseDisplayAccount'?: boolean;
}

export const DashboardDtoStripePlanTypeEnum = {
    Free: 'FREE',
    Pro: 'PRO',
    Design: 'DESIGN',
    ProDrd: 'PRO_DRD',
    DesignDrd: 'DESIGN_DRD'
} as const;

export type DashboardDtoStripePlanTypeEnum = typeof DashboardDtoStripePlanTypeEnum[keyof typeof DashboardDtoStripePlanTypeEnum];

/**
 * 
 * @export
 * @interface DesignDisplayStatusDto
 */
export interface DesignDisplayStatusDto {
    /**
     * 
     * @type {number}
     * @memberof DesignDisplayStatusDto
     */
    'assignedScreens'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignDisplayStatusDto
     */
    'liveScreens'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignDisplayStatusDto
     */
    'status'?: string;
    /**
     * 
     * @type {Array<DesignScreenStatusDto>}
     * @memberof DesignDisplayStatusDto
     */
    'screens'?: Array<DesignScreenStatusDto>;
    /**
     * 
     * @type {string}
     * @memberof DesignDisplayStatusDto
     */
    'publishedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignDisplayStatusDto
     */
    'scheduledScreens'?: number;
}
/**
 * 
 * @export
 * @interface DesignDto
 */
export interface DesignDto {
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'thumb'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'folders'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'visible'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'width'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'height'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'unit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'locked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'upload'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DesignDto
     */
    'pageCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'inUse'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignDto
     */
    'inUseMemberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DesignDto
     */
    'inUseLastPingAt'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'compressed'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'creatorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'toastItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'toastSections'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasToastItems'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'squareItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'squareSections'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasSquareItems'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'treezItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'treezSections'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasTreezItems'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'popmenuItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'popmenuSections'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasPopmenuItems'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'itemlibraryItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'itemlibrarySections'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasItemlibraryItems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'free'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasVideo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DesignDto
     */
    'posUpdatedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'posUpdatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'dsaUpdatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'linksUpdatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'hasItemLibraryItems'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'ilUpdatedEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DesignDto
     */
    'sharedInListings'?: boolean;
}
/**
 * 
 * @export
 * @interface DesignScreenStatusDto
 */
export interface DesignScreenStatusDto {
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'serial'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'thumbnailDesignId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DesignScreenStatusDto
     */
    'thumbnailPage'?: number;
    /**
     * 
     * @type {string}
     * @memberof DesignScreenStatusDto
     */
    'thumbnailUrl'?: string;
}
/**
 * 
 * @export
 * @interface DeviceQueryDto
 */
export interface DeviceQueryDto {
    /**
     * 
     * @type {string}
     * @memberof DeviceQueryDto
     */
    'deviceKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceQueryDto
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceQueryDto
     */
    'serial'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceQueryDto
     */
    'optionalData'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DevicesQueryDto
 */
export interface DevicesQueryDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DevicesQueryDto
     */
    'deviceKeys'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevicesQueryDto
     */
    'deviceIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevicesQueryDto
     */
    'serials'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevicesQueryDto
     */
    'labelIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DiningRDCommunityDto
 */
export interface DiningRDCommunityDto {
    /**
     * 
     * @type {number}
     * @memberof DiningRDCommunityDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiningRDCommunityDto
     */
    'name'?: string;
    /**
     * 
     * @type {DiningRDCorporationDto}
     * @memberof DiningRDCommunityDto
     */
    'corporation'?: DiningRDCorporationDto;
    /**
     * 
     * @type {Set<DiningRDContactDto>}
     * @memberof DiningRDCommunityDto
     */
    'contacts'?: Set<DiningRDContactDto>;
    /**
     * 
     * @type {number}
     * @memberof DiningRDCommunityDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiningRDCommunityDto
     */
    'locationId'?: number;
}
/**
 * 
 * @export
 * @interface DiningRDContactDto
 */
export interface DiningRDContactDto {
    /**
     * 
     * @type {number}
     * @memberof DiningRDContactDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiningRDContactDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiningRDContactDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface DiningRDCorporationDto
 */
export interface DiningRDCorporationDto {
    /**
     * 
     * @type {number}
     * @memberof DiningRDCorporationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiningRDCorporationDto
     */
    'name'?: string;
    /**
     * 
     * @type {Set<DiningRDCommunityDto>}
     * @memberof DiningRDCorporationDto
     */
    'communities'?: Set<DiningRDCommunityDto>;
}
/**
 * 
 * @export
 * @interface DownloadedItemDto
 */
export interface DownloadedItemDto {
    /**
     * 
     * @type {string}
     * @memberof DownloadedItemDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadedItemDto
     */
    'base64'?: string;
}
/**
 * 
 * @export
 * @interface DsaBoardDto
 */
export interface DsaBoardDto {
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'type'?: DsaBoardDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'designId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaBoardDto
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaBoardDto
     */
    'version'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaBoardDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaBoardDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaBoardDto
     */
    'uploadId'?: string;
}

export const DsaBoardDtoTypeEnum = {
    Design: 'DESIGN',
    Upload: 'UPLOAD'
} as const;

export type DsaBoardDtoTypeEnum = typeof DsaBoardDtoTypeEnum[keyof typeof DsaBoardDtoTypeEnum];

/**
 * 
 * @export
 * @interface DsaContentDto
 */
export interface DsaContentDto {
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'type'?: DsaContentDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'sourceId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaContentDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaContentDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'serial'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaContentDto
     */
    'playable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaContentDto
     */
    'updatedDate'?: string;
}

export const DsaContentDtoTypeEnum = {
    Board: 'BOARD',
    Playlist: 'PLAYLIST',
    Schedule: 'SCHEDULE'
} as const;

export type DsaContentDtoTypeEnum = typeof DsaContentDtoTypeEnum[keyof typeof DsaContentDtoTypeEnum];

/**
 * 
 * @export
 * @interface DsaDeleteScheduleEventDto
 */
export interface DsaDeleteScheduleEventDto {
    /**
     * 
     * @type {string}
     * @memberof DsaDeleteScheduleEventDto
     */
    'scheduleId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaDeleteScheduleEventDto
     */
    'eventId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaDeleteScheduleEventDto
     */
    'updatedByName'?: string;
}
/**
 * 
 * @export
 * @interface DsaPlaylistDto
 */
export interface DsaPlaylistDto {
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistDto
     */
    'version'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {Array<DsaPlaylistEntryDto>}
     * @memberof DsaPlaylistDto
     */
    'entries'?: Array<DsaPlaylistEntryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof DsaPlaylistDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaPlaylistDto
     */
    'locked'?: boolean;
}
/**
 * 
 * @export
 * @interface DsaPlaylistEntryDto
 */
export interface DsaPlaylistEntryDto {
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistEntryDto
     */
    'sequence'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'type'?: DsaPlaylistEntryDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'designId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistEntryDto
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'transition'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaPlaylistEntryDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DsaPlaylistEntryDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaPlaylistEntryDto
     */
    'uploadId'?: string;
}

export const DsaPlaylistEntryDtoTypeEnum = {
    Design: 'DESIGN',
    Upload: 'UPLOAD'
} as const;

export type DsaPlaylistEntryDtoTypeEnum = typeof DsaPlaylistEntryDtoTypeEnum[keyof typeof DsaPlaylistEntryDtoTypeEnum];

/**
 * 
 * @export
 * @interface DsaScheduleDto
 */
export interface DsaScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScheduleDto
     */
    'allDay'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScheduleDto
     */
    'locked'?: boolean;
    /**
     * 
     * @type {Array<DsaScheduleEventDto>}
     * @memberof DsaScheduleDto
     */
    'events'?: Array<DsaScheduleEventDto>;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'createdByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'updatedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleDto
     */
    'updatedDate'?: string;
}
/**
 * 
 * @export
 * @interface DsaScheduleEventDto
 */
export interface DsaScheduleEventDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleEventDto
     */
    'startDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleEventDto
     */
    'endDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'endTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScheduleEventDto
     */
    'allDay'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'repeat'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'rrule'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'contentMeta'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'contentDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'contentTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScheduleEventDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleEventDto
     */
    'updatedByName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScheduleEventDto
     */
    'timezoneAgnostic'?: boolean;
}
/**
 * 
 * @export
 * @interface DsaScheduleRenameDto
 */
export interface DsaScheduleRenameDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRenameDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRenameDto
     */
    'newName'?: string;
}
/**
 * 
 * @export
 * @interface DsaScheduleRotationDto
 */
export interface DsaScheduleRotationDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRotationDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRotationDto
     */
    'scheduleId'?: string;
    /**
     * 
     * @type {Array<DsaScheduleRotationEventDto>}
     * @memberof DsaScheduleRotationDto
     */
    'events'?: Array<DsaScheduleRotationEventDto>;
    /**
     * 
     * @type {DsaScheduleRotationEventDto}
     * @memberof DsaScheduleRotationDto
     */
    'currentRotationEvent'?: DsaScheduleRotationEventDto;
}
/**
 * 
 * @export
 * @interface DsaScheduleRotationEventDto
 */
export interface DsaScheduleRotationEventDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRotationEventDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScheduleRotationEventDto
     */
    'scheduleEventId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleRotationEventDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaScheduleRotationEventDto
     */
    'sequence'?: number;
}
/**
 * 
 * @export
 * @interface DsaScreenAddDto
 */
export interface DsaScreenAddDto {
    /**
     * 
     * @type {number}
     * @memberof DsaScreenAddDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenAddDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenAddDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenAddDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenAddDto
     */
    'placement'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenAddDto
     */
    'timezone'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenAddDto
     */
    'rotation'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenAddDto
     */
    'restartDay'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenAddDto
     */
    'restartTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScreenAddDto
     */
    'scheduledReboot'?: boolean;
    /**
     * 
     * @type {DeviceQueryDto}
     * @memberof DsaScreenAddDto
     */
    'deviceQueryDto'?: DeviceQueryDto;
}
/**
 * 
 * @export
 * @interface DsaScreenDto
 */
export interface DsaScreenDto {
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'serial'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'deviceKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'placement'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenDto
     */
    'restartDay'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'restartTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScreenDto
     */
    'scheduledReboot'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenDto
     */
    'rotation'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScreenDto
     */
    'online'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'lastOnline'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'createdOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'network'?: string;
    /**
     * 
     * @type {DsaContentDto}
     * @memberof DsaScreenDto
     */
    'content'?: DsaContentDto;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScreenDto
     */
    'locked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DsaScreenDto
     */
    'wifiSsid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DsaScreenDto
     */
    'hdmiConnected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DsaScreenDto
     */
    'wifiSignal'?: number;
}
/**
 * 
 * @export
 * @interface DsaUploadFolderAssignmentDto
 */
export interface DsaUploadFolderAssignmentDto {
    /**
     * 
     * @type {number}
     * @memberof DsaUploadFolderAssignmentDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaUploadFolderAssignmentDto
     */
    'folderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderAssignmentDto
     */
    'uploadId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderAssignmentDto
     */
    'createDate'?: string;
}
/**
 * 
 * @export
 * @interface DsaUploadFolderDto
 */
export interface DsaUploadFolderDto {
    /**
     * 
     * @type {number}
     * @memberof DsaUploadFolderDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DsaUploadFolderDto
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof DsaUploadFolderDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderDto
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof DsaUploadFolderDto
     */
    'parentId'?: string;
}
/**
 * 
 * @export
 * @interface FileUploadResult
 */
export interface FileUploadResult {
    /**
     * 
     * @type {string}
     * @memberof FileUploadResult
     */
    'fileName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileUploadResult
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileUploadResult
     */
    'error'?: string;
    /**
     * 
     * @type {AssetDto}
     * @memberof FileUploadResult
     */
    'asset'?: AssetDto;
}
/**
 * 
 * @export
 * @interface FullBillingDto
 */
export interface FullBillingDto {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof FullBillingDto
     */
    'address'?: BillingAddressDto;
    /**
     * 
     * @type {UpdateCardDto}
     * @memberof FullBillingDto
     */
    'card'?: UpdateCardDto;
}
/**
 * 
 * @export
 * @interface GeneratePasswordRequest
 */
export interface GeneratePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof GeneratePasswordRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface InitDto
 */
export interface InitDto {
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitDto
     */
    'owner'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InitDto
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitDto
     */
    'logged'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'plan'?: InitDtoPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'memberStatus'?: InitDtoMemberStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof InitDto
     */
    'name'?: string;
}

export const InitDtoPlanEnum = {
    Premium: 'PREMIUM',
    OnHold: 'ON_HOLD',
    Cancelled: 'CANCELLED',
    Declined: 'DECLINED',
    Free: 'FREE',
    Paused: 'PAUSED',
    PastDue: 'PAST_DUE',
    Removed: 'REMOVED'
} as const;

export type InitDtoPlanEnum = typeof InitDtoPlanEnum[keyof typeof InitDtoPlanEnum];
export const InitDtoMemberStatusEnum = {
    Active: 'Active',
    Hold: 'Hold',
    Cancelled: 'Cancelled',
    Declined: 'Declined',
    Freemium: 'Freemium',
    Paused: 'Paused',
    PastDue: 'PastDue',
    Removed: 'Removed'
} as const;

export type InitDtoMemberStatusEnum = typeof InitDtoMemberStatusEnum[keyof typeof InitDtoMemberStatusEnum];

/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {Array<any>}
     * @memberof InlineObject
     */
    'images': Array<any>;
}
/**
 * 
 * @export
 * @interface IntercomDataDto
 */
export interface IntercomDataDto {
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'planName'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'planStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'planTerm'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'customerLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'lastLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'renewing'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyBusinessType'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyUsageContactlessMenu'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyUsageOnlineAccess'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyUsageSimpleWebsite'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyUsageTraditionalMenu'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'surveyUsageMarketing'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'expireDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'loginCount'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'lastPrintOrder'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntercomDataDto
     */
    'hasDisplay'?: number;
    /**
     * 
     * @type {number}
     * @memberof IntercomDataDto
     */
    'hasLocations'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'pos'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntercomDataDto
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface InviteUserDto
 */
export interface InviteUserDto {
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'role'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserDto
     */
    'locations'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InviteUserDto
     */
    'ownerId'?: string;
}
/**
 * 
 * @export
 * @interface LightCardDto
 */
export interface LightCardDto {
    /**
     * 
     * @type {string}
     * @memberof LightCardDto
     */
    'ending'?: string;
    /**
     * 
     * @type {number}
     * @memberof LightCardDto
     */
    'exprMonth'?: number;
    /**
     * 
     * @type {number}
     * @memberof LightCardDto
     */
    'exprYear'?: number;
    /**
     * 
     * @type {string}
     * @memberof LightCardDto
     */
    'zip'?: string;
}
/**
 * 
 * @export
 * @interface LocationBrandPreviewDto
 */
export interface LocationBrandPreviewDto {
    /**
     * 
     * @type {BrandColorDto}
     * @memberof LocationBrandPreviewDto
     */
    'color'?: BrandColorDto;
    /**
     * 
     * @type {BrandLogoDto}
     * @memberof LocationBrandPreviewDto
     */
    'logo'?: BrandLogoDto;
}
/**
 * 
 * @export
 * @interface LocationDto
 */
export interface LocationDto {
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'facebook'?: string;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'restaurantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'brandId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'type'?: LocationDtoTypeEnum;
    /**
     * 
     * @type {Array<MemberDto>}
     * @memberof LocationDto
     */
    'managers'?: Array<MemberDto>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDto
     */
    'removed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'designCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'qrCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'lpCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'omCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDto
     */
    'primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDto
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'managersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LocationDto
     */
    'availableScreens'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDto
     */
    'drdAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDto
     */
    'hasBrandTemplates'?: boolean;
}

export const LocationDtoTypeEnum = {
    Restaurant: 'Restaurant',
    Spa: 'Spa',
    Dispensary: 'Dispensary',
    Designer: 'Designer',
    Other: 'Other'
} as const;

export type LocationDtoTypeEnum = typeof LocationDtoTypeEnum[keyof typeof LocationDtoTypeEnum];

/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'token'?: string;
    /**
     * 
     * @type {number}
     * @memberof LoginResponse
     */
    'mid'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoginResponse
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof LoginResponse
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResponse
     */
    'error'?: boolean;
}
/**
 * 
 * @export
 * @interface MemberDto
 */
export interface MemberDto {
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberDto
     */
    'internalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberDto
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof MemberDto
     */
    'accountStatus'?: number;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'teamId'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberDto
     */
    'ownerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'plan'?: MemberDtoPlanEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'logged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'changePassword'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberDto
     */
    'numLogins'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'subscriptionInvoicing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'diningRDIntegration'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'diningRDAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'enterpriseDisplayAccount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'printInvoicing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'downloads'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'templates'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'printing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'itemLibraryOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'dataOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberDto
     */
    'showItemLibrary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'partner'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberDto
     */
    'role'?: MemberDtoRoleEnum;
    /**
     * 
     * @type {{ [key: string]: PermissionsDto; }}
     * @memberof MemberDto
     */
    'permissions'?: { [key: string]: PermissionsDto; };
}

export const MemberDtoPlanEnum = {
    Premium: 'PREMIUM',
    OnHold: 'ON_HOLD',
    Cancelled: 'CANCELLED',
    Declined: 'DECLINED',
    Free: 'FREE',
    Paused: 'PAUSED',
    PastDue: 'PAST_DUE',
    Removed: 'REMOVED'
} as const;

export type MemberDtoPlanEnum = typeof MemberDtoPlanEnum[keyof typeof MemberDtoPlanEnum];
export const MemberDtoRoleEnum = {
    User: 'User',
    Owner: 'Owner',
    Admin: 'Admin'
} as const;

export type MemberDtoRoleEnum = typeof MemberDtoRoleEnum[keyof typeof MemberDtoRoleEnum];

/**
 * 
 * @export
 * @interface MemberImageDto
 */
export interface MemberImageDto {
    /**
     * 
     * @type {string}
     * @memberof MemberImageDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberImageDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberImageDto
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberImageDto
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberImageDto
     */
    'altText'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MemberImageDto
     */
    'mp4'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberImageDto
     */
    'webM'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberImageDto
     */
    'gif'?: boolean;
}
/**
 * 
 * @export
 * @interface MemberLocationPermissionDto
 */
export interface MemberLocationPermissionDto {
    /**
     * 
     * @type {string}
     * @memberof MemberLocationPermissionDto
     */
    'ownerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberLocationPermissionDto
     */
    'memberId'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberLocationPermissionDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'itemLibraryOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'dataOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'downloadAndPublish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'publish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'createTemplate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'updateDrd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'orderPrint'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberLocationPermissionDto
     */
    'manageBrand'?: boolean;
}
/**
 * 
 * @export
 * @interface MemberWebsiteUrlDto
 */
export interface MemberWebsiteUrlDto {
    /**
     * 
     * @type {string}
     * @memberof MemberWebsiteUrlDto
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface MenuFolderDto
 */
export interface MenuFolderDto {
    /**
     * 
     * @type {number}
     * @memberof MenuFolderDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuFolderDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuFolderDto
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuFolderDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {number}
     * @memberof MenuFolderDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuFolderDto
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuFolderDto
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuFolderDto
     */
    'parentId'?: string;
}
/**
 * 
 * @export
 * @interface PastDueStatusDto
 */
export interface PastDueStatusDto {
    /**
     * 
     * @type {string}
     * @memberof PastDueStatusDto
     */
    'invoice'?: string;
}
/**
 * 
 * @export
 * @interface PaymentDetailsDto
 */
export interface PaymentDetailsDto {
    /**
     * 
     * @type {BillingAddressDto}
     * @memberof PaymentDetailsDto
     */
    'billing'?: BillingAddressDto;
    /**
     * 
     * @type {LightCardDto}
     * @memberof PaymentDetailsDto
     */
    'card'?: LightCardDto;
}
/**
 * 
 * @export
 * @interface PaymentIntentBody
 */
export interface PaymentIntentBody {
    /**
     * 
     * @type {string}
     * @memberof PaymentIntentBody
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentIntentBody
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PermissionPresetDto
 */
export interface PermissionPresetDto {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionPresetDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionPresetDto
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'dataOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'manageDesigns'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'publish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'createTemplates'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionPresetDto
     */
    'orderPrint'?: boolean;
}
/**
 * 
 * @export
 * @interface PermissionsDto
 */
export interface PermissionsDto {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'itemLibraryOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'dataOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'downloadAndPublish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'publish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'createTemplate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'updateDrd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'orderPrint'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionsDto
     */
    'manageBrand'?: boolean;
}
/**
 * 
 * @export
 * @interface PopmenuAuthReqDto
 */
export interface PopmenuAuthReqDto {
    /**
     * 
     * @type {string}
     * @memberof PopmenuAuthReqDto
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof PopmenuAuthReqDto
     */
    'memberId'?: number;
}
/**
 * 
 * @export
 * @interface PopmenuDeltaUpdate
 */
export interface PopmenuDeltaUpdate {
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'menuExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'menuName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'menuDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'sectionExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'sectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'sectionDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemTags'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof PopmenuDeltaUpdate
     */
    'itemPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'affectedResource'?: PopmenuDeltaUpdateAffectedResourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'type'?: PopmenuDeltaUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'status'?: PopmenuDeltaUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'solvedForDesignIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'batchHash'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdate
     */
    'updatedDate'?: string;
}

export const PopmenuDeltaUpdateAffectedResourceEnum = {
    Menu: 'MENU',
    Section: 'SECTION',
    Item: 'ITEM'
} as const;

export type PopmenuDeltaUpdateAffectedResourceEnum = typeof PopmenuDeltaUpdateAffectedResourceEnum[keyof typeof PopmenuDeltaUpdateAffectedResourceEnum];
export const PopmenuDeltaUpdateTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type PopmenuDeltaUpdateTypeEnum = typeof PopmenuDeltaUpdateTypeEnum[keyof typeof PopmenuDeltaUpdateTypeEnum];
export const PopmenuDeltaUpdateStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type PopmenuDeltaUpdateStatusEnum = typeof PopmenuDeltaUpdateStatusEnum[keyof typeof PopmenuDeltaUpdateStatusEnum];

/**
 * 
 * @export
 * @interface PopmenuDeltaUpdateDesignResponse
 */
export interface PopmenuDeltaUpdateDesignResponse {
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdateDesignResponse
     */
    'designId'?: string;
}
/**
 * 
 * @export
 * @interface PopmenuDeltaUpdateResponse
 */
export interface PopmenuDeltaUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdateResponse
     */
    'changeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuDeltaUpdateResponse
     */
    'status'?: PopmenuDeltaUpdateResponseStatusEnum;
}

export const PopmenuDeltaUpdateResponseStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type PopmenuDeltaUpdateResponseStatusEnum = typeof PopmenuDeltaUpdateResponseStatusEnum[keyof typeof PopmenuDeltaUpdateResponseStatusEnum];

/**
 * 
 * @export
 * @interface PopmenuLocationDto
 */
export interface PopmenuLocationDto {
    /**
     * 
     * @type {number}
     * @memberof PopmenuLocationDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'dbId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof PopmenuLocationDto
     */
    'postalCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuLocationDto
     */
    'streetAddress'?: string;
}
/**
 * 
 * @export
 * @interface PopmenuRestaurantDto
 */
export interface PopmenuRestaurantDto {
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'externalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'accessTokenExpiresAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PopmenuRestaurantDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PopmenuRestaurantDto
     */
    'lastWebhookReceivedAt'?: string;
}
/**
 * 
 * @export
 * @interface PriceDto
 */
export interface PriceDto {
    /**
     * 
     * @type {string}
     * @memberof PriceDto
     */
    'type'?: PriceDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PriceDto
     */
    'planType'?: PriceDtoPlanTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PriceDto
     */
    'total'?: number;
}

export const PriceDtoTypeEnum = {
    Monthly: 'MONTHLY',
    Annually: 'ANNUALLY'
} as const;

export type PriceDtoTypeEnum = typeof PriceDtoTypeEnum[keyof typeof PriceDtoTypeEnum];
export const PriceDtoPlanTypeEnum = {
    Pro: 'PRO',
    Design: 'DESIGN'
} as const;

export type PriceDtoPlanTypeEnum = typeof PriceDtoPlanTypeEnum[keyof typeof PriceDtoPlanTypeEnum];

/**
 * 
 * @export
 * @interface PrintDto
 */
export interface PrintDto {
    /**
     * 
     * @type {number}
     * @memberof PrintDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintDto
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintDto
     */
    'finishedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrintDto
     */
    'total'?: number;
    /**
     * 
     * @type {Array<PrintProductDto>}
     * @memberof PrintDto
     */
    'items'?: Array<PrintProductDto>;
    /**
     * 
     * @type {number}
     * @memberof PrintDto
     */
    'itemCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintDto
     */
    'location'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrintDto
     */
    'status'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PrintDto
     */
    'available'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrintDto
     */
    'test'?: boolean;
}
/**
 * 
 * @export
 * @interface PrintProductDto
 */
export interface PrintProductDto {
    /**
     * 
     * @type {number}
     * @memberof PrintProductDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintProductDto
     */
    'documentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintProductDto
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintProductDto
     */
    'pdfId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrintProductDto
     */
    'nextGen'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrintProductDto
     */
    'pdfUploaded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PrintProductDto
     */
    'available'?: boolean;
}
/**
 * 
 * @export
 * @interface PurchaseDto
 */
export interface PurchaseDto {
    /**
     * 
     * @type {number}
     * @memberof PurchaseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDto
     */
    'purchaseDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseDto
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDto
     */
    'transactionId'?: string;
}
/**
 * 
 * @export
 * @interface QuestionnaireAnswerDto
 */
export interface QuestionnaireAnswerDto {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'diffPhone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireAnswerDto
     */
    'smsOptIn'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'businessType'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'omgr'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'pos'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'fsp'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'dss'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireAnswerDto
     */
    'needs'?: string;
}
/**
 * 
 * @export
 * @interface RegMemberDto
 */
export interface RegMemberDto {
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'business'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegMemberDto
     */
    'restaurantType'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegMemberDto
     */
    'numLocations'?: number;
}
/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'first'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'last'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'confirm'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'invitation'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterDto
     */
    'drd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterDto
     */
    'ssoMicrosoft'?: boolean;
}
/**
 * 
 * @export
 * @interface RegisterMemberDto
 */
export interface RegisterMemberDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'first'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'last'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'business'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'referral'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'restaurantType'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterMemberDto
     */
    'numLocations'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'drdCommunity'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterMemberDto
     */
    'drdCorporateGroupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterMemberDto
     */
    'ssoMicrosoft'?: boolean;
}
/**
 * 
 * @export
 * @interface RenameDesignRequest
 */
export interface RenameDesignRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameDesignRequest
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof RenameDesignRequest
     */
    'locationId'?: number;
}
/**
 * 
 * @export
 * @interface RenameFolderRequest
 */
export interface RenameFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof RenameFolderRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ReplaceSquareItemDto
 */
export interface ReplaceSquareItemDto {
    /**
     * 
     * @type {string}
     * @memberof ReplaceSquareItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<SquareItemDto>}
     * @memberof ReplaceSquareItemDto
     */
    'items'?: Array<SquareItemDto>;
}
/**
 * 
 * @export
 * @interface ReplaceToastItemDto
 */
export interface ReplaceToastItemDto {
    /**
     * 
     * @type {string}
     * @memberof ReplaceToastItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<ToastItemDto>}
     * @memberof ReplaceToastItemDto
     */
    'items'?: Array<ToastItemDto>;
}
/**
 * 
 * @export
 * @interface ScheduleDto
 */
export interface ScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof ScheduleDto
     */
    'time'?: string;
}
/**
 * 
 * @export
 * @interface ScreenConfigDto
 */
export interface ScreenConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'adbEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'autoLaunchHome'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'bluetoothEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'brightness'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'density'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'disallowUsb'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'frameBuffer'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'hideNavBar'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'homeApp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'ignoreAccelerometer'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'kiosk'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'kioskApp'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'locationEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'logLevel'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'otaBuildType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'otaChannel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'otaUpdateUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'remoteLogLevel'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'restartDay'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'restartTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'rotation'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'scheduledReboot'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'settingsCheckMins'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenConfigDto
     */
    'timezone'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScreenConfigDto
     */
    'volume'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenConfigDto
     */
    'wifiEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface SendDeviceComandDto
 */
export interface SendDeviceComandDto {
    /**
     * 
     * @type {DevicesQueryDto}
     * @memberof SendDeviceComandDto
     */
    'deviceQuery'?: DevicesQueryDto;
    /**
     * 
     * @type {string}
     * @memberof SendDeviceComandDto
     */
    'command'?: string;
    /**
     * 
     * @type {ScheduleDto}
     * @memberof SendDeviceComandDto
     */
    'schedule'?: ScheduleDto;
}
/**
 * 
 * @export
 * @interface ShippingAddressDto
 */
export interface ShippingAddressDto {
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'addressType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'address2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressDto
     */
    'phone'?: string;
}
/**
 * 
 * @export
 * @interface SquareAuthReqDto
 */
export interface SquareAuthReqDto {
    /**
     * 
     * @type {string}
     * @memberof SquareAuthReqDto
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof SquareAuthReqDto
     */
    'memberId'?: number;
}
/**
 * 
 * @export
 * @interface SquareDeltaUpdate
 */
export interface SquareDeltaUpdate {
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'menuExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'menuName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'menuDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'sectionExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'sectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'sectionDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemImage'?: string;
    /**
     * 
     * @type {number}
     * @memberof SquareDeltaUpdate
     */
    'itemPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'itemAvailableAtLocations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'affectedResource'?: SquareDeltaUpdateAffectedResourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'type'?: SquareDeltaUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'status'?: SquareDeltaUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'solvedForDesignIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'batchHash'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdate
     */
    'updatedDate'?: string;
}

export const SquareDeltaUpdateAffectedResourceEnum = {
    Menu: 'MENU',
    Section: 'SECTION',
    Item: 'ITEM'
} as const;

export type SquareDeltaUpdateAffectedResourceEnum = typeof SquareDeltaUpdateAffectedResourceEnum[keyof typeof SquareDeltaUpdateAffectedResourceEnum];
export const SquareDeltaUpdateTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type SquareDeltaUpdateTypeEnum = typeof SquareDeltaUpdateTypeEnum[keyof typeof SquareDeltaUpdateTypeEnum];
export const SquareDeltaUpdateStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type SquareDeltaUpdateStatusEnum = typeof SquareDeltaUpdateStatusEnum[keyof typeof SquareDeltaUpdateStatusEnum];

/**
 * 
 * @export
 * @interface SquareDeltaUpdateResponse
 */
export interface SquareDeltaUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdateResponse
     */
    'changeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareDeltaUpdateResponse
     */
    'status'?: SquareDeltaUpdateResponseStatusEnum;
}

export const SquareDeltaUpdateResponseStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type SquareDeltaUpdateResponseStatusEnum = typeof SquareDeltaUpdateResponseStatusEnum[keyof typeof SquareDeltaUpdateResponseStatusEnum];

/**
 * 
 * @export
 * @interface SquareItemDto
 */
export interface SquareItemDto {
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'itemAvailableAtLocations'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'changeType'?: SquareItemDtoChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareItemDto
     */
    'sectionExternalId'?: string;
}

export const SquareItemDtoChangeTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type SquareItemDtoChangeTypeEnum = typeof SquareItemDtoChangeTypeEnum[keyof typeof SquareItemDtoChangeTypeEnum];

/**
 * 
 * @export
 * @interface SquareRestaurantDto
 */
export interface SquareRestaurantDto {
    /**
     * 
     * @type {string}
     * @memberof SquareRestaurantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareRestaurantDto
     */
    'merchantId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SquareRestaurantDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SquareRestaurantDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SquareRestaurantDto
     */
    'createdDate'?: string;
}
/**
 * 
 * @export
 * @interface SsoMember
 */
export interface SsoMember {
    /**
     * 
     * @type {string}
     * @memberof SsoMember
     */
    'ssoId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SsoMember
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SsoMember
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof SsoMember
     */
    'lastName'?: string;
    /**
     * 
     * @type {number}
     * @memberof SsoMember
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SsoMember
     */
    'token'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SsoMember
     */
    'linked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SsoMember
     */
    'exists'?: boolean;
}
/**
 * 
 * @export
 * @interface StreamAddress
 */
export interface StreamAddress {
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'addressLine1'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'addressLine2'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamAddress
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface StreamLocation
 */
export interface StreamLocation {
    /**
     * 
     * @type {string}
     * @memberof StreamLocation
     */
    'providerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StreamLocation
     */
    'name'?: string;
    /**
     * 
     * @type {StreamAddress}
     * @memberof StreamLocation
     */
    'address'?: StreamAddress;
}
/**
 * 
 * @export
 * @interface StreamLocationConnection
 */
export interface StreamLocationConnection {
    /**
     * 
     * @type {string}
     * @memberof StreamLocationConnection
     */
    'locationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StreamLocationConnection
     */
    'connected'?: boolean;
}
/**
 * 
 * @export
 * @interface StreamLocations
 */
export interface StreamLocations {
    /**
     * 
     * @type {Array<StreamLocation>}
     * @memberof StreamLocations
     */
    'locations'?: Array<StreamLocation>;
}
/**
 * 
 * @export
 * @interface SubStatusDto
 */
export interface SubStatusDto {
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'plan'?: SubStatusDtoPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'status'?: SubStatusDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'grandTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'grandTotalWithTax'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'dueToday'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'totalTax'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubStatusDto
     */
    'planUpgradeInProgress'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'planCycle'?: SubStatusDtoPlanCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'planEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'nextPlanBillingDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'planTotal'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'pauseStartDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'pauseEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'trialStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'trialEnd'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubStatusDto
     */
    'addonsUpgradeInProgress'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'addonsCycle'?: SubStatusDtoAddonsCycleEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'addonsEndDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'nextAddonsBillingDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'addonsTotal'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubStatusDto
     */
    'addonsPendingChange'?: boolean;
    /**
     * 
     * @type {Array<AddOnDto>}
     * @memberof SubStatusDto
     */
    'addons'?: Array<AddOnDto>;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'paymentProvider'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'subscriptionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'coupon'?: string;
    /**
     * 
     * @type {ThreeDSParams}
     * @memberof SubStatusDto
     */
    'tds'?: ThreeDSParams;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'devicePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'deviceQuantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'shippingCosts'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubStatusDto
     */
    'hasZipError'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'planType'?: SubStatusDtoPlanTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'lastPlanType'?: SubStatusDtoLastPlanTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'stripeResp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'stripeRespWithoutTrial'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubStatusDto
     */
    'prorationRefundAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubStatusDto
     */
    'paymentMethodLast4'?: string;
}

export const SubStatusDtoPlanEnum = {
    Premium: 'PREMIUM',
    OnHold: 'ON_HOLD',
    Cancelled: 'CANCELLED',
    Declined: 'DECLINED',
    Free: 'FREE',
    Paused: 'PAUSED',
    PastDue: 'PAST_DUE',
    Removed: 'REMOVED'
} as const;

export type SubStatusDtoPlanEnum = typeof SubStatusDtoPlanEnum[keyof typeof SubStatusDtoPlanEnum];
export const SubStatusDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive',
    Paused: 'Paused',
    WillPause: 'WillPause',
    Expired: 'Expired',
    Preview: 'Preview'
} as const;

export type SubStatusDtoStatusEnum = typeof SubStatusDtoStatusEnum[keyof typeof SubStatusDtoStatusEnum];
export const SubStatusDtoPlanCycleEnum = {
    No: 'No',
    Daily: 'Daily',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;

export type SubStatusDtoPlanCycleEnum = typeof SubStatusDtoPlanCycleEnum[keyof typeof SubStatusDtoPlanCycleEnum];
export const SubStatusDtoAddonsCycleEnum = {
    No: 'No',
    Daily: 'Daily',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;

export type SubStatusDtoAddonsCycleEnum = typeof SubStatusDtoAddonsCycleEnum[keyof typeof SubStatusDtoAddonsCycleEnum];
export const SubStatusDtoPlanTypeEnum = {
    Pro: 'PRO',
    Design: 'DESIGN'
} as const;

export type SubStatusDtoPlanTypeEnum = typeof SubStatusDtoPlanTypeEnum[keyof typeof SubStatusDtoPlanTypeEnum];
export const SubStatusDtoLastPlanTypeEnum = {
    Pro: 'PRO',
    Design: 'DESIGN'
} as const;

export type SubStatusDtoLastPlanTypeEnum = typeof SubStatusDtoLastPlanTypeEnum[keyof typeof SubStatusDtoLastPlanTypeEnum];

/**
 * 
 * @export
 * @interface TextBlockDto
 */
export interface TextBlockDto {
    /**
     * 
     * @type {number}
     * @memberof TextBlockDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TextBlockDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TextBlockDto
     */
    'details'?: string;
    /**
     * 
     * @type {number}
     * @memberof TextBlockDto
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface ThreeDSParams
 */
export interface ThreeDSParams {
    /**
     * 
     * @type {string}
     * @memberof ThreeDSParams
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThreeDSParams
     */
    'redirectURL'?: string;
}
/**
 * 
 * @export
 * @interface TimberFont
 */
export interface TimberFont {
    /**
     * 
     * @type {string}
     * @memberof TimberFont
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimberFont
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimberFont
     */
    'cls'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TimberFont
     */
    'visible'?: boolean;
}
/**
 * 
 * @export
 * @interface ToastDeltaUpdate
 */
export interface ToastDeltaUpdate {
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'toastRestaurantId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'menuExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'menuName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'menuDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'sectionExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'sectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'sectionDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemTags'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof ToastDeltaUpdate
     */
    'itemPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'affectedResource'?: ToastDeltaUpdateAffectedResourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'type'?: ToastDeltaUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'status'?: ToastDeltaUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'solvedForDesignIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdate
     */
    'updatedDate'?: string;
}

export const ToastDeltaUpdateAffectedResourceEnum = {
    Menu: 'MENU',
    Section: 'SECTION',
    Item: 'ITEM'
} as const;

export type ToastDeltaUpdateAffectedResourceEnum = typeof ToastDeltaUpdateAffectedResourceEnum[keyof typeof ToastDeltaUpdateAffectedResourceEnum];
export const ToastDeltaUpdateTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type ToastDeltaUpdateTypeEnum = typeof ToastDeltaUpdateTypeEnum[keyof typeof ToastDeltaUpdateTypeEnum];
export const ToastDeltaUpdateStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type ToastDeltaUpdateStatusEnum = typeof ToastDeltaUpdateStatusEnum[keyof typeof ToastDeltaUpdateStatusEnum];

/**
 * 
 * @export
 * @interface ToastDeltaUpdateDesignResponse
 */
export interface ToastDeltaUpdateDesignResponse {
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdateDesignResponse
     */
    'designId'?: string;
}
/**
 * 
 * @export
 * @interface ToastDeltaUpdateResponse
 */
export interface ToastDeltaUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdateResponse
     */
    'changeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastDeltaUpdateResponse
     */
    'status'?: ToastDeltaUpdateResponseStatusEnum;
}

export const ToastDeltaUpdateResponseStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type ToastDeltaUpdateResponseStatusEnum = typeof ToastDeltaUpdateResponseStatusEnum[keyof typeof ToastDeltaUpdateResponseStatusEnum];

/**
 * 
 * @export
 * @interface ToastItemDto
 */
export interface ToastItemDto {
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'itemTags'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'price'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'changeType'?: ToastItemDtoChangeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastItemDto
     */
    'sectionExternalId'?: string;
}

export const ToastItemDtoChangeTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type ToastItemDtoChangeTypeEnum = typeof ToastItemDtoChangeTypeEnum[keyof typeof ToastItemDtoChangeTypeEnum];

/**
 * 
 * @export
 * @interface ToastRestaurantDto
 */
export interface ToastRestaurantDto {
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'restaurantGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'managementGroupGuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'restaurantName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'locationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'createdByEmailAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'externalGroupRef'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'externalRestaurantRef'?: string;
    /**
     * 
     * @type {number}
     * @memberof ToastRestaurantDto
     */
    'modifiedDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof ToastRestaurantDto
     */
    'createdDate'?: number;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'isoModifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ToastRestaurantDto
     */
    'isoCreatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ToastRestaurantDto
     */
    'menuLastUpdatedDate'?: number;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof Token
     */
    'expireTime'?: number;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'tokenType'?: string;
}
/**
 * 
 * @export
 * @interface TokenRequestDto
 */
export interface TokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TokenRequestDto
     */
    'grantType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequestDto
     */
    'clientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequestDto
     */
    'clientSecret'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequestDto
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequestDto
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TokenRequestDto
     */
    'valid'?: boolean;
}
/**
 * 
 * @export
 * @interface TransferFilesDto
 */
export interface TransferFilesDto {
    /**
     * 
     * @type {number}
     * @memberof TransferFilesDto
     */
    'fromLocationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransferFilesDto
     */
    'toLocationId'?: number;
}
/**
 * 
 * @export
 * @interface TreezDeltaUpdate
 */
export interface TreezDeltaUpdate {
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'menuId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'menuExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'menuName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'menuDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'sectionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'sectionExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'sectionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'sectionDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemExternalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemTags'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof TreezDeltaUpdate
     */
    'itemPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'itemPriceMultipleJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'affectedResource'?: TreezDeltaUpdateAffectedResourceEnum;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'type'?: TreezDeltaUpdateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'status'?: TreezDeltaUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'solvedForDesignIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'batchHash'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdate
     */
    'updatedDate'?: string;
}

export const TreezDeltaUpdateAffectedResourceEnum = {
    Menu: 'MENU',
    Section: 'SECTION',
    Item: 'ITEM'
} as const;

export type TreezDeltaUpdateAffectedResourceEnum = typeof TreezDeltaUpdateAffectedResourceEnum[keyof typeof TreezDeltaUpdateAffectedResourceEnum];
export const TreezDeltaUpdateTypeEnum = {
    Add: 'ADD',
    Update: 'UPDATE',
    Delete: 'DELETE'
} as const;

export type TreezDeltaUpdateTypeEnum = typeof TreezDeltaUpdateTypeEnum[keyof typeof TreezDeltaUpdateTypeEnum];
export const TreezDeltaUpdateStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type TreezDeltaUpdateStatusEnum = typeof TreezDeltaUpdateStatusEnum[keyof typeof TreezDeltaUpdateStatusEnum];

/**
 * 
 * @export
 * @interface TreezDeltaUpdateDesignResponse
 */
export interface TreezDeltaUpdateDesignResponse {
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdateDesignResponse
     */
    'designId'?: string;
}
/**
 * 
 * @export
 * @interface TreezDeltaUpdateResponse
 */
export interface TreezDeltaUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdateResponse
     */
    'changeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezDeltaUpdateResponse
     */
    'status'?: TreezDeltaUpdateResponseStatusEnum;
}

export const TreezDeltaUpdateResponseStatusEnum = {
    Approved: 'APPROVED',
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
} as const;

export type TreezDeltaUpdateResponseStatusEnum = typeof TreezDeltaUpdateResponseStatusEnum[keyof typeof TreezDeltaUpdateResponseStatusEnum];

/**
 * 
 * @export
 * @interface TreezRestaurantDto
 */
export interface TreezRestaurantDto {
    /**
     * 
     * @type {string}
     * @memberof TreezRestaurantDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezRestaurantDto
     */
    'apiKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezRestaurantDto
     */
    'clientId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TreezRestaurantDto
     */
    'memberId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TreezRestaurantDto
     */
    'dispensaryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TreezRestaurantDto
     */
    'createdDate'?: string;
}
/**
 * 
 * @export
 * @interface UpdateCardDto
 */
export interface UpdateCardDto {
    /**
     * 
     * @type {CardDto}
     * @memberof UpdateCardDto
     */
    'card'?: CardDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCardDto
     */
    'ip'?: string;
}
/**
 * 
 * @export
 * @interface UpdateMemberDto
 */
export interface UpdateMemberDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberDto
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberDto
     */
    'currentPassword'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberDto
     */
    'hasToastInterest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMemberDto
     */
    'hasCsCallInterest'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateMemberRoleBody
 */
export interface UpdateMemberRoleBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberRoleBody
     */
    'role'?: UpdateMemberRoleBodyRoleEnum;
}

export const UpdateMemberRoleBodyRoleEnum = {
    User: 'User',
    Owner: 'Owner',
    Admin: 'Admin'
} as const;

export type UpdateMemberRoleBodyRoleEnum = typeof UpdateMemberRoleBodyRoleEnum[keyof typeof UpdateMemberRoleBodyRoleEnum];

/**
 * 
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface UpgradeSubscriptionDto
 */
export interface UpgradeSubscriptionDto {
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'cycle'?: UpgradeSubscriptionDtoCycleEnum;
    /**
     * 
     * @type {CardDto}
     * @memberof UpgradeSubscriptionDto
     */
    'card'?: CardDto;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeSubscriptionDto
     */
    'preview'?: boolean;
    /**
     * 
     * @type {Array<AccountLocationDto>}
     * @memberof UpgradeSubscriptionDto
     */
    'locations'?: Array<AccountLocationDto>;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpgradeSubscriptionDto
     */
    'trialDays'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeSubscriptionDto
     */
    'compPlan'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'coupon'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpgradeSubscriptionDto
     */
    'dsaAddons'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpgradeSubscriptionDto
     */
    'dsaDevices'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpgradeSubscriptionDto
     */
    'listingsAddons'?: number;
    /**
     * 
     * @type {ShippingAddressDto}
     * @memberof UpgradeSubscriptionDto
     */
    'shippingAddress'?: ShippingAddressDto;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'profitCenter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'shamrockCustomerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'partnerLocation'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'partnerUsers'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'switchType'?: UpgradeSubscriptionDtoSwitchTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpgradeSubscriptionDto
     */
    'planType'?: UpgradeSubscriptionDtoPlanTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpgradeSubscriptionDto
     */
    'locationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpgradeSubscriptionDto
     */
    'switchFlow'?: boolean;
}

export const UpgradeSubscriptionDtoCycleEnum = {
    No: 'No',
    Daily: 'Daily',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;

export type UpgradeSubscriptionDtoCycleEnum = typeof UpgradeSubscriptionDtoCycleEnum[keyof typeof UpgradeSubscriptionDtoCycleEnum];
export const UpgradeSubscriptionDtoSwitchTypeEnum = {
    Annual: 'ANNUAL',
    Monthly: 'MONTHLY',
    Pro: 'PRO',
    Design: 'DESIGN'
} as const;

export type UpgradeSubscriptionDtoSwitchTypeEnum = typeof UpgradeSubscriptionDtoSwitchTypeEnum[keyof typeof UpgradeSubscriptionDtoSwitchTypeEnum];
export const UpgradeSubscriptionDtoPlanTypeEnum = {
    Pro: 'PRO',
    Design: 'DESIGN'
} as const;

export type UpgradeSubscriptionDtoPlanTypeEnum = typeof UpgradeSubscriptionDtoPlanTypeEnum[keyof typeof UpgradeSubscriptionDtoPlanTypeEnum];

/**
 * 
 * @export
 * @interface UserDetailsDto
 */
export interface UserDetailsDto {
    /**
     * 
     * @type {AccountMemberDto}
     * @memberof UserDetailsDto
     */
    'owner'?: AccountMemberDto;
    /**
     * 
     * @type {Array<AccountMemberDto>}
     * @memberof UserDetailsDto
     */
    'users'?: Array<AccountMemberDto>;
    /**
     * 
     * @type {number}
     * @memberof UserDetailsDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface UserLocationPermission
 */
export interface UserLocationPermission {
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'viewOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'itemLibraryOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'dataOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'downloadPublish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'publish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'createTemplate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'updateDrd'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'orderPrint'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLocationPermission
     */
    'manageBrand'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserLocationPermission
     */
    'locationId'?: number;
}
/**
 * 
 * @export
 * @interface YextCategoryDto
 */
export interface YextCategoryDto {
    /**
     * 
     * @type {string}
     * @memberof YextCategoryDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextCategoryDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextCategoryDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof YextCategoryDto
     */
    'selectable'?: boolean;
}
/**
 * 
 * @export
 * @interface YextHolidayRuleDto
 */
export interface YextHolidayRuleDto {
    /**
     * 
     * @type {string}
     * @memberof YextHolidayRuleDto
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextHolidayRuleDto
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextHolidayRuleDto
     */
    'group'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextHolidayRuleDto
     */
    'mode'?: string;
    /**
     * 
     * @type {number}
     * @memberof YextHolidayRuleDto
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextHolidayRuleDto
     */
    'end'?: number;
}
/**
 * 
 * @export
 * @interface YextListingDto
 */
export interface YextListingDto {
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'publisherId'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'publisherName'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'rawStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'listingUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingDto
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface YextListingPhotoDto
 */
export interface YextListingPhotoDto {
    /**
     * 
     * @type {number}
     * @memberof YextListingPhotoDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoDto
     */
    'slot'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoDto
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoDto
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoDto
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoDto
     */
    'altText'?: string;
}
/**
 * 
 * @export
 * @interface YextListingPhotoRequest
 */
export interface YextListingPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoRequest
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoRequest
     */
    'imageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoRequest
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingPhotoRequest
     */
    'altText'?: string;
}
/**
 * 
 * @export
 * @interface YextListingsAccessDto
 */
export interface YextListingsAccessDto {
    /**
     * 
     * @type {boolean}
     * @memberof YextListingsAccessDto
     */
    'allowed'?: boolean;
}
/**
 * 
 * @export
 * @interface YextListingsViewDto
 */
export interface YextListingsViewDto {
    /**
     * 
     * @type {string}
     * @memberof YextListingsViewDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingsViewDto
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextListingsViewDto
     */
    'phone'?: string;
    /**
     * 
     * @type {Array<YextListingDto>}
     * @memberof YextListingsViewDto
     */
    'listings'?: Array<YextListingDto>;
}
/**
 * 
 * @export
 * @interface YextMenuTileDto
 */
export interface YextMenuTileDto {
    /**
     * 
     * @type {number}
     * @memberof YextMenuTileDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileDto
     */
    'designId'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileDto
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileDto
     */
    'publishedDate'?: string;
}
/**
 * 
 * @export
 * @interface YextMenuTileRequest
 */
export interface YextMenuTileRequest {
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileRequest
     */
    'designId'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextMenuTileRequest
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface YextProfileAmenities
 */
export interface YextProfileAmenities {
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'cuisineTypes'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'serviceOptions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'takeout'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'delivery'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'wheelchairAccessible'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'paymentAccepted'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'reservationSupport'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'orderingLinks'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'priceRange'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'alcoholServed'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'outdoorSeating'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'wifiAvailable'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'parking'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'accessibility'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'familyFriendly'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileAmenities
     */
    'languages'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileAmenities
     */
    'blackOwned'?: string;
}
/**
 * 
 * @export
 * @interface YextProfileDayHours
 */
export interface YextProfileDayHours {
    /**
     * 
     * @type {boolean}
     * @memberof YextProfileDayHours
     */
    'open'?: boolean;
    /**
     * 
     * @type {Array<YextProfileTimeRange>}
     * @memberof YextProfileDayHours
     */
    'ranges'?: Array<YextProfileTimeRange>;
}
/**
 * 
 * @export
 * @interface YextProfileDto
 */
export interface YextProfileDto {
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'businessName'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'alternateNames'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileDto
     */
    'category'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'street2'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof YextProfileDto
     */
    'suppressAddress'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'displayAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'latitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'longitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'primaryPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'secondaryPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'websiteDisplayUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'descriptionShort'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'descriptionLong'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'featuredMessage'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileDto
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof YextProfileDto
     */
    'openingDate'?: string;
    /**
     * 
     * @type {Array<YextStaffBio>}
     * @memberof YextProfileDto
     */
    'staffBios'?: Array<YextStaffBio>;
    /**
     * 
     * @type {YextProfileHours}
     * @memberof YextProfileDto
     */
    'hours'?: YextProfileHours;
    /**
     * 
     * @type {Array<YextHolidayRuleDto>}
     * @memberof YextProfileDto
     */
    'holidayHours'?: Array<YextHolidayRuleDto>;
    /**
     * 
     * @type {YextTemporaryClosureDto}
     * @memberof YextProfileDto
     */
    'temporaryClosure'?: YextTemporaryClosureDto;
    /**
     * 
     * @type {YextProfileLinks}
     * @memberof YextProfileDto
     */
    'links'?: YextProfileLinks;
    /**
     * 
     * @type {YextProfileAmenities}
     * @memberof YextProfileDto
     */
    'amenities'?: YextProfileAmenities;
    /**
     * 
     * @type {YextProfileVisualAssets}
     * @memberof YextProfileDto
     */
    'visualAssets'?: YextProfileVisualAssets;
    /**
     * 
     * @type {boolean}
     * @memberof YextProfileDto
     */
    'existing'?: boolean;
}
/**
 * 
 * @export
 * @interface YextProfileHours
 */
export interface YextProfileHours {
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'mon'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'tue'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'wed'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'thu'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'fri'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'sat'?: YextProfileDayHours;
    /**
     * 
     * @type {YextProfileDayHours}
     * @memberof YextProfileHours
     */
    'sun'?: YextProfileDayHours;
}
/**
 * 
 * @export
 * @interface YextProfileLinks
 */
export interface YextProfileLinks {
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileLinks
     */
    'onlineOrdering'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileLinks
     */
    'delivery'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileLinks
     */
    'reservations'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileLinks
     */
    'menu'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof YextProfileLinks
     */
    'social'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileLinks
     */
    'giftCard'?: Array<string>;
}
/**
 * 
 * @export
 * @interface YextProfileTimeRange
 */
export interface YextProfileTimeRange {
    /**
     * 
     * @type {number}
     * @memberof YextProfileTimeRange
     */
    'start'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextProfileTimeRange
     */
    'end'?: number;
}
/**
 * 
 * @export
 * @interface YextProfileVisualAssets
 */
export interface YextProfileVisualAssets {
    /**
     * 
     * @type {string}
     * @memberof YextProfileVisualAssets
     */
    'logo'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof YextProfileVisualAssets
     */
    'photoGallery'?: Array<string>;
}
/**
 * 
 * @export
 * @interface YextPublishResultDto
 */
export interface YextPublishResultDto {
    /**
     * 
     * @type {number}
     * @memberof YextPublishResultDto
     */
    'publisherCount'?: number;
}
/**
 * 
 * @export
 * @interface YextPublisherStat
 */
export interface YextPublisherStat {
    /**
     * 
     * @type {string}
     * @memberof YextPublisherStat
     */
    'publisher'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextPublisherStat
     */
    'primaryLabel'?: string;
    /**
     * 
     * @type {number}
     * @memberof YextPublisherStat
     */
    'primaryValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof YextPublisherStat
     */
    'secondaryLabel'?: string;
    /**
     * 
     * @type {number}
     * @memberof YextPublisherStat
     */
    'secondaryValue'?: number;
}
/**
 * 
 * @export
 * @interface YextReportHealth
 */
export interface YextReportHealth {
    /**
     * 
     * @type {number}
     * @memberof YextReportHealth
     */
    'listingsLive'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportHealth
     */
    'accuracy'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportHealth
     */
    'duplicatesSuppressed'?: number;
}
/**
 * 
 * @export
 * @interface YextReportPoint
 */
export interface YextReportPoint {
    /**
     * 
     * @type {string}
     * @memberof YextReportPoint
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof YextReportPoint
     */
    'impressions'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportPoint
     */
    'interactions'?: number;
}
/**
 * 
 * @export
 * @interface YextReportTotals
 */
export interface YextReportTotals {
    /**
     * 
     * @type {number}
     * @memberof YextReportTotals
     */
    'impressions'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportTotals
     */
    'interactions'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportTotals
     */
    'profileViews'?: number;
    /**
     * 
     * @type {number}
     * @memberof YextReportTotals
     */
    'searches'?: number;
}
/**
 * 
 * @export
 * @interface YextReportsDto
 */
export interface YextReportsDto {
    /**
     * 
     * @type {boolean}
     * @memberof YextReportsDto
     */
    'connected'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof YextReportsDto
     */
    'rangeDays'?: number;
    /**
     * 
     * @type {YextReportTotals}
     * @memberof YextReportsDto
     */
    'totals'?: YextReportTotals;
    /**
     * 
     * @type {Array<YextReportPoint>}
     * @memberof YextReportsDto
     */
    'series'?: Array<YextReportPoint>;
    /**
     * 
     * @type {Array<YextPublisherStat>}
     * @memberof YextReportsDto
     */
    'publishers'?: Array<YextPublisherStat>;
    /**
     * 
     * @type {YextReportHealth}
     * @memberof YextReportsDto
     */
    'health'?: YextReportHealth;
}
/**
 * 
 * @export
 * @interface YextStaffBio
 */
export interface YextStaffBio {
    /**
     * 
     * @type {string}
     * @memberof YextStaffBio
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextStaffBio
     */
    'bio'?: string;
}
/**
 * 
 * @export
 * @interface YextStatusDto
 */
export interface YextStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof YextStatusDto
     */
    'hasEntity'?: boolean;
}
/**
 * 
 * @export
 * @interface YextSyncResultDto
 */
export interface YextSyncResultDto {
    /**
     * 
     * @type {string}
     * @memberof YextSyncResultDto
     */
    'entityId'?: string;
}
/**
 * 
 * @export
 * @interface YextSyncStatusDto
 */
export interface YextSyncStatusDto {
    /**
     * 
     * @type {number}
     * @memberof YextSyncStatusDto
     */
    'syncedAt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof YextSyncStatusDto
     */
    'hasUnpublishedChanges'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof YextSyncStatusDto
     */
    'lastError'?: string;
    /**
     * 
     * @type {YextTemporaryClosureDto}
     * @memberof YextSyncStatusDto
     */
    'temporaryClosure'?: YextTemporaryClosureDto;
}
/**
 * 
 * @export
 * @interface YextTemporaryClosureDto
 */
export interface YextTemporaryClosureDto {
    /**
     * 
     * @type {string}
     * @memberof YextTemporaryClosureDto
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof YextTemporaryClosureDto
     */
    'through'?: string;
}

/**
 * AccountsResourceApi - axios parameter creator
 * @export
 */
export const AccountsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {number} quantity 
         * @param {string} body 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionAddon: async (memberId: string, preview: boolean, quantity: number, body: string, locationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('addSubscriptionAddon', 'memberId', memberId)
            // verify required parameter 'preview' is not null or undefined
            assertParamExists('addSubscriptionAddon', 'preview', preview)
            // verify required parameter 'quantity' is not null or undefined
            assertParamExists('addSubscriptionAddon', 'quantity', quantity)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addSubscriptionAddon', 'body', body)
            const localVarPath = `/accounts/{memberId}/subscription/addons`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preview !== undefined) {
                localVarQueryParameter['preview'] = preview;
            }

            if (quantity !== undefined) {
                localVarQueryParameter['quantity'] = quantity;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('cancelSubscription', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/cancel`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionPlan: async (memberId: string, preview: boolean, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('changeSubscriptionPlan', 'memberId', memberId)
            // verify required parameter 'preview' is not null or undefined
            assertParamExists('changeSubscriptionPlan', 'preview', preview)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('changeSubscriptionPlan', 'body', body)
            const localVarPath = `/accounts/{memberId}/subscription/change`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preview !== undefined) {
                localVarQueryParameter['preview'] = preview;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccount', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDsaScreens: async (memberId: string, includeDetails?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountDsaScreens', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/dsa/screens`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDetails !== undefined) {
                localVarQueryParameter['includeDetails'] = includeDetails;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDsaScreensTotal: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountDsaScreensTotal', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/dsa/screens/total`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentDetails: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountPaymentDetails', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/payments`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPrintHistory: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountPrintHistory', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/prints`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchaseInvoicePDF: async (memberId: string, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountPurchaseInvoicePDF', 'memberId', memberId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getAccountPurchaseInvoicePDF', 'transactionId', transactionId)
            const localVarPath = `/accounts/{memberId}/purchases/invoice/{transactionId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchaseReceiptPDF: async (memberId: string, transactionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountPurchaseReceiptPDF', 'memberId', memberId)
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getAccountPurchaseReceiptPDF', 'transactionId', transactionId)
            const localVarPath = `/accounts/{memberId}/purchases/receipt/{transactionId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchases: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAccountPurchases', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/purchases`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddOnsExpirationDate: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAddOnsExpirationDate', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/addons/expiration`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersDetails: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAllUsersDetails', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/users/all`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePrices: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAvailablePrices', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/getAvailablePrices`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSubscriptions: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getAvailableSubscriptions', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/list`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberRole: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberRole', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/role`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPastDueStatus: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getPastDueStatus', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/past-due`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuLocations1: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getPopmenuLocations1', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/popmenu/locations`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryUserLocation: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getPrimaryUserLocation', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/locations/primary`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSubscription', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionAddons: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSubscriptionAddons', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/addons`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToAnnualStatus: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSwitchToAnnualStatus', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/switch-to-annual`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToDesignStatus: async (memberId: string, billingCycle: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSwitchToDesignStatus', 'memberId', memberId)
            // verify required parameter 'billingCycle' is not null or undefined
            assertParamExists('getSwitchToDesignStatus', 'billingCycle', billingCycle)
            const localVarPath = `/accounts/{memberId}/subscription/switch-to-design`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billingCycle !== undefined) {
                localVarQueryParameter['billingCycle'] = billingCycle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToMonthlyStatus: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSwitchToMonthlyStatus', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/subscription/switch-to-monthly`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToProStatus: async (memberId: string, billingCycle: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getSwitchToProStatus', 'memberId', memberId)
            // verify required parameter 'billingCycle' is not null or undefined
            assertParamExists('getSwitchToProStatus', 'billingCycle', billingCycle)
            const localVarPath = `/accounts/{memberId}/subscription/switch-to-pro`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (billingCycle !== undefined) {
                localVarQueryParameter['billingCycle'] = billingCycle;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvailableSeats: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamAvailableSeats', 'teamId', teamId)
            const localVarPath = `/accounts/{teamId}/seats`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBrands: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUserBrands', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/brands`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUserInfo', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/info`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocations: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUserLocations', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/locations`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationsLight: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUserLocationsLight', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/locations/light`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationsWithLogos: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUserLocationsWithLogos', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/locations/withLogos`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} [page] 
         * @param {string} [status] 
         * @param {number} [size] 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersDetails: async (memberId: string, page?: number, status?: string, size?: number, key?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getUsersDetails', 'memberId', memberId)
            const localVarPath = `/accounts/{memberId}/users`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription: async (memberId: string, body: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('pauseSubscription', 'memberId', memberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('pauseSubscription', 'body', body)
            const localVarPath = `/accounts/{memberId}/subscription/pause`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription: async (memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('reactivateSubscription', 'memberId', memberId)
            // verify required parameter 'upgradeSubscriptionDto' is not null or undefined
            assertParamExists('reactivateSubscription', 'upgradeSubscriptionDto', upgradeSubscriptionDto)
            const localVarPath = `/accounts/{memberId}/subscription/reactivate`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateSubscriptionPlan: async (memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('recreateSubscriptionPlan', 'memberId', memberId)
            // verify required parameter 'upgradeSubscriptionDto' is not null or undefined
            assertParamExists('recreateSubscriptionPlan', 'upgradeSubscriptionDto', upgradeSubscriptionDto)
            const localVarPath = `/accounts/{memberId}/subscription/recreate`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriptionAddon: async (memberId: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('removeSubscriptionAddon', 'memberId', memberId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('removeSubscriptionAddon', 'body', body)
            const localVarPath = `/accounts/{memberId}/subscription/addons`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscription: async (memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('resumeSubscription', 'memberId', memberId)
            // verify required parameter 'upgradeSubscriptionDto' is not null or undefined
            assertParamExists('resumeSubscription', 'upgradeSubscriptionDto', upgradeSubscriptionDto)
            const localVarPath = `/accounts/{memberId}/subscription/resume`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {FullBillingDto} fullBillingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFullBillingInfo: async (memberId: string, fullBillingDto: FullBillingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('saveFullBillingInfo', 'memberId', memberId)
            // verify required parameter 'fullBillingDto' is not null or undefined
            assertParamExists('saveFullBillingInfo', 'fullBillingDto', fullBillingDto)
            const localVarPath = `/accounts/{memberId}/billing`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fullBillingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryUserLocation: async (memberId: number, locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('setPrimaryUserLocation', 'memberId', memberId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('setPrimaryUserLocation', 'locationId', locationId)
            const localVarPath = `/accounts/{memberId}/locations/{locationId}/primary`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateCardDto} updateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPaymentDetailsCard: async (memberId: string, updateCardDto: UpdateCardDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateAccountPaymentDetailsCard', 'memberId', memberId)
            // verify required parameter 'updateCardDto' is not null or undefined
            assertParamExists('updateAccountPaymentDetailsCard', 'updateCardDto', updateCardDto)
            const localVarPath = `/accounts/{memberId}/payments/card`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<AccountMemberDto>} accountMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissions: async (memberId: string, accountMemberDto: Array<AccountMemberDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updatePermissions', 'memberId', memberId)
            // verify required parameter 'accountMemberDto' is not null or undefined
            assertParamExists('updatePermissions', 'accountMemberDto', accountMemberDto)
            const localVarPath = `/accounts/{memberId}/users/permissions`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscriptionPlan: async (memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('upgradeSubscriptionPlan', 'memberId', memberId)
            // verify required parameter 'upgradeSubscriptionDto' is not null or undefined
            assertParamExists('upgradeSubscriptionPlan', 'upgradeSubscriptionDto', upgradeSubscriptionDto)
            const localVarPath = `/accounts/{memberId}/subscription/upgrade`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBilling: async (memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('validateBilling', 'memberId', memberId)
            // verify required parameter 'upgradeSubscriptionDto' is not null or undefined
            assertParamExists('validateBilling', 'upgradeSubscriptionDto', upgradeSubscriptionDto)
            const localVarPath = `/accounts/{memberId}/billing/validate`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upgradeSubscriptionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsResourceApi - functional programming interface
 * @export
 */
export const AccountsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {number} quantity 
         * @param {string} body 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSubscriptionAddon(memberId: string, preview: boolean, quantity: number, body: string, locationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSubscriptionAddon(memberId, preview, quantity, body, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeSubscriptionPlan(memberId: string, preview: boolean, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeSubscriptionPlan(memberId, preview, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountDsaScreens(memberId: string, includeDetails?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountDsaScreens(memberId, includeDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountDsaScreensTotal(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountDsaScreensTotal(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPaymentDetails(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPaymentDetails(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPrintHistory(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrintDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPrintHistory(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPurchaseInvoicePDF(memberId: string, transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPurchaseInvoicePDF(memberId, transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPurchaseReceiptPDF(memberId: string, transactionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPurchaseReceiptPDF(memberId, transactionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPurchases(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPurchases(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddOnsExpirationDate(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddonExpirationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddOnsExpirationDate(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersDetails(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersDetails(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailablePrices(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PriceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailablePrices(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableSubscriptions(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubStatusDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableSubscriptions(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberRole(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberRole(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPastDueStatus(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountPastDueStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPastDueStatus(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopmenuLocations1(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopmenuLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopmenuLocations1(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrimaryUserLocation(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrimaryUserLocation(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscription(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscription(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionAddons(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddOnDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionAddons(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSwitchToAnnualStatus(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSwitchToAnnualStatus(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSwitchToDesignStatus(memberId: string, billingCycle: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSwitchToDesignStatus(memberId, billingCycle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSwitchToMonthlyStatus(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSwitchToMonthlyStatus(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSwitchToProStatus(memberId: string, billingCycle: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSwitchToProStatus(memberId, billingCycle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamAvailableSeats(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamAvailableSeats(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserBrands(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserBrands(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLocations(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLocations(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLocationsLight(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLocationsLight(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLocationsWithLogos(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLocationsWithLogos(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} [page] 
         * @param {string} [status] 
         * @param {number} [size] 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersDetails(memberId: string, page?: number, status?: string, size?: number, key?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersDetails(memberId, page, status, size, key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseSubscription(memberId: string, body: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseSubscription(memberId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateSubscription(memberId, upgradeSubscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recreateSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recreateSubscriptionPlan(memberId, upgradeSubscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSubscriptionAddon(memberId: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSubscriptionAddon(memberId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeSubscription(memberId, upgradeSubscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {FullBillingDto} fullBillingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFullBillingInfo(memberId: string, fullBillingDto: FullBillingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFullBillingInfo(memberId, fullBillingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryUserLocation(memberId: number, locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryUserLocation(memberId, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateCardDto} updateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountPaymentDetailsCard(memberId: string, updateCardDto: UpdateCardDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LightCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountPaymentDetailsCard(memberId, updateCardDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<AccountMemberDto>} accountMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissions(memberId: string, accountMemberDto: Array<AccountMemberDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissions(memberId, accountMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upgradeSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upgradeSubscriptionPlan(memberId, upgradeSubscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateBilling(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateBilling(memberId, upgradeSubscriptionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountsResourceApi - factory interface
 * @export
 */
export const AccountsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {number} quantity 
         * @param {string} body 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSubscriptionAddon(memberId: string, preview: boolean, quantity: number, body: string, locationId?: number, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.addSubscriptionAddon(memberId, preview, quantity, body, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(memberId: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.cancelSubscription(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} preview 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeSubscriptionPlan(memberId: string, preview: boolean, body: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.changeSubscriptionPlan(memberId, preview, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(memberId: string, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.getAccount(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDsaScreens(memberId: string, includeDetails?: boolean, options?: any): AxiosPromise<Array<DsaScreenDto>> {
            return localVarFp.getAccountDsaScreens(memberId, includeDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDsaScreensTotal(memberId: string, options?: any): AxiosPromise<number> {
            return localVarFp.getAccountDsaScreensTotal(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentDetails(memberId: string, options?: any): AxiosPromise<PaymentDetailsDto> {
            return localVarFp.getAccountPaymentDetails(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPrintHistory(memberId: string, options?: any): AxiosPromise<Array<PrintDto>> {
            return localVarFp.getAccountPrintHistory(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchaseInvoicePDF(memberId: string, transactionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getAccountPurchaseInvoicePDF(memberId, transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} transactionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchaseReceiptPDF(memberId: string, transactionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getAccountPurchaseReceiptPDF(memberId, transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPurchases(memberId: string, options?: any): AxiosPromise<Array<PurchaseDto>> {
            return localVarFp.getAccountPurchases(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddOnsExpirationDate(memberId: string, options?: any): AxiosPromise<AddonExpirationDto> {
            return localVarFp.getAddOnsExpirationDate(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersDetails(memberId: string, options?: any): AxiosPromise<UserDetailsDto> {
            return localVarFp.getAllUsersDetails(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailablePrices(memberId: string, options?: any): AxiosPromise<Array<PriceDto>> {
            return localVarFp.getAvailablePrices(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableSubscriptions(memberId: string, options?: any): AxiosPromise<Array<SubStatusDto>> {
            return localVarFp.getAvailableSubscriptions(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberRole(memberId: number, options?: any): AxiosPromise<string> {
            return localVarFp.getMemberRole(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPastDueStatus(memberId: string, options?: any): AxiosPromise<AccountPastDueStatusDto> {
            return localVarFp.getPastDueStatus(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuLocations1(memberId: string, options?: any): AxiosPromise<Array<PopmenuLocationDto>> {
            return localVarFp.getPopmenuLocations1(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryUserLocation(memberId: number, options?: any): AxiosPromise<AccountLocationDto> {
            return localVarFp.getPrimaryUserLocation(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(memberId: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.getSubscription(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionAddons(memberId: string, options?: any): AxiosPromise<Array<AddOnDto>> {
            return localVarFp.getSubscriptionAddons(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToAnnualStatus(memberId: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.getSwitchToAnnualStatus(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToDesignStatus(memberId: string, billingCycle: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.getSwitchToDesignStatus(memberId, billingCycle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToMonthlyStatus(memberId: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.getSwitchToMonthlyStatus(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} billingCycle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSwitchToProStatus(memberId: string, billingCycle: string, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.getSwitchToProStatus(memberId, billingCycle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvailableSeats(teamId: string, options?: any): AxiosPromise<number> {
            return localVarFp.getTeamAvailableSeats(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBrands(memberId: string, options?: any): AxiosPromise<Array<BrandDto>> {
            return localVarFp.getUserBrands(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(memberId: string, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.getUserInfo(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocations(memberId: string, options?: any): AxiosPromise<Array<AccountLocationDto>> {
            return localVarFp.getUserLocations(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationsLight(memberId: string, options?: any): AxiosPromise<Array<AccountLocationDto>> {
            return localVarFp.getUserLocationsLight(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLocationsWithLogos(memberId: string, options?: any): AxiosPromise<Array<AccountLocationDto>> {
            return localVarFp.getUserLocationsWithLogos(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} [page] 
         * @param {string} [status] 
         * @param {number} [size] 
         * @param {string} [key] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersDetails(memberId: string, page?: number, status?: string, size?: number, key?: string, options?: any): AxiosPromise<UserDetailsDto> {
            return localVarFp.getUsersDetails(memberId, page, status, size, key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription(memberId: string, body: number, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.pauseSubscription(memberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.reactivateSubscription(memberId, upgradeSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.recreateSubscriptionPlan(memberId, upgradeSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriptionAddon(memberId: string, body: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeSubscriptionAddon(memberId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.resumeSubscription(memberId, upgradeSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {FullBillingDto} fullBillingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFullBillingInfo(memberId: string, fullBillingDto: FullBillingDto, options?: any): AxiosPromise<void> {
            return localVarFp.saveFullBillingInfo(memberId, fullBillingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryUserLocation(memberId: number, locationId: number, options?: any): AxiosPromise<void> {
            return localVarFp.setPrimaryUserLocation(memberId, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateCardDto} updateCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPaymentDetailsCard(memberId: string, updateCardDto: UpdateCardDto, options?: any): AxiosPromise<LightCardDto> {
            return localVarFp.updateAccountPaymentDetailsCard(memberId, updateCardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<AccountMemberDto>} accountMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissions(memberId: string, accountMemberDto: Array<AccountMemberDto>, options?: any): AxiosPromise<boolean> {
            return localVarFp.updatePermissions(memberId, accountMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.upgradeSubscriptionPlan(memberId, upgradeSubscriptionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateBilling(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: any): AxiosPromise<SubStatusDto> {
            return localVarFp.validateBilling(memberId, upgradeSubscriptionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsResourceApi - object-oriented interface
 * @export
 * @class AccountsResourceApi
 * @extends {BaseAPI}
 */
export class AccountsResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} memberId 
     * @param {boolean} preview 
     * @param {number} quantity 
     * @param {string} body 
     * @param {number} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public addSubscriptionAddon(memberId: string, preview: boolean, quantity: number, body: string, locationId?: number, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).addSubscriptionAddon(memberId, preview, quantity, body, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public cancelSubscription(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).cancelSubscription(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {boolean} preview 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public changeSubscriptionPlan(memberId: string, preview: boolean, body: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).changeSubscriptionPlan(memberId, preview, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccount(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccount(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {boolean} [includeDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountDsaScreens(memberId: string, includeDetails?: boolean, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountDsaScreens(memberId, includeDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountDsaScreensTotal(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountDsaScreensTotal(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountPaymentDetails(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountPaymentDetails(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountPrintHistory(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountPrintHistory(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountPurchaseInvoicePDF(memberId: string, transactionId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountPurchaseInvoicePDF(memberId, transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} transactionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountPurchaseReceiptPDF(memberId: string, transactionId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountPurchaseReceiptPDF(memberId, transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAccountPurchases(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAccountPurchases(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAddOnsExpirationDate(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAddOnsExpirationDate(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAllUsersDetails(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAllUsersDetails(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAvailablePrices(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAvailablePrices(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getAvailableSubscriptions(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getAvailableSubscriptions(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getMemberRole(memberId: number, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getMemberRole(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getPastDueStatus(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getPastDueStatus(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getPopmenuLocations1(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getPopmenuLocations1(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getPrimaryUserLocation(memberId: number, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getPrimaryUserLocation(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSubscription(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSubscription(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSubscriptionAddons(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSubscriptionAddons(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSwitchToAnnualStatus(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSwitchToAnnualStatus(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} billingCycle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSwitchToDesignStatus(memberId: string, billingCycle: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSwitchToDesignStatus(memberId, billingCycle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSwitchToMonthlyStatus(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSwitchToMonthlyStatus(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} billingCycle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getSwitchToProStatus(memberId: string, billingCycle: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getSwitchToProStatus(memberId, billingCycle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getTeamAvailableSeats(teamId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getTeamAvailableSeats(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUserBrands(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUserBrands(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUserInfo(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUserInfo(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUserLocations(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUserLocations(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUserLocationsLight(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUserLocationsLight(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUserLocationsWithLogos(memberId: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUserLocationsWithLogos(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {number} [page] 
     * @param {string} [status] 
     * @param {number} [size] 
     * @param {string} [key] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public getUsersDetails(memberId: string, page?: number, status?: string, size?: number, key?: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).getUsersDetails(memberId, page, status, size, key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {number} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public pauseSubscription(memberId: string, body: number, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).pauseSubscription(memberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public reactivateSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).reactivateSubscription(memberId, upgradeSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public recreateSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).recreateSubscriptionPlan(memberId, upgradeSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public removeSubscriptionAddon(memberId: string, body: string, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).removeSubscriptionAddon(memberId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public resumeSubscription(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).resumeSubscription(memberId, upgradeSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {FullBillingDto} fullBillingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public saveFullBillingInfo(memberId: string, fullBillingDto: FullBillingDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).saveFullBillingInfo(memberId, fullBillingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public setPrimaryUserLocation(memberId: number, locationId: number, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).setPrimaryUserLocation(memberId, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpdateCardDto} updateCardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public updateAccountPaymentDetailsCard(memberId: string, updateCardDto: UpdateCardDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).updateAccountPaymentDetailsCard(memberId, updateCardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {Array<AccountMemberDto>} accountMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public updatePermissions(memberId: string, accountMemberDto: Array<AccountMemberDto>, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).updatePermissions(memberId, accountMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public upgradeSubscriptionPlan(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).upgradeSubscriptionPlan(memberId, upgradeSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpgradeSubscriptionDto} upgradeSubscriptionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsResourceApi
     */
    public validateBilling(memberId: string, upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: AxiosRequestConfig) {
        return AccountsResourceApiFp(this.configuration).validateBilling(memberId, upgradeSubscriptionDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AppResourceApi - axios parameter creator
 * @export
 */
export const AppResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmail: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('checkEmail', 'body', body)
            const localVarPath = `/public/login/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('googleLogin', 'body', body)
            const localVarPath = `/public/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('login', 'loginDto', loginDto)
            const localVarPath = `/public/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftLogin: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('microsoftLogin', 'body', body)
            const localVarPath = `/public/login/microsoft`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppResourceApi - functional programming interface
 * @export
 */
export const AppResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEmail(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEmail(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async init(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.init(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async microsoftLogin(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.microsoftLogin(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppResourceApi - factory interface
 * @export
 */
export const AppResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEmail(body: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(body: string, options?: any): AxiosPromise<SsoMember> {
            return localVarFp.googleLogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init(options?: any): AxiosPromise<InitDto> {
            return localVarFp.init(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDto: LoginDto, options?: any): AxiosPromise<LoginResponse> {
            return localVarFp.login(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftLogin(body: string, options?: any): AxiosPromise<SsoMember> {
            return localVarFp.microsoftLogin(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppResourceApi - object-oriented interface
 * @export
 * @class AppResourceApi
 * @extends {BaseAPI}
 */
export class AppResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppResourceApi
     */
    public checkEmail(body: string, options?: AxiosRequestConfig) {
        return AppResourceApiFp(this.configuration).checkEmail(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppResourceApi
     */
    public googleLogin(body: string, options?: AxiosRequestConfig) {
        return AppResourceApiFp(this.configuration).googleLogin(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppResourceApi
     */
    public init(options?: AxiosRequestConfig) {
        return AppResourceApiFp(this.configuration).init(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppResourceApi
     */
    public login(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AppResourceApiFp(this.configuration).login(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppResourceApi
     */
    public microsoftLogin(body: string, options?: AxiosRequestConfig) {
        return AppResourceApiFp(this.configuration).microsoftLogin(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AssetResourceApi - axios parameter creator
 * @export
 */
export const AssetResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBrand: async (brandKitId: string, ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitId' is not null or undefined
            assertParamExists('assignToBrand', 'brandKitId', brandKitId)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('assignToBrand', 'ids', ids)
            const localVarPath = `/assets/assign-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandKitId !== undefined) {
                localVarQueryParameter['brandKitId'] = brandKitId;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandKitIds 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBrands: async (brandKitIds: string, ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitIds' is not null or undefined
            assertParamExists('assignToBrands', 'brandKitIds', brandKitIds)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('assignToBrands', 'ids', ids)
            const localVarPath = `/assets/assign-brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandKitIds !== undefined) {
                localVarQueryParameter['brandKitIds'] = brandKitIds;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDelete: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDelete', 'requestBody', requestBody)
            const localVarPath = `/assets/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDownload: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkDownload', 'requestBody', requestBody)
            const localVarPath = `/assets/bulk-download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMoveCategory: async (category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('bulkMoveCategory', 'category', category)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('bulkMoveCategory', 'requestBody', requestBody)
            const localVarPath = `/assets/bulk-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsset: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAsset', 'id', id)
            const localVarPath = `/assets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('download', 'id', id)
            const localVarPath = `/assets/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (teamId: string, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', query?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('list', 'teamId', teamId)
            const localVarPath = `/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>} [categories] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByBrandKit1: async (brandKitId: string, categories?: Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitId' is not null or undefined
            assertParamExists('listByBrandKit1', 'brandKitId', brandKitId)
            const localVarPath = `/assets/by-brand-kit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandKitId !== undefined) {
                localVarQueryParameter['brandKitId'] = brandKitId;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCategory: async (id: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveCategory', 'id', id)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('moveCategory', 'category', category)
            const localVarPath = `/assets/{id}/category`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAsset: async (id: string, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('renameAsset', 'id', id)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('renameAsset', 'name', name)
            const localVarPath = `/assets/{id}/rename`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignFromBrand: async (brandKitId: string, ids: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitId' is not null or undefined
            assertParamExists('unassignFromBrand', 'brandKitId', brandKitId)
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('unassignFromBrand', 'ids', ids)
            const localVarPath = `/assets/unassign-brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandKitId !== undefined) {
                localVarQueryParameter['brandKitId'] = brandKitId;
            }

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAltText: async (id: string, altText: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAltText', 'id', id)
            // verify required parameter 'altText' is not null or undefined
            assertParamExists('updateAltText', 'altText', altText)
            const localVarPath = `/assets/{id}/alt-text`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (altText !== undefined) {
                localVarQueryParameter['altText'] = altText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (teamId: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('upload', 'teamId', teamId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('upload', 'category', category)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upload', 'file', file)
            const localVarPath = `/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<any>} files 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMultiple: async (teamId: string, files: Array<any>, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('uploadMultiple', 'teamId', teamId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadMultiple', 'files', files)
            const localVarPath = `/assets/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetResourceApi - functional programming interface
 * @export
 */
export const AssetResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToBrand(brandKitId: string, ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToBrand(brandKitId, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandKitIds 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignToBrands(brandKitIds: string, ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignToBrands(brandKitIds, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDelete(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDownload(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDownload(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkMoveCategory(category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkMoveCategory(category, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsset(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsset(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(teamId: string, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', query?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(teamId, category, query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>} [categories] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByBrandKit1(brandKitId: string, categories?: Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByBrandKit1(brandKitId, categories, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveCategory(id: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveCategory(id, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameAsset(id: string, name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameAsset(id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignFromBrand(brandKitId: string, ids: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignFromBrand(brandKitId, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAltText(id: string, altText: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAltText(id, altText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(teamId: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(teamId, category, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<any>} files 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMultiple(teamId: string, files: Array<any>, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUploadResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMultiple(teamId, files, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssetResourceApi - factory interface
 * @export
 */
export const AssetResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBrand(brandKitId: string, ids: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignToBrand(brandKitId, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandKitIds 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignToBrands(brandKitIds: string, ids: string, options?: any): AxiosPromise<void> {
            return localVarFp.assignToBrands(brandKitIds, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDelete(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.bulkDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDownload(requestBody: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.bulkDownload(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkMoveCategory(category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', requestBody: Array<string>, options?: any): AxiosPromise<Array<AssetDto>> {
            return localVarFp.bulkMoveCategory(category, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsset(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAsset(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.download(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(teamId: string, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', query?: string, options?: any): AxiosPromise<Array<AssetDto>> {
            return localVarFp.list(teamId, category, query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>} [categories] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByBrandKit1(brandKitId: string, categories?: Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>, options?: any): AxiosPromise<Array<AssetDto>> {
            return localVarFp.listByBrandKit1(brandKitId, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCategory(id: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: any): AxiosPromise<AssetDto> {
            return localVarFp.moveCategory(id, category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameAsset(id: string, name: string, options?: any): AxiosPromise<AssetDto> {
            return localVarFp.renameAsset(id, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignFromBrand(brandKitId: string, ids: string, options?: any): AxiosPromise<void> {
            return localVarFp.unassignFromBrand(brandKitId, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAltText(id: string, altText: string, options?: any): AxiosPromise<AssetDto> {
            return localVarFp.updateAltText(id, altText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(teamId: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', file: any, options?: any): AxiosPromise<AssetDto> {
            return localVarFp.upload(teamId, category, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<any>} files 
         * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMultiple(teamId: string, files: Array<any>, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: any): AxiosPromise<BulkUploadResultDto> {
            return localVarFp.uploadMultiple(teamId, files, category, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetResourceApi - object-oriented interface
 * @export
 * @class AssetResourceApi
 * @extends {BaseAPI}
 */
export class AssetResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} brandKitId 
     * @param {string} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public assignToBrand(brandKitId: string, ids: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).assignToBrand(brandKitId, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandKitIds 
     * @param {string} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public assignToBrands(brandKitIds: string, ids: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).assignToBrands(brandKitIds, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public bulkDelete(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).bulkDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public bulkDownload(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).bulkDownload(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public bulkMoveCategory(category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', requestBody: Array<string>, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).bulkMoveCategory(category, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public deleteAsset(id: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).deleteAsset(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public download(id: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).download(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public list(teamId: string, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', query?: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).list(teamId, category, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandKitId 
     * @param {Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>} [categories] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public listByBrandKit1(brandKitId: string, categories?: Array<'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'>, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).listByBrandKit1(brandKitId, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public moveCategory(id: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).moveCategory(id, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public renameAsset(id: string, name: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).renameAsset(id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandKitId 
     * @param {string} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public unassignFromBrand(brandKitId: string, ids: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).unassignFromBrand(brandKitId, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} altText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public updateAltText(id: string, altText: string, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).updateAltText(id, altText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} category 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public upload(teamId: string, category: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', file: any, options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).upload(teamId, category, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {Array<any>} files 
     * @param {'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS'} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetResourceApi
     */
    public uploadMultiple(teamId: string, files: Array<any>, category?: 'LOGOS' | 'FONTS' | 'ICONS' | 'PHOTOS' | 'GRAPHICS', options?: AxiosRequestConfig) {
        return AssetResourceApiFp(this.configuration).uploadMultiple(teamId, files, category, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandKitResourceApi - axios parameter creator
 * @export
 */
export const BrandKitResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addColor: async (id: string, brandColorDto: BrandColorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addColor', 'id', id)
            // verify required parameter 'brandColorDto' is not null or undefined
            assertParamExists('addColor', 'brandColorDto', brandColorDto)
            const localVarPath = `/brand-kits/{id}/colors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandColorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLocation: async (id: string, locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignLocation', 'id', id)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('assignLocation', 'locationId', locationId)
            const localVarPath = `/brand-kits/{id}/locations/{locationId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandKit: async (brandKitDto: BrandKitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitDto' is not null or undefined
            assertParamExists('createBrandKit', 'brandKitDto', brandKitDto)
            const localVarPath = `/brand-kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandKitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkBrandKitRequest} bulkBrandKitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkBrandKits: async (bulkBrandKitRequest: BulkBrandKitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkBrandKitRequest' is not null or undefined
            assertParamExists('createBulkBrandKits', 'bulkBrandKitRequest', bulkBrandKitRequest)
            const localVarPath = `/brand-kits/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkBrandKitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandKit: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBrandKit', 'id', id)
            const localVarPath = `/brand-kits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColor: async (id: string, colorCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteColor', 'id', id)
            // verify required parameter 'colorCode' is not null or undefined
            assertParamExists('deleteColor', 'colorCode', colorCode)
            const localVarPath = `/brand-kits/{id}/colors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (colorCode !== undefined) {
                localVarQueryParameter['colorCode'] = colorCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrdIcon: async (id: string, attribute: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDrdIcon', 'id', id)
            // verify required parameter 'attribute' is not null or undefined
            assertParamExists('deleteDrdIcon', 'attribute', attribute)
            const localVarPath = `/brand-kits/{id}/drd-icons/{attribute}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attribute"}}`, encodeURIComponent(String(attribute)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get2', 'id', id)
            const localVarPath = `/brand-kits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPreviewPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getBrandPreviewPerLocation', 'locationId', locationId)
            const localVarPath = `/brand-kits/location/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColors: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getColors', 'id', id)
            const localVarPath = `/brand-kits/{id}/colors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrdIcons: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDrdIcons', 'id', id)
            const localVarPath = `/brand-kits/{id}/drd-icons`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonts1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFonts1', 'id', id)
            const localVarPath = `/brand-kits/{id}/fonts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogos: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLogos', 'id', id)
            const localVarPath = `/brand-kits/{id}/logos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForTeam: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listForTeam', 'teamId', teamId)
            const localVarPath = `/brand-kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandFontsDto} brandFontsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFonts: async (id: string, brandFontsDto: BrandFontsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveFonts', 'id', id)
            // verify required parameter 'brandFontsDto' is not null or undefined
            assertParamExists('saveFonts', 'brandFontsDto', brandFontsDto)
            const localVarPath = `/brand-kits/{id}/fonts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandFontsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLocation: async (id: string, locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unassignLocation', 'id', id)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('unassignLocation', 'locationId', locationId)
            const localVarPath = `/brand-kits/{id}/locations/{locationId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandKit: async (id: string, brandKitDto: BrandKitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBrandKit', 'id', id)
            // verify required parameter 'brandKitDto' is not null or undefined
            assertParamExists('updateBrandKit', 'brandKitDto', brandKitDto)
            const localVarPath = `/brand-kits/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandKitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} oldColorCode 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateColor: async (id: string, oldColorCode: string, brandColorDto: BrandColorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateColor', 'id', id)
            // verify required parameter 'oldColorCode' is not null or undefined
            assertParamExists('updateColor', 'oldColorCode', oldColorCode)
            // verify required parameter 'brandColorDto' is not null or undefined
            assertParamExists('updateColor', 'brandColorDto', brandColorDto)
            const localVarPath = `/brand-kits/{id}/colors`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (oldColorCode !== undefined) {
                localVarQueryParameter['oldColorCode'] = oldColorCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandColorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {BrandKitDrdIconDto} brandKitDrdIconDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDrdIcon: async (id: string, attribute: string, brandKitDrdIconDto: BrandKitDrdIconDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertDrdIcon', 'id', id)
            // verify required parameter 'attribute' is not null or undefined
            assertParamExists('upsertDrdIcon', 'attribute', attribute)
            // verify required parameter 'brandKitDrdIconDto' is not null or undefined
            assertParamExists('upsertDrdIcon', 'brandKitDrdIconDto', brandKitDrdIconDto)
            const localVarPath = `/brand-kits/{id}/drd-icons/{attribute}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attribute"}}`, encodeURIComponent(String(attribute)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandKitDrdIconDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandKitResourceApi - functional programming interface
 * @export
 */
export const BrandKitResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandKitResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addColor(id: string, brandColorDto: BrandColorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandColorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addColor(id, brandColorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLocation(id: string, locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLocation(id, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrandKit(brandKitDto: BrandKitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrandKit(brandKitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkBrandKitRequest} bulkBrandKitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkBrandKits(bulkBrandKitRequest: BulkBrandKitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandKitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkBrandKits(bulkBrandKitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandKit(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandKit(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteColor(id: string, colorCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandColorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteColor(id, colorCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDrdIcon(id: string, attribute: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDrdIcon(id, attribute, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get2(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get2(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandPreviewPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationBrandPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandPreviewPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getColors(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandColorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getColors(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrdIcons(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandKitDrdIconDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrdIcons(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFonts1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandFontsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFonts1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLogos(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandLogoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLogos(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listForTeam(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandKitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listForTeam(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandFontsDto} brandFontsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFonts(id: string, brandFontsDto: BrandFontsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandFontsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFonts(id, brandFontsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignLocation(id: string, locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignLocation(id, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrandKit(id: string, brandKitDto: BrandKitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrandKit(id, brandKitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} oldColorCode 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateColor(id: string, oldColorCode: string, brandColorDto: BrandColorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandColorDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateColor(id, oldColorCode, brandColorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {BrandKitDrdIconDto} brandKitDrdIconDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertDrdIcon(id: string, attribute: string, brandKitDrdIconDto: BrandKitDrdIconDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandKitDrdIconDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertDrdIcon(id, attribute, brandKitDrdIconDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrandKitResourceApi - factory interface
 * @export
 */
export const BrandKitResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandKitResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addColor(id: string, brandColorDto: BrandColorDto, options?: any): AxiosPromise<Array<BrandColorDto>> {
            return localVarFp.addColor(id, brandColorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLocation(id: string, locationId: number, options?: any): AxiosPromise<BrandKitDto> {
            return localVarFp.assignLocation(id, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrandKit(brandKitDto: BrandKitDto, options?: any): AxiosPromise<BrandKitDto> {
            return localVarFp.createBrandKit(brandKitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkBrandKitRequest} bulkBrandKitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkBrandKits(bulkBrandKitRequest: BulkBrandKitRequest, options?: any): AxiosPromise<Array<BrandKitDto>> {
            return localVarFp.createBulkBrandKits(bulkBrandKitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandKit(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrandKit(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteColor(id: string, colorCode: string, options?: any): AxiosPromise<Array<BrandColorDto>> {
            return localVarFp.deleteColor(id, colorCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDrdIcon(id: string, attribute: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDrdIcon(id, attribute, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get2(id: string, options?: any): AxiosPromise<BrandKitDto> {
            return localVarFp.get2(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPreviewPerLocation(locationId: number, options?: any): AxiosPromise<LocationBrandPreviewDto> {
            return localVarFp.getBrandPreviewPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getColors(id: string, options?: any): AxiosPromise<Array<BrandColorDto>> {
            return localVarFp.getColors(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrdIcons(id: string, options?: any): AxiosPromise<Array<BrandKitDrdIconDto>> {
            return localVarFp.getDrdIcons(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonts1(id: string, options?: any): AxiosPromise<BrandFontsDto> {
            return localVarFp.getFonts1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogos(id: string, options?: any): AxiosPromise<Array<BrandLogoDto>> {
            return localVarFp.getLogos(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForTeam(teamId: string, options?: any): AxiosPromise<Array<BrandKitDto>> {
            return localVarFp.listForTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandFontsDto} brandFontsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFonts(id: string, brandFontsDto: BrandFontsDto, options?: any): AxiosPromise<BrandFontsDto> {
            return localVarFp.saveFonts(id, brandFontsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignLocation(id: string, locationId: number, options?: any): AxiosPromise<BrandKitDto> {
            return localVarFp.unassignLocation(id, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {BrandKitDto} brandKitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandKit(id: string, brandKitDto: BrandKitDto, options?: any): AxiosPromise<BrandKitDto> {
            return localVarFp.updateBrandKit(id, brandKitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} oldColorCode 
         * @param {BrandColorDto} brandColorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateColor(id: string, oldColorCode: string, brandColorDto: BrandColorDto, options?: any): AxiosPromise<Array<BrandColorDto>> {
            return localVarFp.updateColor(id, oldColorCode, brandColorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} attribute 
         * @param {BrandKitDrdIconDto} brandKitDrdIconDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDrdIcon(id: string, attribute: string, brandKitDrdIconDto: BrandKitDrdIconDto, options?: any): AxiosPromise<BrandKitDrdIconDto> {
            return localVarFp.upsertDrdIcon(id, attribute, brandKitDrdIconDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandKitResourceApi - object-oriented interface
 * @export
 * @class BrandKitResourceApi
 * @extends {BaseAPI}
 */
export class BrandKitResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {BrandColorDto} brandColorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public addColor(id: string, brandColorDto: BrandColorDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).addColor(id, brandColorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public assignLocation(id: string, locationId: number, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).assignLocation(id, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BrandKitDto} brandKitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public createBrandKit(brandKitDto: BrandKitDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).createBrandKit(brandKitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkBrandKitRequest} bulkBrandKitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public createBulkBrandKits(bulkBrandKitRequest: BulkBrandKitRequest, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).createBulkBrandKits(bulkBrandKitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public deleteBrandKit(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).deleteBrandKit(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} colorCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public deleteColor(id: string, colorCode: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).deleteColor(id, colorCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} attribute 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public deleteDrdIcon(id: string, attribute: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).deleteDrdIcon(id, attribute, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public get2(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).get2(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public getBrandPreviewPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).getBrandPreviewPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public getColors(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).getColors(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public getDrdIcons(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).getDrdIcons(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public getFonts1(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).getFonts1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public getLogos(id: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).getLogos(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public listForTeam(teamId: string, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).listForTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {BrandFontsDto} brandFontsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public saveFonts(id: string, brandFontsDto: BrandFontsDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).saveFonts(id, brandFontsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public unassignLocation(id: string, locationId: number, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).unassignLocation(id, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {BrandKitDto} brandKitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public updateBrandKit(id: string, brandKitDto: BrandKitDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).updateBrandKit(id, brandKitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} oldColorCode 
     * @param {BrandColorDto} brandColorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public updateColor(id: string, oldColorCode: string, brandColorDto: BrandColorDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).updateColor(id, oldColorCode, brandColorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} attribute 
     * @param {BrandKitDrdIconDto} brandKitDrdIconDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandKitResourceApi
     */
    public upsertDrdIcon(id: string, attribute: string, brandKitDrdIconDto: BrandKitDrdIconDto, options?: AxiosRequestConfig) {
        return BrandKitResourceApiFp(this.configuration).upsertDrdIcon(id, attribute, brandKitDrdIconDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandTemplateResourceApi - axios parameter creator
 * @export
 */
export const BrandTemplateResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get1', 'id', id)
            const localVarPath = `/brand-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByBrandKit: async (brandKitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandKitId' is not null or undefined
            assertParamExists('listByBrandKit', 'brandKitId', brandKitId)
            const localVarPath = `/brand-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (brandKitId !== undefined) {
                localVarQueryParameter['brandKitId'] = brandKitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listByLocation', 'locationId', locationId)
            const localVarPath = `/brand-templates/by-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromBrandTemplates: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeFromBrandTemplates', 'id', id)
            const localVarPath = `/brand-templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromBrandTemplatesBulk: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('removeFromBrandTemplatesBulk', 'requestBody', requestBody)
            const localVarPath = `/brand-templates/bulk-remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAsBrandTemplate: async (designId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('saveAsBrandTemplate', 'designId', designId)
            const localVarPath = `/brand-templates/from-design/{designId}`
                .replace(`{${"designId"}}`, encodeURIComponent(String(designId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandTemplateResourceApi - functional programming interface
 * @export
 */
export const BrandTemplateResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandTemplateResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByBrandKit(brandKitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByBrandKit(brandKitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listByLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listByLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromBrandTemplates(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromBrandTemplates(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromBrandTemplatesBulk(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromBrandTemplatesBulk(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAsBrandTemplate(designId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAsBrandTemplate(designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrandTemplateResourceApi - factory interface
 * @export
 */
export const BrandTemplateResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandTemplateResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(id: string, options?: any): AxiosPromise<BrandTemplateDto> {
            return localVarFp.get1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandKitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByBrandKit(brandKitId: string, options?: any): AxiosPromise<Array<BrandTemplateDto>> {
            return localVarFp.listByBrandKit(brandKitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listByLocation(locationId: number, options?: any): AxiosPromise<Array<BrandTemplateDto>> {
            return localVarFp.listByLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromBrandTemplates(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeFromBrandTemplates(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromBrandTemplatesBulk(requestBody: Array<string>, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.removeFromBrandTemplatesBulk(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAsBrandTemplate(designId: string, options?: any): AxiosPromise<BrandTemplateDto> {
            return localVarFp.saveAsBrandTemplate(designId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandTemplateResourceApi - object-oriented interface
 * @export
 * @class BrandTemplateResourceApi
 * @extends {BaseAPI}
 */
export class BrandTemplateResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public get1(id: string, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).get1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandKitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public listByBrandKit(brandKitId: string, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).listByBrandKit(brandKitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public listByLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).listByLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public removeFromBrandTemplates(id: string, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).removeFromBrandTemplates(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public removeFromBrandTemplatesBulk(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).removeFromBrandTemplatesBulk(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} designId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandTemplateResourceApi
     */
    public saveAsBrandTemplate(designId: string, options?: AxiosRequestConfig) {
        return BrandTemplateResourceApiFp(this.configuration).saveAsBrandTemplate(designId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandsResourceApi - axios parameter creator
 * @export
 */
export const BrandsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBrand: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clearBrand', 'id', id)
            const localVarPath = `/brands/{id}/clear`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} copyFromLocId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyFromLocation: async (id: string, copyFromLocId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copyFromLocation', 'id', id)
            // verify required parameter 'copyFromLocId' is not null or undefined
            assertParamExists('copyFromLocation', 'copyFromLocId', copyFromLocId)
            const localVarPath = `/brands/{id}/copy/{copyFromLocId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"copyFromLocId"}}`, encodeURIComponent(String(copyFromLocId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand: async (brandDto: BrandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandDto' is not null or undefined
            assertParamExists('createBrand', 'brandDto', brandDto)
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteBrand', 'id', id)
            const localVarPath = `/brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandColor: async (brandId: string, colorCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('deleteBrandColor', 'brandId', brandId)
            // verify required parameter 'colorCode' is not null or undefined
            assertParamExists('deleteBrandColor', 'colorCode', colorCode)
            const localVarPath = `/brands/{brandId}/color`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (colorCode !== undefined) {
                localVarQueryParameter['colorCode'] = colorCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandLogo: async (logoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoId' is not null or undefined
            assertParamExists('deleteBrandLogo', 'logoId', logoId)
            const localVarPath = `/brands/logo/{logoId}`
                .replace(`{${"logoId"}}`, encodeURIComponent(String(logoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} proFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandProFont: async (proFontId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proFontId' is not null or undefined
            assertParamExists('deleteBrandProFont', 'proFontId', proFontId)
            const localVarPath = `/brands/profont/{proFontId}`
                .replace(`{${"proFontId"}}`, encodeURIComponent(String(proFontId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uploadedFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandUploadedFont: async (uploadedFontId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadedFontId' is not null or undefined
            assertParamExists('deleteBrandUploadedFont', 'uploadedFontId', uploadedFontId)
            const localVarPath = `/brands/uploadedfont/{uploadedFontId}`
                .replace(`{${"uploadedFontId"}}`, encodeURIComponent(String(uploadedFontId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamBrandsPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAllTeamBrandsPerLocation', 'locationId', locationId)
            const localVarPath = `/brands/locations/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand: async (id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandLogosPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getBrandLogosPerLocation', 'locationId', locationId)
            const localVarPath = `/brands/logos/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getBrandPerLocation', 'locationId', locationId)
            const localVarPath = `/brands/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsPerLocationIds: async (requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getBrandsPerLocationIds', 'requestBody', requestBody)
            const localVarPath = `/brands/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrdIconsPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDrdIconsPerLocation', 'locationId', locationId)
            const localVarPath = `/brands/location/drd-icons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand: async (brandDto: BrandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandDto' is not null or undefined
            assertParamExists('updateBrand', 'brandDto', brandDto)
            const localVarPath = `/brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(brandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandLogos: async (brandId: string, logoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'brandId' is not null or undefined
            assertParamExists('updateBrandLogos', 'brandId', brandId)
            // verify required parameter 'logoId' is not null or undefined
            assertParamExists('updateBrandLogos', 'logoId', logoId)
            const localVarPath = `/brands/{brandId}/logo/{logoId}`
                .replace(`{${"brandId"}}`, encodeURIComponent(String(brandId)))
                .replace(`{${"logoId"}}`, encodeURIComponent(String(logoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} logoId 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogoAltText: async (logoId: string, altText: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logoId' is not null or undefined
            assertParamExists('updateLogoAltText', 'logoId', logoId)
            // verify required parameter 'altText' is not null or undefined
            assertParamExists('updateLogoAltText', 'altText', altText)
            const localVarPath = `/brands/{logoId}/logo/altText`
                .replace(`{${"logoId"}}`, encodeURIComponent(String(logoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (altText !== undefined) {
                localVarQueryParameter['altText'] = altText;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBackgroundImage: async (id: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadBackgroundImage', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadBackgroundImage', 'file', file)
            const localVarPath = `/brands/{id}/background-image/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFont: async (id: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadFont', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFont', 'file', file)
            const localVarPath = `/brands/{id}/font/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo: async (id: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadLogo', 'id', id)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadLogo', 'file', file)
            const localVarPath = `/brands/{id}/logo/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsResourceApi - functional programming interface
 * @export
 */
export const BrandsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearBrand(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearBrand(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} copyFromLocId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyFromLocation(id: string, copyFromLocId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyFromLocation(id, copyFromLocId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBrand(brandDto: BrandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBrand(brandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrand(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrand(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandColor(brandId: string, colorCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandColor(brandId, colorCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandLogo(logoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandLogo(logoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} proFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandProFont(proFontId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandProFont(proFontId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} uploadedFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBrandUploadedFont(uploadedFontId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBrandUploadedFont(uploadedFontId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTeamBrandsPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTeamBrandsPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrand(id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrand(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandLogosPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandLogoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandLogosPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrandsPerLocationIds(requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrandsPerLocationIds(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrdIconsPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrandKitDrdIconDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrdIconsPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrand(brandDto: BrandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrand(brandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBrandLogos(brandId: string, logoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBrandLogos(brandId, logoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} logoId 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLogoAltText(logoId: string, altText: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandLogoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogoAltText(logoId, altText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBackgroundImage(id: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandBackgroundImageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBackgroundImage(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFont(id: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandUploadedFontDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFont(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLogo(id: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandLogoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLogo(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrandsResourceApi - factory interface
 * @export
 */
export const BrandsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBrand(id: string, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.clearBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} copyFromLocId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyFromLocation(id: string, copyFromLocId: number, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.copyFromLocation(id, copyFromLocId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBrand(brandDto: BrandDto, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.createBrand(brandDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrand(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} colorCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandColor(brandId: string, colorCode: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrandColor(brandId, colorCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandLogo(logoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrandLogo(logoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} proFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandProFont(proFontId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrandProFont(proFontId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} uploadedFontId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBrandUploadedFont(uploadedFontId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteBrandUploadedFont(uploadedFontId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamBrandsPerLocation(locationId: number, options?: any): AxiosPromise<Array<BrandDto>> {
            return localVarFp.getAllTeamBrandsPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrand(id?: string, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.getBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandLogosPerLocation(locationId: number, options?: any): AxiosPromise<Array<BrandLogoDto>> {
            return localVarFp.getBrandLogosPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandPerLocation(locationId: number, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.getBrandPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrandsPerLocationIds(requestBody: Array<number>, options?: any): AxiosPromise<Array<BrandDto>> {
            return localVarFp.getBrandsPerLocationIds(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrdIconsPerLocation(locationId: number, options?: any): AxiosPromise<Array<BrandKitDrdIconDto>> {
            return localVarFp.getDrdIconsPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BrandDto} brandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrand(brandDto: BrandDto, options?: any): AxiosPromise<BrandDto> {
            return localVarFp.updateBrand(brandDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} brandId 
         * @param {string} logoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBrandLogos(brandId: string, logoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateBrandLogos(brandId, logoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} logoId 
         * @param {string} altText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLogoAltText(logoId: string, altText: string, options?: any): AxiosPromise<BrandLogoDto> {
            return localVarFp.updateLogoAltText(logoId, altText, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBackgroundImage(id: string, file: any, options?: any): AxiosPromise<BrandBackgroundImageDto> {
            return localVarFp.uploadBackgroundImage(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFont(id: string, file: any, options?: any): AxiosPromise<BrandUploadedFontDto> {
            return localVarFp.uploadFont(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(id: string, file: any, options?: any): AxiosPromise<BrandLogoDto> {
            return localVarFp.uploadLogo(id, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandsResourceApi - object-oriented interface
 * @export
 * @class BrandsResourceApi
 * @extends {BaseAPI}
 */
export class BrandsResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public clearBrand(id: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).clearBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} copyFromLocId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public copyFromLocation(id: string, copyFromLocId: number, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).copyFromLocation(id, copyFromLocId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BrandDto} brandDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public createBrand(brandDto: BrandDto, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).createBrand(brandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public deleteBrand(id: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).deleteBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandId 
     * @param {string} colorCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public deleteBrandColor(brandId: string, colorCode: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).deleteBrandColor(brandId, colorCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} logoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public deleteBrandLogo(logoId: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).deleteBrandLogo(logoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} proFontId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public deleteBrandProFont(proFontId: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).deleteBrandProFont(proFontId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} uploadedFontId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public deleteBrandUploadedFont(uploadedFontId: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).deleteBrandUploadedFont(uploadedFontId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getAllTeamBrandsPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getAllTeamBrandsPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getBrand(id?: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getBrandLogosPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getBrandLogosPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getBrandPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getBrandPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getBrandsPerLocationIds(requestBody: Array<number>, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getBrandsPerLocationIds(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public getDrdIconsPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).getDrdIconsPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BrandDto} brandDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public updateBrand(brandDto: BrandDto, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).updateBrand(brandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} brandId 
     * @param {string} logoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public updateBrandLogos(brandId: string, logoId: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).updateBrandLogos(brandId, logoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} logoId 
     * @param {string} altText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public updateLogoAltText(logoId: string, altText: string, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).updateLogoAltText(logoId, altText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public uploadBackgroundImage(id: string, file: any, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).uploadBackgroundImage(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public uploadFont(id: string, file: any, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).uploadFont(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsResourceApi
     */
    public uploadLogo(id: string, file: any, options?: AxiosRequestConfig) {
        return BrandsResourceApiFp(this.configuration).uploadLogo(id, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BulkInviteResourceApi - axios parameter creator
 * @export
 */
export const BulkInviteResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteDto} bulkInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInvite: async (teamId: string, bulkInviteDto: BulkInviteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('bulkInvite', 'teamId', teamId)
            // verify required parameter 'bulkInviteDto' is not null or undefined
            assertParamExists('bulkInvite', 'bulkInviteDto', bulkInviteDto)
            const localVarPath = `/teams/{teamId}/bulk-invite`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteValidateDto} bulkInviteValidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate: async (teamId: string, bulkInviteValidateDto: BulkInviteValidateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('validate', 'teamId', teamId)
            // verify required parameter 'bulkInviteValidateDto' is not null or undefined
            assertParamExists('validate', 'bulkInviteValidateDto', bulkInviteValidateDto)
            const localVarPath = `/teams/{teamId}/bulk-invite/validate`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteValidateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BulkInviteResourceApi - functional programming interface
 * @export
 */
export const BulkInviteResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BulkInviteResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteDto} bulkInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkInvite(teamId: string, bulkInviteDto: BulkInviteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkInviteResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkInvite(teamId, bulkInviteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteValidateDto} bulkInviteValidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validate(teamId: string, bulkInviteValidateDto: BulkInviteValidateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BulkInviteEmailIssueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validate(teamId, bulkInviteValidateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BulkInviteResourceApi - factory interface
 * @export
 */
export const BulkInviteResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BulkInviteResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteDto} bulkInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInvite(teamId: string, bulkInviteDto: BulkInviteDto, options?: any): AxiosPromise<BulkInviteResultDto> {
            return localVarFp.bulkInvite(teamId, bulkInviteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {BulkInviteValidateDto} bulkInviteValidateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validate(teamId: string, bulkInviteValidateDto: BulkInviteValidateDto, options?: any): AxiosPromise<Array<BulkInviteEmailIssueDto>> {
            return localVarFp.validate(teamId, bulkInviteValidateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BulkInviteResourceApi - object-oriented interface
 * @export
 * @class BulkInviteResourceApi
 * @extends {BaseAPI}
 */
export class BulkInviteResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} teamId 
     * @param {BulkInviteDto} bulkInviteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkInviteResourceApi
     */
    public bulkInvite(teamId: string, bulkInviteDto: BulkInviteDto, options?: AxiosRequestConfig) {
        return BulkInviteResourceApiFp(this.configuration).bulkInvite(teamId, bulkInviteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {BulkInviteValidateDto} bulkInviteValidateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BulkInviteResourceApi
     */
    public validate(teamId: string, bulkInviteValidateDto: BulkInviteValidateDto, options?: AxiosRequestConfig) {
        return BulkInviteResourceApiFp(this.configuration).validate(teamId, bulkInviteValidateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CategoryResourceApi - axios parameter creator
 * @export
 */
export const CategoryResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrowseSubcats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/categories/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageableCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/categories/pages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchableCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/categories/searchable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryResourceApi - functional programming interface
 * @export
 */
export const CategoryResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBrowseSubcats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBrowseSubcats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPageableCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPageableCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearchableCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearchableCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoryResourceApi - factory interface
 * @export
 */
export const CategoryResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBrowseSubcats(options?: any): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.getBrowseSubcats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPageableCategories(options?: any): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.getPageableCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchableCategories(options?: any): AxiosPromise<Array<CategoryDto>> {
            return localVarFp.getSearchableCategories(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoryResourceApi - object-oriented interface
 * @export
 * @class CategoryResourceApi
 * @extends {BaseAPI}
 */
export class CategoryResourceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryResourceApi
     */
    public getBrowseSubcats(options?: AxiosRequestConfig) {
        return CategoryResourceApiFp(this.configuration).getBrowseSubcats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryResourceApi
     */
    public getPageableCategories(options?: AxiosRequestConfig) {
        return CategoryResourceApiFp(this.configuration).getPageableCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryResourceApi
     */
    public getSearchableCategories(options?: AxiosRequestConfig) {
        return CategoryResourceApiFp(this.configuration).getSearchableCategories(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardResourceApi - axios parameter creator
 * @export
 */
export const DashboardResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/fonts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaydiantDesigns: async (token: string, locationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getRaydiantDesigns', 'token', token)
            const localVarPath = `/public/raydiant/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaydiantLocations: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getRaydiantLocations', 'token', token)
            const localVarPath = `/public/raydiant/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intercomData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/dashboard/intercomData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateOAuthToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('invalidateOAuthToken', 'token', token)
            const localVarPath = `/public/oauth/token/invalidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOAuthToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyOAuthToken', 'token', token)
            const localVarPath = `/public/oauth/token/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardResourceApi - functional programming interface
 * @export
 */
export const DashboardResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFonts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TimberFont>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFonts(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOAuthToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOAuthToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRaydiantDesigns(token: string, locationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRaydiantDesigns(token, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRaydiantLocations(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRaydiantLocations(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async intercomData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntercomDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.intercomData(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateOAuthToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateOAuthToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async status(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.status(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOAuthToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOAuthToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardResourceApi - factory interface
 * @export
 */
export const DashboardResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFonts(options?: any): AxiosPromise<Array<TimberFont>> {
            return localVarFp.getFonts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOAuthToken(options?: any): AxiosPromise<string> {
            return localVarFp.getOAuthToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {number} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaydiantDesigns(token: string, locationId?: number, options?: any): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.getRaydiantDesigns(token, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRaydiantLocations(token: string, options?: any): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.getRaydiantLocations(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intercomData(options?: any): AxiosPromise<IntercomDataDto> {
            return localVarFp.intercomData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateOAuthToken(token: string, options?: any): AxiosPromise<string> {
            return localVarFp.invalidateOAuthToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options?: any): AxiosPromise<DashboardDto> {
            return localVarFp.status(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOAuthToken(token: string, options?: any): AxiosPromise<string> {
            return localVarFp.verifyOAuthToken(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardResourceApi - object-oriented interface
 * @export
 * @class DashboardResourceApi
 * @extends {BaseAPI}
 */
export class DashboardResourceApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public getFonts(options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).getFonts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public getOAuthToken(options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).getOAuthToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {number} [locationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public getRaydiantDesigns(token: string, locationId?: number, options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).getRaydiantDesigns(token, locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public getRaydiantLocations(token: string, options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).getRaydiantLocations(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public intercomData(options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).intercomData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public invalidateOAuthToken(token: string, options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).invalidateOAuthToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public status(options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).status(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardResourceApi
     */
    public verifyOAuthToken(token: string, options?: AxiosRequestConfig) {
        return DashboardResourceApiFp(this.configuration).verifyOAuthToken(token, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DesignResourceApi - axios parameter creator
 * @export
 */
export const DesignResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderToFolder: async (childFolderId: number, parentFolderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childFolderId' is not null or undefined
            assertParamExists('addFolderToFolder', 'childFolderId', childFolderId)
            // verify required parameter 'parentFolderId' is not null or undefined
            assertParamExists('addFolderToFolder', 'parentFolderId', parentFolderId)
            const localVarPath = `/designs/folder/putfolder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (childFolderId !== undefined) {
                localVarQueryParameter['childFolderId'] = childFolderId;
            }

            if (parentFolderId !== undefined) {
                localVarQueryParameter['parentFolderId'] = parentFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeFolderRequest} changeFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFolder: async (id: string, changeFolderRequest: ChangeFolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeFolder', 'id', id)
            // verify required parameter 'changeFolderRequest' is not null or undefined
            assertParamExists('changeFolder', 'changeFolderRequest', changeFolderRequest)
            const localVarPath = `/designs/{id}/folder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLocation: async (id: string, changeLocationRequest: ChangeLocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeLocation', 'id', id)
            // verify required parameter 'changeLocationRequest' is not null or undefined
            assertParamExists('changeLocation', 'changeLocationRequest', changeLocationRequest)
            const localVarPath = `/designs/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLocationPDFUpload: async (id: string, changeLocationRequest: ChangeLocationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('changeLocationPDFUpload', 'id', id)
            // verify required parameter 'changeLocationRequest' is not null or undefined
            assertParamExists('changeLocationPDFUpload', 'changeLocationRequest', changeLocationRequest)
            const localVarPath = `/designs/uploaded/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CopyDesignRequest} copyDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy: async (id: string, copyDesignRequest: CopyDesignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('copy', 'id', id)
            // verify required parameter 'copyDesignRequest' is not null or undefined
            assertParamExists('copy', 'copyDesignRequest', copyDesignRequest)
            const localVarPath = `/designs/{id}/copy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(copyDesignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesigns: async (ids: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteDesigns', 'ids', ids)
            const localVarPath = `/designs/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesign: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDesign', 'id', id)
            const localVarPath = `/designs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge: async (ids: Array<string>, name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('merge', 'ids', ids)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('merge', 'name', name)
            const localVarPath = `/designs/merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideFolderCount: async (folderId: number, count: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('overrideFolderCount', 'folderId', folderId)
            // verify required parameter 'count' is not null or undefined
            assertParamExists('overrideFolderCount', 'count', count)
            const localVarPath = `/designs/folder/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {number} folderId 
         * @param {number} [oldFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInFolder: async (ids: Array<string>, folderId: number, oldFolderId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('putInFolder', 'ids', ids)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('putInFolder', 'folderId', folderId)
            const localVarPath = `/designs/folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (oldFolderId !== undefined) {
                localVarQueryParameter['oldFolderId'] = oldFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderFromFolder: async (childFolderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childFolderId' is not null or undefined
            assertParamExists('removeFolderFromFolder', 'childFolderId', childFolderId)
            const localVarPath = `/designs/folder/putfolder/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (childFolderId !== undefined) {
                localVarQueryParameter['childFolderId'] = childFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromFolder: async (ids: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('removeFromFolder', 'ids', ids)
            const localVarPath = `/designs/folder/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {RenameDesignRequest} renameDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rename: async (id: string, renameDesignRequest: RenameDesignRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rename', 'id', id)
            // verify required parameter 'renameDesignRequest' is not null or undefined
            assertParamExists('rename', 'renameDesignRequest', renameDesignRequest)
            const localVarPath = `/designs/{id}/name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameDesignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DesignResourceApi - functional programming interface
 * @export
 */
export const DesignResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DesignResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFolderToFolder(childFolderId: number, parentFolderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFolderToFolder(childFolderId, parentFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeFolderRequest} changeFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeFolder(id: string, changeFolderRequest: ChangeFolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeFolder(id, changeFolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeLocation(id: string, changeLocationRequest: ChangeLocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeLocation(id, changeLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeLocationPDFUpload(id: string, changeLocationRequest: ChangeLocationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeLocationPDFUpload(id, changeLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CopyDesignRequest} copyDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copy(id: string, copyDesignRequest: CopyDesignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copy(id, copyDesignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDesigns(ids: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDesigns(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesign(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merge(ids: Array<string>, name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merge(ids, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideFolderCount(folderId: number, count: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideFolderCount(folderId, count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {number} folderId 
         * @param {number} [oldFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putInFolder(ids: Array<string>, folderId: number, oldFolderId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putInFolder(ids, folderId, oldFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFolderFromFolder(childFolderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFolderFromFolder(childFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromFolder(ids: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromFolder(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {RenameDesignRequest} renameDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rename(id: string, renameDesignRequest: RenameDesignRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rename(id, renameDesignRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DesignResourceApi - factory interface
 * @export
 */
export const DesignResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DesignResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderToFolder(childFolderId: number, parentFolderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.addFolderToFolder(childFolderId, parentFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeFolderRequest} changeFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeFolder(id: string, changeFolderRequest: ChangeFolderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.changeFolder(id, changeFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLocation(id: string, changeLocationRequest: ChangeLocationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.changeLocation(id, changeLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ChangeLocationRequest} changeLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeLocationPDFUpload(id: string, changeLocationRequest: ChangeLocationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.changeLocationPDFUpload(id, changeLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CopyDesignRequest} copyDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copy(id: string, copyDesignRequest: CopyDesignRequest, options?: any): AxiosPromise<DesignDto> {
            return localVarFp.copy(id, copyDesignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDesigns(ids: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDesigns(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesign(id: string, options?: any): AxiosPromise<DesignDto> {
            return localVarFp.getDesign(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(ids: Array<string>, name: string, options?: any): AxiosPromise<DesignDto> {
            return localVarFp.merge(ids, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideFolderCount(folderId: number, count: number, options?: any): AxiosPromise<void> {
            return localVarFp.overrideFolderCount(folderId, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {number} folderId 
         * @param {number} [oldFolderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putInFolder(ids: Array<string>, folderId: number, oldFolderId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.putInFolder(ids, folderId, oldFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderFromFolder(childFolderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeFolderFromFolder(childFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromFolder(ids: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.removeFromFolder(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {RenameDesignRequest} renameDesignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rename(id: string, renameDesignRequest: RenameDesignRequest, options?: any): AxiosPromise<void> {
            return localVarFp.rename(id, renameDesignRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DesignResourceApi - object-oriented interface
 * @export
 * @class DesignResourceApi
 * @extends {BaseAPI}
 */
export class DesignResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} childFolderId 
     * @param {number} parentFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public addFolderToFolder(childFolderId: number, parentFolderId: number, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).addFolderToFolder(childFolderId, parentFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ChangeFolderRequest} changeFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public changeFolder(id: string, changeFolderRequest: ChangeFolderRequest, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).changeFolder(id, changeFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ChangeLocationRequest} changeLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public changeLocation(id: string, changeLocationRequest: ChangeLocationRequest, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).changeLocation(id, changeLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ChangeLocationRequest} changeLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public changeLocationPDFUpload(id: string, changeLocationRequest: ChangeLocationRequest, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).changeLocationPDFUpload(id, changeLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CopyDesignRequest} copyDesignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public copy(id: string, copyDesignRequest: CopyDesignRequest, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).copy(id, copyDesignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public deleteDesigns(ids: Array<string>, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).deleteDesigns(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public getDesign(id: string, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).getDesign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public merge(ids: Array<string>, name: string, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).merge(ids, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {number} count 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public overrideFolderCount(folderId: number, count: number, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).overrideFolderCount(folderId, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {number} folderId 
     * @param {number} [oldFolderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public putInFolder(ids: Array<string>, folderId: number, oldFolderId?: number, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).putInFolder(ids, folderId, oldFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} childFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public removeFolderFromFolder(childFolderId: number, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).removeFolderFromFolder(childFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public removeFromFolder(ids: Array<string>, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).removeFromFolder(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {RenameDesignRequest} renameDesignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DesignResourceApi
     */
    public rename(id: string, renameDesignRequest: RenameDesignRequest, options?: AxiosRequestConfig) {
        return DesignResourceApiFp(this.configuration).rename(id, renameDesignRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DrdResourceApi - axios parameter creator
 * @export
 */
export const DrdResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunity: async (diningRDCommunityDto: DiningRDCommunityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'diningRDCommunityDto' is not null or undefined
            assertParamExists('createCommunity', 'diningRDCommunityDto', diningRDCommunityDto)
            const localVarPath = `/drd/communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diningRDCommunityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunity: async (communityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteCommunity', 'communityId', communityId)
            const localVarPath = `/drd/communities/{communityId}`
                .replace(`{${"communityId"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunities: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/drd/communities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} communityId 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunity: async (communityId: number, diningRDCommunityDto: DiningRDCommunityDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCommunity', 'communityId', communityId)
            // verify required parameter 'diningRDCommunityDto' is not null or undefined
            assertParamExists('updateCommunity', 'diningRDCommunityDto', diningRDCommunityDto)
            const localVarPath = `/drd/communities/{communityId}`
                .replace(`{${"communityId"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diningRDCommunityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrdResourceApi - functional programming interface
 * @export
 */
export const DrdResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrdResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommunity(diningRDCommunityDto: DiningRDCommunityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiningRDCommunityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommunity(diningRDCommunityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommunity(communityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommunity(communityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunities(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiningRDCommunityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunities(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} communityId 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunity(communityId: number, diningRDCommunityDto: DiningRDCommunityDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiningRDCommunityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunity(communityId, diningRDCommunityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DrdResourceApi - factory interface
 * @export
 */
export const DrdResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrdResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunity(diningRDCommunityDto: DiningRDCommunityDto, options?: any): AxiosPromise<DiningRDCommunityDto> {
            return localVarFp.createCommunity(diningRDCommunityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunity(communityId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCommunity(communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunities(options?: any): AxiosPromise<Array<DiningRDCommunityDto>> {
            return localVarFp.getCommunities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} communityId 
         * @param {DiningRDCommunityDto} diningRDCommunityDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunity(communityId: number, diningRDCommunityDto: DiningRDCommunityDto, options?: any): AxiosPromise<DiningRDCommunityDto> {
            return localVarFp.updateCommunity(communityId, diningRDCommunityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DrdResourceApi - object-oriented interface
 * @export
 * @class DrdResourceApi
 * @extends {BaseAPI}
 */
export class DrdResourceApi extends BaseAPI {
    /**
     * 
     * @param {DiningRDCommunityDto} diningRDCommunityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrdResourceApi
     */
    public createCommunity(diningRDCommunityDto: DiningRDCommunityDto, options?: AxiosRequestConfig) {
        return DrdResourceApiFp(this.configuration).createCommunity(diningRDCommunityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} communityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrdResourceApi
     */
    public deleteCommunity(communityId: number, options?: AxiosRequestConfig) {
        return DrdResourceApiFp(this.configuration).deleteCommunity(communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrdResourceApi
     */
    public getCommunities(options?: AxiosRequestConfig) {
        return DrdResourceApiFp(this.configuration).getCommunities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} communityId 
     * @param {DiningRDCommunityDto} diningRDCommunityDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DrdResourceApi
     */
    public updateCommunity(communityId: number, diningRDCommunityDto: DiningRDCommunityDto, options?: AxiosRequestConfig) {
        return DrdResourceApiFp(this.configuration).updateCommunity(communityId, diningRDCommunityDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DsaResourceApi - axios parameter creator
 * @export
 */
export const DsaResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDsaFolderToFolder: async (childFolderId: number, parentFolderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childFolderId' is not null or undefined
            assertParamExists('addDsaFolderToFolder', 'childFolderId', childFolderId)
            // verify required parameter 'parentFolderId' is not null or undefined
            assertParamExists('addDsaFolderToFolder', 'parentFolderId', parentFolderId)
            const localVarPath = `/dsa/folder/putfolder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (childFolderId !== undefined) {
                localVarQueryParameter['childFolderId'] = childFolderId;
            }

            if (parentFolderId !== undefined) {
                localVarQueryParameter['parentFolderId'] = parentFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScheduleEvent: async (id: string, dsaScheduleEventDto: DsaScheduleEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addScheduleEvent', 'id', id)
            // verify required parameter 'dsaScheduleEventDto' is not null or undefined
            assertParamExists('addScheduleEvent', 'dsaScheduleEventDto', dsaScheduleEventDto)
            const localVarPath = `/dsa/schedules/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScreen: async (dsaScreenAddDto: DsaScreenAddDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaScreenAddDto' is not null or undefined
            assertParamExists('addScreen', 'dsaScreenAddDto', dsaScreenAddDto)
            const localVarPath = `/dsa/screens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScreenAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaBoardDto} dsaBoardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard: async (dsaBoardDto: DsaBoardDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaBoardDto' is not null or undefined
            assertParamExists('createBoard', 'dsaBoardDto', dsaBoardDto)
            const localVarPath = `/dsa/boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaBoardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaylist: async (dsaPlaylistDto: DsaPlaylistDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaPlaylistDto' is not null or undefined
            assertParamExists('createPlaylist', 'dsaPlaylistDto', dsaPlaylistDto)
            const localVarPath = `/dsa/playlists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaPlaylistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaScheduleDto} dsaScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: async (dsaScheduleDto: DsaScheduleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaScheduleDto' is not null or undefined
            assertParamExists('createSchedule', 'dsaScheduleDto', dsaScheduleDto)
            const localVarPath = `/dsa/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduleRotation: async (dsaScheduleRotationDto: DsaScheduleRotationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaScheduleRotationDto' is not null or undefined
            assertParamExists('createScheduleRotation', 'dsaScheduleRotationDto', dsaScheduleRotationDto)
            const localVarPath = `/dsa/schedule-rotations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleRotationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaylist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePlaylist', 'id', id)
            const localVarPath = `/dsa/playlists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSchedule', 'id', id)
            const localVarPath = `/dsa/schedules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} scheduleId 
         * @param {DsaDeleteScheduleEventDto} dsaDeleteScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleEvent: async (scheduleId: string, dsaDeleteScheduleEventDto: DsaDeleteScheduleEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('deleteScheduleEvent', 'scheduleId', scheduleId)
            // verify required parameter 'dsaDeleteScheduleEventDto' is not null or undefined
            assertParamExists('deleteScheduleEvent', 'dsaDeleteScheduleEventDto', dsaDeleteScheduleEventDto)
            const localVarPath = `/dsa/schedules/{scheduleId}/event/remove`
                .replace(`{${"scheduleId"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaDeleteScheduleEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleRotation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteScheduleRotation', 'id', id)
            const localVarPath = `/dsa/schedule-rotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScreen: async (serial: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('deleteScreen', 'serial', serial)
            const localVarPath = `/dsa/screens/{serial}`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getBoard', 'id', id)
            const localVarPath = `/dsa/boards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoards: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/boards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeactivatedScreens: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/screens/deactivated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignDisplayStatus: async (designId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('getDesignDisplayStatus', 'designId', designId)
            const localVarPath = `/dsa/screens/design/{designId}`
                .replace(`{${"designId"}}`, encodeURIComponent(String(designId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDsaUploadFolderAssignments: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDsaUploadFolderAssignments', 'locationId', locationId)
            const localVarPath = `/dsa/uploads/folder/assignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaylist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPlaylist', 'id', id)
            const localVarPath = `/dsa/playlists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaylists: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/playlists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleRotations: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getScheduleRotations', 'id', id)
            const localVarPath = `/dsa/schedules/{id}/rotations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedules: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreens: async (includeDetails?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/screens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDetails !== undefined) {
                localVarQueryParameter['includeDetails'] = includeDetails;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensDetails: async (requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getScreensDetails', 'requestBody', requestBody)
            const localVarPath = `/dsa/screens/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensPerLocation: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getScreensPerLocation', 'locationId', locationId)
            const localVarPath = `/dsa/screens/location/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensTotal: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/screens/total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideDsaFolderCount: async (folderId: number, count: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('overrideDsaFolderCount', 'folderId', folderId)
            // verify required parameter 'count' is not null or undefined
            assertParamExists('overrideDsaFolderCount', 'count', count)
            const localVarPath = `/dsa/uploads/folder/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDsaUploadsInFolder: async (uploadIds: Array<string>, folderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadIds' is not null or undefined
            assertParamExists('putDsaUploadsInFolder', 'uploadIds', uploadIds)
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('putDsaUploadsInFolder', 'folderId', folderId)
            const localVarPath = `/dsa/uploads/folder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uploadIds) {
                localVarQueryParameter['uploadIds'] = uploadIds;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDsaFolderFromFolder: async (childFolderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childFolderId' is not null or undefined
            assertParamExists('removeDsaFolderFromFolder', 'childFolderId', childFolderId)
            const localVarPath = `/dsa/folder/putfolder/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (childFolderId !== undefined) {
                localVarQueryParameter['childFolderId'] = childFolderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDsaUploadsFromFolder: async (uploadIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadIds' is not null or undefined
            assertParamExists('removeDsaUploadsFromFolder', 'uploadIds', uploadIds)
            const localVarPath = `/dsa/uploads/folder/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uploadIds) {
                localVarQueryParameter['uploadIds'] = uploadIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeScreenContent: async (serial: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('removeScreenContent', 'serial', serial)
            const localVarPath = `/dsa/screens/{serial}/content`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {SendDeviceComandDto} sendDeviceComandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDeviceCommand: async (serial: string, sendDeviceComandDto: SendDeviceComandDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('sendDeviceCommand', 'serial', serial)
            // verify required parameter 'sendDeviceComandDto' is not null or undefined
            assertParamExists('sendDeviceCommand', 'sendDeviceComandDto', sendDeviceComandDto)
            const localVarPath = `/dsa/screens/{serial}/command`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendDeviceComandDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setScreenContent: async (serial: string, dsaContentDto: DsaContentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('setScreenContent', 'serial', serial)
            // verify required parameter 'dsaContentDto' is not null or undefined
            assertParamExists('setScreenContent', 'dsaContentDto', dsaContentDto)
            const localVarPath = `/dsa/screens/{serial}/content`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockPlaylist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('toggleLockPlaylist', 'id', id)
            const localVarPath = `/dsa/playlists/{id}/togglelock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockSchedule: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('toggleLockSchedule', 'id', id)
            const localVarPath = `/dsa/schedules/{id}/lock/toggle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockScreen: async (serial: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('toggleLockScreen', 'serial', serial)
            const localVarPath = `/dsa/screens/{serial}/togglelock`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlaylist: async (id: string, dsaPlaylistDto: DsaPlaylistDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePlaylist', 'id', id)
            // verify required parameter 'dsaPlaylistDto' is not null or undefined
            assertParamExists('updatePlaylist', 'dsaPlaylistDto', dsaPlaylistDto)
            const localVarPath = `/dsa/playlists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaPlaylistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleEvent: async (id: string, dsaScheduleEventDto: DsaScheduleEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateScheduleEvent', 'id', id)
            // verify required parameter 'dsaScheduleEventDto' is not null or undefined
            assertParamExists('updateScheduleEvent', 'dsaScheduleEventDto', dsaScheduleEventDto)
            const localVarPath = `/dsa/schedules/{id}/events/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DsaScheduleRenameDto} dsaScheduleRenameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleName: async (dsaScheduleRenameDto: DsaScheduleRenameDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dsaScheduleRenameDto' is not null or undefined
            assertParamExists('updateScheduleName', 'dsaScheduleRenameDto', dsaScheduleRenameDto)
            const localVarPath = `/dsa/schedules/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleRenameDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleRotation: async (id: string, dsaScheduleRotationDto: DsaScheduleRotationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateScheduleRotation', 'id', id)
            // verify required parameter 'dsaScheduleRotationDto' is not null or undefined
            assertParamExists('updateScheduleRotation', 'dsaScheduleRotationDto', dsaScheduleRotationDto)
            const localVarPath = `/dsa/schedule-rotations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScheduleRotationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreen: async (serial: string, dsaScreenAddDto: DsaScreenAddDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('updateScreen', 'serial', serial)
            // verify required parameter 'dsaScreenAddDto' is not null or undefined
            assertParamExists('updateScreen', 'dsaScreenAddDto', dsaScreenAddDto)
            const localVarPath = `/dsa/screens/{serial}/update`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaScreenAddDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {ScreenConfigDto} screenConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreenConfig: async (serial: string, screenConfigDto: ScreenConfigDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('updateScreenConfig', 'serial', serial)
            // verify required parameter 'screenConfigDto' is not null or undefined
            assertParamExists('updateScreenConfig', 'screenConfigDto', screenConfigDto)
            const localVarPath = `/dsa/screens/{serial}/config`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(screenConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreenContent: async (serial: string, dsaContentDto: DsaContentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serial' is not null or undefined
            assertParamExists('updateScreenContent', 'serial', serial)
            // verify required parameter 'dsaContentDto' is not null or undefined
            assertParamExists('updateScreenContent', 'dsaContentDto', dsaContentDto)
            const localVarPath = `/dsa/screens/{serial}/content`
                .replace(`{${"serial"}}`, encodeURIComponent(String(serial)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dsaContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userHasScreens: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dsa/userHasScreens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DsaResourceApi - functional programming interface
 * @export
 */
export const DsaResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DsaResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDsaFolderToFolder(childFolderId: number, parentFolderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDsaFolderToFolder(childFolderId, parentFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addScheduleEvent(id, dsaScheduleEventDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addScreen(dsaScreenAddDto: DsaScreenAddDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addScreen(dsaScreenAddDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaBoardDto} dsaBoardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBoard(dsaBoardDto: DsaBoardDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaBoardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBoard(dsaBoardDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPlaylist(dsaPlaylistDto: DsaPlaylistDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaPlaylistDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPlaylist(dsaPlaylistDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaScheduleDto} dsaScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSchedule(dsaScheduleDto: DsaScheduleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSchedule(dsaScheduleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScheduleRotation(dsaScheduleRotationDto: DsaScheduleRotationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleRotationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScheduleRotation(dsaScheduleRotationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePlaylist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePlaylist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSchedule(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSchedule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} scheduleId 
         * @param {DsaDeleteScheduleEventDto} dsaDeleteScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduleEvent(scheduleId: string, dsaDeleteScheduleEventDto: DsaDeleteScheduleEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduleEvent(scheduleId, dsaDeleteScheduleEventDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScheduleRotation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScheduleRotation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScreen(serial: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScreen(serial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoard(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaBoardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoard(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoards(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaBoardDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoards(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeactivatedScreens(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeactivatedScreens(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignDisplayStatus(designId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesignDisplayStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignDisplayStatus(designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDsaUploadFolderAssignments(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaUploadFolderAssignmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDsaUploadFolderAssignments(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaylist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaPlaylistDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaylist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlaylists(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaPlaylistDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlaylists(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScheduleRotations(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScheduleRotationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScheduleRotations(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchedules(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScheduleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchedules(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreens(includeDetails?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreens(includeDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreensDetails(requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreensDetails(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreensPerLocation(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaScreenDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreensPerLocation(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScreensTotal(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScreensTotal(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overrideDsaFolderCount(folderId: number, count: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overrideDsaFolderCount(folderId, count, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putDsaUploadsInFolder(uploadIds: Array<string>, folderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putDsaUploadsInFolder(uploadIds, folderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDsaFolderFromFolder(childFolderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDsaFolderFromFolder(childFolderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDsaUploadsFromFolder(uploadIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDsaUploadsFromFolder(uploadIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeScreenContent(serial: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeScreenContent(serial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {SendDeviceComandDto} sendDeviceComandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendDeviceCommand(serial: string, sendDeviceComandDto: SendDeviceComandDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendDeviceCommand(serial, sendDeviceComandDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setScreenContent(serial, dsaContentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleLockPlaylist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaPlaylistDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleLockPlaylist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleLockSchedule(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleLockSchedule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleLockScreen(serial: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleLockScreen(serial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlaylist(id: string, dsaPlaylistDto: DsaPlaylistDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaPlaylistDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlaylist(id, dsaPlaylistDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduleEvent(id, dsaScheduleEventDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DsaScheduleRenameDto} dsaScheduleRenameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduleName(dsaScheduleRenameDto: DsaScheduleRenameDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduleName(dsaScheduleRenameDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScheduleRotation(id: string, dsaScheduleRotationDto: DsaScheduleRotationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScheduleRotationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScheduleRotation(id, dsaScheduleRotationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScreen(serial: string, dsaScreenAddDto: DsaScreenAddDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScreen(serial, dsaScreenAddDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {ScreenConfigDto} screenConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScreenConfig(serial: string, screenConfigDto: ScreenConfigDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScreenConfig(serial, screenConfigDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaScreenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScreenContent(serial, dsaContentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userHasScreens(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userHasScreens(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DsaResourceApi - factory interface
 * @export
 */
export const DsaResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DsaResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} childFolderId 
         * @param {number} parentFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDsaFolderToFolder(childFolderId: number, parentFolderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.addDsaFolderToFolder(childFolderId, parentFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: any): AxiosPromise<DsaScheduleEventDto> {
            return localVarFp.addScheduleEvent(id, dsaScheduleEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addScreen(dsaScreenAddDto: DsaScreenAddDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.addScreen(dsaScreenAddDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaBoardDto} dsaBoardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBoard(dsaBoardDto: DsaBoardDto, options?: any): AxiosPromise<DsaBoardDto> {
            return localVarFp.createBoard(dsaBoardDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaylist(dsaPlaylistDto: DsaPlaylistDto, options?: any): AxiosPromise<DsaPlaylistDto> {
            return localVarFp.createPlaylist(dsaPlaylistDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaScheduleDto} dsaScheduleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule(dsaScheduleDto: DsaScheduleDto, options?: any): AxiosPromise<DsaScheduleDto> {
            return localVarFp.createSchedule(dsaScheduleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScheduleRotation(dsaScheduleRotationDto: DsaScheduleRotationDto, options?: any): AxiosPromise<DsaScheduleRotationDto> {
            return localVarFp.createScheduleRotation(dsaScheduleRotationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaylist(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePlaylist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSchedule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} scheduleId 
         * @param {DsaDeleteScheduleEventDto} dsaDeleteScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleEvent(scheduleId: string, dsaDeleteScheduleEventDto: DsaDeleteScheduleEventDto, options?: any): AxiosPromise<DsaScheduleDto> {
            return localVarFp.deleteScheduleEvent(scheduleId, dsaDeleteScheduleEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScheduleRotation(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteScheduleRotation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScreen(serial: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteScreen(serial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard(id: string, options?: any): AxiosPromise<DsaBoardDto> {
            return localVarFp.getBoard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoards(options?: any): AxiosPromise<Array<DsaBoardDto>> {
            return localVarFp.getBoards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeactivatedScreens(options?: any): AxiosPromise<number> {
            return localVarFp.getDeactivatedScreens(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignDisplayStatus(designId: string, options?: any): AxiosPromise<DesignDisplayStatusDto> {
            return localVarFp.getDesignDisplayStatus(designId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDsaUploadFolderAssignments(locationId: number, options?: any): AxiosPromise<Array<DsaUploadFolderAssignmentDto>> {
            return localVarFp.getDsaUploadFolderAssignments(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaylist(id: string, options?: any): AxiosPromise<DsaPlaylistDto> {
            return localVarFp.getPlaylist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaylists(options?: any): AxiosPromise<Array<DsaPlaylistDto>> {
            return localVarFp.getPlaylists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScheduleRotations(id: string, options?: any): AxiosPromise<Array<DsaScheduleRotationDto>> {
            return localVarFp.getScheduleRotations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedules(options?: any): AxiosPromise<Array<DsaScheduleDto>> {
            return localVarFp.getSchedules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [includeDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreens(includeDetails?: boolean, options?: any): AxiosPromise<Array<DsaScreenDto>> {
            return localVarFp.getScreens(includeDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensDetails(requestBody: Array<string>, options?: any): AxiosPromise<Array<DsaScreenDto>> {
            return localVarFp.getScreensDetails(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensPerLocation(locationId: number, options?: any): AxiosPromise<Array<DsaScreenDto>> {
            return localVarFp.getScreensPerLocation(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScreensTotal(options?: any): AxiosPromise<number> {
            return localVarFp.getScreensTotal(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {number} count 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overrideDsaFolderCount(folderId: number, count: number, options?: any): AxiosPromise<void> {
            return localVarFp.overrideDsaFolderCount(folderId, count, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putDsaUploadsInFolder(uploadIds: Array<string>, folderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.putDsaUploadsInFolder(uploadIds, folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} childFolderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDsaFolderFromFolder(childFolderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeDsaFolderFromFolder(childFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} uploadIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDsaUploadsFromFolder(uploadIds: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.removeDsaUploadsFromFolder(uploadIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeScreenContent(serial: string, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.removeScreenContent(serial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {SendDeviceComandDto} sendDeviceComandDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDeviceCommand(serial: string, sendDeviceComandDto: SendDeviceComandDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.sendDeviceCommand(serial, sendDeviceComandDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.setScreenContent(serial, dsaContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockPlaylist(id: string, options?: any): AxiosPromise<DsaPlaylistDto> {
            return localVarFp.toggleLockPlaylist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockSchedule(id: string, options?: any): AxiosPromise<DsaScheduleDto> {
            return localVarFp.toggleLockSchedule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleLockScreen(serial: string, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.toggleLockScreen(serial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaPlaylistDto} dsaPlaylistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlaylist(id: string, dsaPlaylistDto: DsaPlaylistDto, options?: any): AxiosPromise<DsaPlaylistDto> {
            return localVarFp.updatePlaylist(id, dsaPlaylistDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleEventDto} dsaScheduleEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: any): AxiosPromise<DsaScheduleEventDto> {
            return localVarFp.updateScheduleEvent(id, dsaScheduleEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DsaScheduleRenameDto} dsaScheduleRenameDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleName(dsaScheduleRenameDto: DsaScheduleRenameDto, options?: any): AxiosPromise<DsaScheduleDto> {
            return localVarFp.updateScheduleName(dsaScheduleRenameDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScheduleRotation(id: string, dsaScheduleRotationDto: DsaScheduleRotationDto, options?: any): AxiosPromise<DsaScheduleRotationDto> {
            return localVarFp.updateScheduleRotation(id, dsaScheduleRotationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaScreenAddDto} dsaScreenAddDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreen(serial: string, dsaScreenAddDto: DsaScreenAddDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.updateScreen(serial, dsaScreenAddDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {ScreenConfigDto} screenConfigDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreenConfig(serial: string, screenConfigDto: ScreenConfigDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.updateScreenConfig(serial, screenConfigDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serial 
         * @param {DsaContentDto} dsaContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: any): AxiosPromise<DsaScreenDto> {
            return localVarFp.updateScreenContent(serial, dsaContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userHasScreens(options?: any): AxiosPromise<boolean> {
            return localVarFp.userHasScreens(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DsaResourceApi - object-oriented interface
 * @export
 * @class DsaResourceApi
 * @extends {BaseAPI}
 */
export class DsaResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} childFolderId 
     * @param {number} parentFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public addDsaFolderToFolder(childFolderId: number, parentFolderId: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).addDsaFolderToFolder(childFolderId, parentFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DsaScheduleEventDto} dsaScheduleEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public addScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).addScheduleEvent(id, dsaScheduleEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaScreenAddDto} dsaScreenAddDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public addScreen(dsaScreenAddDto: DsaScreenAddDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).addScreen(dsaScreenAddDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaBoardDto} dsaBoardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public createBoard(dsaBoardDto: DsaBoardDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).createBoard(dsaBoardDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaPlaylistDto} dsaPlaylistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public createPlaylist(dsaPlaylistDto: DsaPlaylistDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).createPlaylist(dsaPlaylistDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaScheduleDto} dsaScheduleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public createSchedule(dsaScheduleDto: DsaScheduleDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).createSchedule(dsaScheduleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public createScheduleRotation(dsaScheduleRotationDto: DsaScheduleRotationDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).createScheduleRotation(dsaScheduleRotationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public deletePlaylist(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).deletePlaylist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public deleteSchedule(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).deleteSchedule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} scheduleId 
     * @param {DsaDeleteScheduleEventDto} dsaDeleteScheduleEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public deleteScheduleEvent(scheduleId: string, dsaDeleteScheduleEventDto: DsaDeleteScheduleEventDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).deleteScheduleEvent(scheduleId, dsaDeleteScheduleEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public deleteScheduleRotation(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).deleteScheduleRotation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public deleteScreen(serial: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).deleteScreen(serial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getBoard(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getBoard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getBoards(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getBoards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getDeactivatedScreens(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getDeactivatedScreens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} designId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getDesignDisplayStatus(designId: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getDesignDisplayStatus(designId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getDsaUploadFolderAssignments(locationId: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getDsaUploadFolderAssignments(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getPlaylist(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getPlaylist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getPlaylists(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getPlaylists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getScheduleRotations(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getScheduleRotations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getSchedules(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getSchedules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [includeDetails] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getScreens(includeDetails?: boolean, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getScreens(includeDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getScreensDetails(requestBody: Array<string>, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getScreensDetails(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getScreensPerLocation(locationId: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getScreensPerLocation(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public getScreensTotal(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).getScreensTotal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {number} count 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public overrideDsaFolderCount(folderId: number, count: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).overrideDsaFolderCount(folderId, count, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} uploadIds 
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public putDsaUploadsInFolder(uploadIds: Array<string>, folderId: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).putDsaUploadsInFolder(uploadIds, folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} childFolderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public removeDsaFolderFromFolder(childFolderId: number, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).removeDsaFolderFromFolder(childFolderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} uploadIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public removeDsaUploadsFromFolder(uploadIds: Array<string>, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).removeDsaUploadsFromFolder(uploadIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public removeScreenContent(serial: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).removeScreenContent(serial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {SendDeviceComandDto} sendDeviceComandDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public sendDeviceCommand(serial: string, sendDeviceComandDto: SendDeviceComandDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).sendDeviceCommand(serial, sendDeviceComandDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {DsaContentDto} dsaContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public setScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).setScreenContent(serial, dsaContentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public toggleLockPlaylist(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).toggleLockPlaylist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public toggleLockSchedule(id: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).toggleLockSchedule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public toggleLockScreen(serial: string, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).toggleLockScreen(serial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DsaPlaylistDto} dsaPlaylistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updatePlaylist(id: string, dsaPlaylistDto: DsaPlaylistDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updatePlaylist(id, dsaPlaylistDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DsaScheduleEventDto} dsaScheduleEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScheduleEvent(id: string, dsaScheduleEventDto: DsaScheduleEventDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScheduleEvent(id, dsaScheduleEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DsaScheduleRenameDto} dsaScheduleRenameDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScheduleName(dsaScheduleRenameDto: DsaScheduleRenameDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScheduleName(dsaScheduleRenameDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DsaScheduleRotationDto} dsaScheduleRotationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScheduleRotation(id: string, dsaScheduleRotationDto: DsaScheduleRotationDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScheduleRotation(id, dsaScheduleRotationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {DsaScreenAddDto} dsaScreenAddDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScreen(serial: string, dsaScreenAddDto: DsaScreenAddDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScreen(serial, dsaScreenAddDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {ScreenConfigDto} screenConfigDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScreenConfig(serial: string, screenConfigDto: ScreenConfigDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScreenConfig(serial, screenConfigDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serial 
     * @param {DsaContentDto} dsaContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public updateScreenContent(serial: string, dsaContentDto: DsaContentDto, options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).updateScreenContent(serial, dsaContentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DsaResourceApi
     */
    public userHasScreens(options?: AxiosRequestConfig) {
        return DsaResourceApiFp(this.configuration).userHasScreens(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationResourceApi - axios parameter creator
 * @export
 */
export const LocationResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsaLocationFolder: async (id: number, name: string, parentId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDsaLocationFolder', 'id', id)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createDsaLocationFolder', 'name', name)
            const localVarPath = `/locations/{id}/dsa/folder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {number} [memberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationFolder: async (id: number, name: string, parentId?: string, memberId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createLocationFolder', 'id', id)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createLocationFolder', 'name', name)
            const localVarPath = `/locations/{id}/folder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (parentId !== undefined) {
                localVarQueryParameter['parentId'] = parentId;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsaFolder: async (folderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteDsaFolder', 'folderId', folderId)
            const localVarPath = `/locations/dsa/folder/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (folderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolder', 'folderId', folderId)
            const localVarPath = `/locations/folder/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDsaLocationFolders: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDsaLocationFolders', 'id', id)
            const localVarPath = `/locations/{id}/dsa/folder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDesigns: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationDesigns', 'id', id)
            const localVarPath = `/locations/{id}/designs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDesignsForLocations: async (requestBody: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('getLocationDesignsForLocations', 'requestBody', requestBody)
            const localVarPath = `/locations/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationFolders: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationFolders', 'id', id)
            const localVarPath = `/locations/{id}/folder`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocationPermissions', 'id', id)
            const localVarPath = `/locations/{id}/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} locationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUserCounts: async (locationIds: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationIds' is not null or undefined
            assertParamExists('getLocationUserCounts', 'locationIds', locationIds)
            const localVarPath = `/locations/user-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationIds) {
                localVarQueryParameter['locationIds'] = locationIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDsaFolder: async (folderId: number, renameFolderRequest: RenameFolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameDsaFolder', 'folderId', folderId)
            // verify required parameter 'renameFolderRequest' is not null or undefined
            assertParamExists('renameDsaFolder', 'renameFolderRequest', renameFolderRequest)
            const localVarPath = `/locations/dsa/folder/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder: async (folderId: number, renameFolderRequest: RenameFolderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('renameFolder', 'folderId', folderId)
            // verify required parameter 'renameFolderRequest' is not null or undefined
            assertParamExists('renameFolder', 'renameFolderRequest', renameFolderRequest)
            const localVarPath = `/locations/folder/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renameFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationResourceApi - functional programming interface
 * @export
 */
export const LocationResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDsaLocationFolder(id: number, name: string, parentId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DsaUploadFolderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDsaLocationFolder(id, name, parentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {number} [memberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocationFolder(id: number, name: string, parentId?: string, memberId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MenuFolderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocationFolder(id, name, parentId, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDsaFolder(folderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDsaFolder(folderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(folderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(folderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDsaLocationFolders(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DsaUploadFolderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDsaLocationFolders(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationDesigns(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationDesigns(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationDesignsForLocations(requestBody: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<DesignDto>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationDesignsForLocations(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationFolders(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MenuFolderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationFolders(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationPermissions(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberLocationPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationPermissions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<number>} locationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationUserCounts(locationIds: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationUserCounts(locationIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameDsaFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameDsaFolder(folderId, renameFolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameFolder(folderId, renameFolderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationResourceApi - factory interface
 * @export
 */
export const LocationResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDsaLocationFolder(id: number, name: string, parentId?: string, options?: any): AxiosPromise<DsaUploadFolderDto> {
            return localVarFp.createDsaLocationFolder(id, name, parentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} name 
         * @param {string} [parentId] 
         * @param {number} [memberId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationFolder(id: number, name: string, parentId?: string, memberId?: number, options?: any): AxiosPromise<MenuFolderDto> {
            return localVarFp.createLocationFolder(id, name, parentId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDsaFolder(folderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDsaFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folderId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDsaLocationFolders(id: number, options?: any): AxiosPromise<Array<DsaUploadFolderDto>> {
            return localVarFp.getDsaLocationFolders(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDesigns(id: number, options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getLocationDesigns(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDesignsForLocations(requestBody: Array<number>, options?: any): AxiosPromise<{ [key: string]: Array<DesignDto>; }> {
            return localVarFp.getLocationDesignsForLocations(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationFolders(id: number, options?: any): AxiosPromise<Array<MenuFolderDto>> {
            return localVarFp.getLocationFolders(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions(id: number, options?: any): AxiosPromise<Array<MemberLocationPermissionDto>> {
            return localVarFp.getLocationPermissions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<number>} locationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUserCounts(locationIds: Array<number>, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getLocationUserCounts(locationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameDsaFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.renameDsaFolder(folderId, renameFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} folderId 
         * @param {RenameFolderRequest} renameFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.renameFolder(folderId, renameFolderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationResourceApi - object-oriented interface
 * @export
 * @class LocationResourceApi
 * @extends {BaseAPI}
 */
export class LocationResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} name 
     * @param {string} [parentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public createDsaLocationFolder(id: number, name: string, parentId?: string, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).createDsaLocationFolder(id, name, parentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} name 
     * @param {string} [parentId] 
     * @param {number} [memberId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public createLocationFolder(id: number, name: string, parentId?: string, memberId?: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).createLocationFolder(id, name, parentId, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public deleteDsaFolder(folderId: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).deleteDsaFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public deleteFolder(folderId: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).deleteFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getDsaLocationFolders(id: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getDsaLocationFolders(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getLocationDesigns(id: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getLocationDesigns(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getLocationDesignsForLocations(requestBody: Array<number>, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getLocationDesignsForLocations(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getLocationFolders(id: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getLocationFolders(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getLocationPermissions(id: number, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getLocationPermissions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<number>} locationIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public getLocationUserCounts(locationIds: Array<number>, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).getLocationUserCounts(locationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {RenameFolderRequest} renameFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public renameDsaFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).renameDsaFolder(folderId, renameFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} folderId 
     * @param {RenameFolderRequest} renameFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationResourceApi
     */
    public renameFolder(folderId: number, renameFolderRequest: RenameFolderRequest, options?: AxiosRequestConfig) {
        return LocationResourceApiFp(this.configuration).renameFolder(folderId, renameFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocationsResourceApi - axios parameter creator
 * @export
 */
export const LocationsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AssignPosLocation} assignPosLocation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPopmenuLocation: async (assignPosLocation: AssignPosLocation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignPosLocation' is not null or undefined
            assertParamExists('assignPopmenuLocation', 'assignPosLocation', assignPosLocation)
            const localVarPath = `/locations/assign/pos/popmenu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignPosLocation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLocation', 'id', id)
            const localVarPath = `/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [internalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (id?: string, internalId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (internalId !== undefined) {
                localVarQueryParameter['internalId'] = internalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUserCount: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationUserCount', 'locationId', locationId)
            const localVarPath = `/locations/user-count/{locationId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferFilesDto} transferFilesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferDigitalProducts: async (transferFilesDto: TransferFilesDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferFilesDto' is not null or undefined
            assertParamExists('transferDigitalProducts', 'transferFilesDto', transferFilesDto)
            const localVarPath = `/locations/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferFilesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountLocationDto} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (accountLocationDto: AccountLocationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountLocationDto' is not null or undefined
            assertParamExists('updateLocation', 'accountLocationDto', accountLocationDto)
            const localVarPath = `/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsResourceApi - functional programming interface
 * @export
 */
export const LocationsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AssignPosLocation} assignPosLocation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPopmenuLocation(assignPosLocation: AssignPosLocation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPopmenuLocation(assignPosLocation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [internalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(id?: string, internalId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(id, internalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationUserCount(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationUserCount(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TransferFilesDto} transferFilesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferDigitalProducts(transferFilesDto: TransferFilesDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferDigitalProducts(transferFilesDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AccountLocationDto} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(accountLocationDto: AccountLocationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(accountLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationsResourceApi - factory interface
 * @export
 */
export const LocationsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {AssignPosLocation} assignPosLocation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPopmenuLocation(assignPosLocation: AssignPosLocation, options?: any): AxiosPromise<void> {
            return localVarFp.assignPopmenuLocation(assignPosLocation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [id] 
         * @param {number} [internalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(id?: string, internalId?: number, options?: any): AxiosPromise<AccountLocationDto> {
            return localVarFp.getLocation(id, internalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationUserCount(locationId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getLocationUserCount(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferFilesDto} transferFilesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferDigitalProducts(transferFilesDto: TransferFilesDto, options?: any): AxiosPromise<void> {
            return localVarFp.transferDigitalProducts(transferFilesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AccountLocationDto} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(accountLocationDto: AccountLocationDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateLocation(accountLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsResourceApi - object-oriented interface
 * @export
 * @class LocationsResourceApi
 * @extends {BaseAPI}
 */
export class LocationsResourceApi extends BaseAPI {
    /**
     * 
     * @param {AssignPosLocation} assignPosLocation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public assignPopmenuLocation(assignPosLocation: AssignPosLocation, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).assignPopmenuLocation(assignPosLocation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public deleteLocation(id: number, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).deleteLocation(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [id] 
     * @param {number} [internalId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public getLocation(id?: string, internalId?: number, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).getLocation(id, internalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public getLocationUserCount(locationId: number, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).getLocationUserCount(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferFilesDto} transferFilesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public transferDigitalProducts(transferFilesDto: TransferFilesDto, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).transferDigitalProducts(transferFilesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AccountLocationDto} accountLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsResourceApi
     */
    public updateLocation(accountLocationDto: AccountLocationDto, options?: AxiosRequestConfig) {
        return LocationsResourceApiFp(this.configuration).updateLocation(accountLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MemberResourceApi - axios parameter creator
 * @export
 */
export const MemberResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewUserInTeam: async (createUserWithLocationPermissions: CreateUserWithLocationPermissions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserWithLocationPermissions' is not null or undefined
            assertParamExists('createNewUserInTeam', 'createUserWithLocationPermissions', createUserWithLocationPermissions)
            const localVarPath = `/members/team/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserWithLocationPermissions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTeamLocationPermissions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUserTeamLocationPermissions', 'id', id)
            const localVarPath = `/members/{id}/team/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} img 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImg: async (img: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'img' is not null or undefined
            assertParamExists('downloadImg', 'img', img)
            const localVarPath = `/members/downloadImg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (img !== undefined) {
                localVarQueryParameter['img'] = img;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GeneratePasswordRequest} generatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePassword: async (generatePasswordRequest: GeneratePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatePasswordRequest' is not null or undefined
            assertParamExists('generatePassword', 'generatePasswordRequest', generatePasswordRequest)
            const localVarPath = `/public/members/password/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchTeamLocationPermissions: async (ids: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getBatchTeamLocationPermissions', 'ids', ids)
            const localVarPath = `/members/team/permissions/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsSharedWithMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/designs/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLocations: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMemberLocations', 'id', id)
            const localVarPath = `/members/{id}/locations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerTeamLocationPermissions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOwnerTeamLocationPermissions', 'id', id)
            const localVarPath = `/members/owner/{id}/team/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidInvoicePaymentPageUrl: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/members/unpaid-invoice-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTeamLocationPermissions: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserTeamLocationPermissions', 'id', id)
            const localVarPath = `/members/{id}/team/permissions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberEmail 
         * @param {QuestionnaireAnswerDto} questionnaireAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQuestionnaire: async (memberEmail: string, questionnaireAnswerDto: QuestionnaireAnswerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberEmail' is not null or undefined
            assertParamExists('saveQuestionnaire', 'memberEmail', memberEmail)
            // verify required parameter 'questionnaireAnswerDto' is not null or undefined
            assertParamExists('saveQuestionnaire', 'questionnaireAnswerDto', questionnaireAnswerDto)
            const localVarPath = `/members/questionnaire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberEmail !== undefined) {
                localVarQueryParameter['memberEmail'] = memberEmail;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionnaireAnswerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AffiliateDto} affiliateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAffiliate: async (affiliateDto: AffiliateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'affiliateDto' is not null or undefined
            assertParamExists('sendAffiliate', 'affiliateDto', affiliateDto)
            const localVarPath = `/public/affiliatelead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(affiliateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMultiRegEmail: async (regMemberDto: RegMemberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regMemberDto' is not null or undefined
            assertParamExists('sendMultiRegEmail', 'regMemberDto', regMemberDto)
            const localVarPath = `/members/multiReg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToast: async (regMemberDto: RegMemberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'regMemberDto' is not null or undefined
            assertParamExists('sendToast', 'regMemberDto', regMemberDto)
            const localVarPath = `/members/toast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(regMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePasswordRequest} updatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (updatePasswordRequest: UpdatePasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordRequest' is not null or undefined
            assertParamExists('updatePassword', 'updatePasswordRequest', updatePasswordRequest)
            const localVarPath = `/members/password/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLocationPermissions: async (id: string, createUserWithLocationPermissions: CreateUserWithLocationPermissions, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUserLocationPermissions', 'id', id)
            // verify required parameter 'createUserWithLocationPermissions' is not null or undefined
            assertParamExists('updateUserLocationPermissions', 'createUserWithLocationPermissions', createUserWithLocationPermissions)
            const localVarPath = `/members/{id}/team/user`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserWithLocationPermissions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemberResourceApi - functional programming interface
 * @export
 */
export const MemberResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemberResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewUserInTeam(createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewUserInTeam(createUserWithLocationPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserTeamLocationPermissions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserTeamLocationPermissions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} img 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadImg(img: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadedItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadImg(img, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GeneratePasswordRequest} generatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePassword(generatePasswordRequest: GeneratePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePassword(generatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBatchTeamLocationPermissions(ids: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<MemberLocationPermissionDto>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBatchTeamLocationPermissions(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignsSharedWithMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignsSharedWithMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberLocations(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberLocations(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnerTeamLocationPermissions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberLocationPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnerTeamLocationPermissions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnpaidInvoicePaymentPageUrl(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PastDueStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnpaidInvoicePaymentPageUrl(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTeamLocationPermissions(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberLocationPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTeamLocationPermissions(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberEmail 
         * @param {QuestionnaireAnswerDto} questionnaireAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveQuestionnaire(memberEmail: string, questionnaireAnswerDto: QuestionnaireAnswerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveQuestionnaire(memberEmail, questionnaireAnswerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AffiliateDto} affiliateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAffiliate(affiliateDto: AffiliateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAffiliate(affiliateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMultiRegEmail(regMemberDto: RegMemberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMultiRegEmail(regMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendToast(regMemberDto: RegMemberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendToast(regMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdatePasswordRequest} updatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(updatePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserLocationPermissions(id: string, createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserLocationPermissions(id, createUserWithLocationPermissions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MemberResourceApi - factory interface
 * @export
 */
export const MemberResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemberResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewUserInTeam(createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: any): AxiosPromise<void> {
            return localVarFp.createNewUserInTeam(createUserWithLocationPermissions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserTeamLocationPermissions(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUserTeamLocationPermissions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} img 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImg(img: string, options?: any): AxiosPromise<DownloadedItemDto> {
            return localVarFp.downloadImg(img, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneratePasswordRequest} generatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePassword(generatePasswordRequest: GeneratePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.generatePassword(generatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBatchTeamLocationPermissions(ids: Array<string>, options?: any): AxiosPromise<{ [key: string]: Array<MemberLocationPermissionDto>; }> {
            return localVarFp.getBatchTeamLocationPermissions(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsSharedWithMe(options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getDesignsSharedWithMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberLocations(id: number, options?: any): AxiosPromise<Array<LocationDto>> {
            return localVarFp.getMemberLocations(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnerTeamLocationPermissions(id: string, options?: any): AxiosPromise<Array<MemberLocationPermissionDto>> {
            return localVarFp.getOwnerTeamLocationPermissions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnpaidInvoicePaymentPageUrl(options?: any): AxiosPromise<PastDueStatusDto> {
            return localVarFp.getUnpaidInvoicePaymentPageUrl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTeamLocationPermissions(id: string, options?: any): AxiosPromise<Array<MemberLocationPermissionDto>> {
            return localVarFp.getUserTeamLocationPermissions(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberEmail 
         * @param {QuestionnaireAnswerDto} questionnaireAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveQuestionnaire(memberEmail: string, questionnaireAnswerDto: QuestionnaireAnswerDto, options?: any): AxiosPromise<void> {
            return localVarFp.saveQuestionnaire(memberEmail, questionnaireAnswerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AffiliateDto} affiliateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAffiliate(affiliateDto: AffiliateDto, options?: any): AxiosPromise<void> {
            return localVarFp.sendAffiliate(affiliateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMultiRegEmail(regMemberDto: RegMemberDto, options?: any): AxiosPromise<void> {
            return localVarFp.sendMultiRegEmail(regMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegMemberDto} regMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToast(regMemberDto: RegMemberDto, options?: any): AxiosPromise<void> {
            return localVarFp.sendToast(regMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdatePasswordRequest} updatePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updatePassword(updatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLocationPermissions(id: string, createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserLocationPermissions(id, createUserWithLocationPermissions, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemberResourceApi - object-oriented interface
 * @export
 * @class MemberResourceApi
 * @extends {BaseAPI}
 */
export class MemberResourceApi extends BaseAPI {
    /**
     * 
     * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public createNewUserInTeam(createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).createNewUserInTeam(createUserWithLocationPermissions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public deleteUserTeamLocationPermissions(id: string, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).deleteUserTeamLocationPermissions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} img 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public downloadImg(img: string, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).downloadImg(img, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneratePasswordRequest} generatePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public generatePassword(generatePasswordRequest: GeneratePasswordRequest, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).generatePassword(generatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getBatchTeamLocationPermissions(ids: Array<string>, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getBatchTeamLocationPermissions(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getDesignsSharedWithMe(options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getDesignsSharedWithMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getMemberLocations(id: number, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getMemberLocations(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getOwnerTeamLocationPermissions(id: string, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getOwnerTeamLocationPermissions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getUnpaidInvoicePaymentPageUrl(options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getUnpaidInvoicePaymentPageUrl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public getUserTeamLocationPermissions(id: string, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).getUserTeamLocationPermissions(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberEmail 
     * @param {QuestionnaireAnswerDto} questionnaireAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public saveQuestionnaire(memberEmail: string, questionnaireAnswerDto: QuestionnaireAnswerDto, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).saveQuestionnaire(memberEmail, questionnaireAnswerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AffiliateDto} affiliateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public sendAffiliate(affiliateDto: AffiliateDto, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).sendAffiliate(affiliateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegMemberDto} regMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public sendMultiRegEmail(regMemberDto: RegMemberDto, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).sendMultiRegEmail(regMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegMemberDto} regMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public sendToast(regMemberDto: RegMemberDto, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).sendToast(regMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdatePasswordRequest} updatePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public updatePassword(updatePasswordRequest: UpdatePasswordRequest, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).updatePassword(updatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {CreateUserWithLocationPermissions} createUserWithLocationPermissions 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberResourceApi
     */
    public updateUserLocationPermissions(id: string, createUserWithLocationPermissions: CreateUserWithLocationPermissions, options?: AxiosRequestConfig) {
        return MemberResourceApiFp(this.configuration).updateUserLocationPermissions(id, createUserWithLocationPermissions, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MembersResourceApi - axios parameter creator
 * @export
 */
export const MembersResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertHoneypot: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('alertHoneypot', 'memberId', memberId)
            const localVarPath = `/members/{memberId}/honeypotalert`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        increaseMemberLoginCount: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('increaseMemberLoginCount', 'memberId', memberId)
            const localVarPath = `/members/increaseLoginCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterMemberDto} registerMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register1: async (registerMemberDto: RegisterMemberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerMemberDto' is not null or undefined
            assertParamExists('register1', 'registerMemberDto', registerMemberDto)
            const localVarPath = `/public/members/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} ga4id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGA4id: async (memberId: string, ga4id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('setGA4id', 'memberId', memberId)
            // verify required parameter 'ga4id' is not null or undefined
            assertParamExists('setGA4id', 'ga4id', ga4id)
            const localVarPath = `/members/{memberId}/setGA4id/{ga4id}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"ga4id"}}`, encodeURIComponent(String(ga4id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationsForMember: async (memberId: string, requestBody: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateLocationsForMember', 'memberId', memberId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateLocationsForMember', 'requestBody', requestBody)
            const localVarPath = `/members/{memberId}/locations`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: async (memberId: string, updateMemberDto: UpdateMemberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateMember', 'memberId', memberId)
            // verify required parameter 'updateMemberDto' is not null or undefined
            assertParamExists('updateMember', 'updateMemberDto', updateMemberDto)
            const localVarPath = `/members/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} internalMemberId 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDiningRDFlag: async (internalMemberId: number, flag: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalMemberId' is not null or undefined
            assertParamExists('updateMemberDiningRDFlag', 'internalMemberId', internalMemberId)
            // verify required parameter 'flag' is not null or undefined
            assertParamExists('updateMemberDiningRDFlag', 'flag', flag)
            const localVarPath = `/members/{internalMemberId}/diningrd`
                .replace(`{${"internalMemberId"}}`, encodeURIComponent(String(internalMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (flag !== undefined) {
                localVarQueryParameter['flag'] = flag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberInterest: async (memberId: string, updateMemberDto: UpdateMemberDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateMemberInterest', 'memberId', memberId)
            // verify required parameter 'updateMemberDto' is not null or undefined
            assertParamExists('updateMemberInterest', 'updateMemberDto', updateMemberDto)
            const localVarPath = `/members/{memberId}/interest`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberRoleBody} updateMemberRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole: async (memberId: string, updateMemberRoleBody: UpdateMemberRoleBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateMemberRole', 'memberId', memberId)
            // verify required parameter 'updateMemberRoleBody' is not null or undefined
            assertParamExists('updateMemberRole', 'updateMemberRoleBody', updateMemberRoleBody)
            const localVarPath = `/members/{memberId}/role`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberRoleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {MemberWebsiteUrlDto} memberWebsiteUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberWebsiteUrl: async (memberId: string, memberWebsiteUrlDto: MemberWebsiteUrlDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateMemberWebsiteUrl', 'memberId', memberId)
            // verify required parameter 'memberWebsiteUrlDto' is not null or undefined
            assertParamExists('updateMemberWebsiteUrl', 'memberWebsiteUrlDto', memberWebsiteUrlDto)
            const localVarPath = `/public/members/{memberId}/website/url`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberWebsiteUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInviteEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('validateInviteEmail', 'email', email)
            const localVarPath = `/members/validateInviteEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembersResourceApi - functional programming interface
 * @export
 */
export const MembersResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembersResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async alertHoneypot(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.alertHoneypot(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async increaseMemberLoginCount(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.increaseMemberLoginCount(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterMemberDto} registerMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register1(registerMemberDto: RegisterMemberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register1(registerMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} ga4id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGA4id(memberId: string, ga4id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGA4id(memberId, ga4id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationsForMember(memberId: string, requestBody: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationsForMember(memberId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMember(memberId: string, updateMemberDto: UpdateMemberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMember(memberId, updateMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} internalMemberId 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberDiningRDFlag(internalMemberId: number, flag: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberDiningRDFlag(internalMemberId, flag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberInterest(memberId: string, updateMemberDto: UpdateMemberDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberInterest(memberId, updateMemberDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberRoleBody} updateMemberRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberRole(memberId: string, updateMemberRoleBody: UpdateMemberRoleBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberRole(memberId, updateMemberRoleBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {MemberWebsiteUrlDto} memberWebsiteUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberWebsiteUrl(memberId: string, memberWebsiteUrlDto: MemberWebsiteUrlDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberWebsiteUrl(memberId, memberWebsiteUrlDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateInviteEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateInviteEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MembersResourceApi - factory interface
 * @export
 */
export const MembersResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembersResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertHoneypot(memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.alertHoneypot(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        increaseMemberLoginCount(memberId: number, options?: any): AxiosPromise<void> {
            return localVarFp.increaseMemberLoginCount(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterMemberDto} registerMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register1(registerMemberDto: RegisterMemberDto, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.register1(registerMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {string} ga4id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGA4id(memberId: string, ga4id: string, options?: any): AxiosPromise<void> {
            return localVarFp.setGA4id(memberId, ga4id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationsForMember(memberId: string, requestBody: Array<string>, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.updateLocationsForMember(memberId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember(memberId: string, updateMemberDto: UpdateMemberDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateMember(memberId, updateMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} internalMemberId 
         * @param {boolean} flag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDiningRDFlag(internalMemberId: number, flag: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.updateMemberDiningRDFlag(internalMemberId, flag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberDto} updateMemberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberInterest(memberId: string, updateMemberDto: UpdateMemberDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateMemberInterest(memberId, updateMemberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {UpdateMemberRoleBody} updateMemberRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole(memberId: string, updateMemberRoleBody: UpdateMemberRoleBody, options?: any): AxiosPromise<void> {
            return localVarFp.updateMemberRole(memberId, updateMemberRoleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {MemberWebsiteUrlDto} memberWebsiteUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberWebsiteUrl(memberId: string, memberWebsiteUrlDto: MemberWebsiteUrlDto, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.updateMemberWebsiteUrl(memberId, memberWebsiteUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateInviteEmail(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.validateInviteEmail(email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembersResourceApi - object-oriented interface
 * @export
 * @class MembersResourceApi
 * @extends {BaseAPI}
 */
export class MembersResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public alertHoneypot(memberId: string, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).alertHoneypot(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public increaseMemberLoginCount(memberId: number, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).increaseMemberLoginCount(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterMemberDto} registerMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public register1(registerMemberDto: RegisterMemberDto, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).register1(registerMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {string} ga4id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public setGA4id(memberId: string, ga4id: string, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).setGA4id(memberId, ga4id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateLocationsForMember(memberId: string, requestBody: Array<string>, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateLocationsForMember(memberId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpdateMemberDto} updateMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateMember(memberId: string, updateMemberDto: UpdateMemberDto, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateMember(memberId, updateMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} internalMemberId 
     * @param {boolean} flag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateMemberDiningRDFlag(internalMemberId: number, flag: boolean, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateMemberDiningRDFlag(internalMemberId, flag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpdateMemberDto} updateMemberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateMemberInterest(memberId: string, updateMemberDto: UpdateMemberDto, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateMemberInterest(memberId, updateMemberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {UpdateMemberRoleBody} updateMemberRoleBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateMemberRole(memberId: string, updateMemberRoleBody: UpdateMemberRoleBody, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateMemberRole(memberId, updateMemberRoleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {MemberWebsiteUrlDto} memberWebsiteUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public updateMemberWebsiteUrl(memberId: string, memberWebsiteUrlDto: MemberWebsiteUrlDto, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).updateMemberWebsiteUrl(memberId, memberWebsiteUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersResourceApi
     */
    public validateInviteEmail(email: string, options?: AxiosRequestConfig) {
        return MembersResourceApiFp(this.configuration).validateInviteEmail(email, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OidcResourceApi - axios parameter creator
 * @export
 */
export const OidcResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} provider 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize: async (provider: string, returnUrl?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('authorize', 'provider', provider)
            const localVarPath = `/public/oidc/{provider}/authorize`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (returnUrl !== undefined) {
                localVarQueryParameter['returnUrl'] = returnUrl;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback: async (provider: string, code?: string, state?: string, error?: string, errorDescription?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('callback', 'provider', provider)
            const localVarPath = `/public/oidc/{provider}/callback`
                .replace(`{${"provider"}}`, encodeURIComponent(String(provider)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (error !== undefined) {
                localVarQueryParameter['error'] = error;
            }

            if (errorDescription !== undefined) {
                localVarQueryParameter['error_description'] = errorDescription;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OidcResourceApi - functional programming interface
 * @export
 */
export const OidcResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OidcResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} provider 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorize(provider: string, returnUrl?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorize(provider, returnUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callback(provider: string, code?: string, state?: string, error?: string, errorDescription?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callback(provider, code, state, error, errorDescription, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OidcResourceApi - factory interface
 * @export
 */
export const OidcResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OidcResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} provider 
         * @param {string} [returnUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorize(provider: string, returnUrl?: string, options?: any): AxiosPromise<void> {
            return localVarFp.authorize(provider, returnUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} provider 
         * @param {string} [code] 
         * @param {string} [state] 
         * @param {string} [error] 
         * @param {string} [errorDescription] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callback(provider: string, code?: string, state?: string, error?: string, errorDescription?: string, options?: any): AxiosPromise<void> {
            return localVarFp.callback(provider, code, state, error, errorDescription, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OidcResourceApi - object-oriented interface
 * @export
 * @class OidcResourceApi
 * @extends {BaseAPI}
 */
export class OidcResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} provider 
     * @param {string} [returnUrl] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcResourceApi
     */
    public authorize(provider: string, returnUrl?: string, options?: AxiosRequestConfig) {
        return OidcResourceApiFp(this.configuration).authorize(provider, returnUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} provider 
     * @param {string} [code] 
     * @param {string} [state] 
     * @param {string} [error] 
     * @param {string} [errorDescription] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OidcResourceApi
     */
    public callback(provider: string, code?: string, state?: string, error?: string, errorDescription?: string, options?: AxiosRequestConfig) {
        return OidcResourceApiFp(this.configuration).callback(provider, code, state, error, errorDescription, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentResourceApi - axios parameter creator
 * @export
 */
export const PaymentResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PaymentIntentBody} paymentIntentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent: async (paymentIntentBody: PaymentIntentBody, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentIntentBody' is not null or undefined
            assertParamExists('createPaymentIntent', 'paymentIntentBody', paymentIntentBody)
            const localVarPath = `/public/payment/intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentIntentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentResourceApi - functional programming interface
 * @export
 */
export const PaymentResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PaymentIntentBody} paymentIntentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentIntent(paymentIntentBody: PaymentIntentBody, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentIntent(paymentIntentBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentResourceApi - factory interface
 * @export
 */
export const PaymentResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {PaymentIntentBody} paymentIntentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent(paymentIntentBody: PaymentIntentBody, options?: any): AxiosPromise<string> {
            return localVarFp.createPaymentIntent(paymentIntentBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentResourceApi - object-oriented interface
 * @export
 * @class PaymentResourceApi
 * @extends {BaseAPI}
 */
export class PaymentResourceApi extends BaseAPI {
    /**
     * 
     * @param {PaymentIntentBody} paymentIntentBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentResourceApi
     */
    public createPaymentIntent(paymentIntentBody: PaymentIntentBody, options?: AxiosRequestConfig) {
        return PaymentResourceApiFp(this.configuration).createPaymentIntent(paymentIntentBody, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PermissionPresetsResourceApi - axios parameter creator
 * @export
 */
export const PermissionPresetsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreset: async (teamId: string, permissionPresetDto: PermissionPresetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createPreset', 'teamId', teamId)
            // verify required parameter 'permissionPresetDto' is not null or undefined
            assertParamExists('createPreset', 'permissionPresetDto', permissionPresetDto)
            const localVarPath = `/teams/{teamId}/permission-presets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(permissionPresetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreset: async (teamId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deletePreset', 'teamId', teamId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePreset', 'id', id)
            const localVarPath = `/teams/{teamId}/permission-presets/{id}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresets: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getPresets', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/permission-presets`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreset: async (teamId: string, id: string, permissionPresetDto: PermissionPresetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updatePreset', 'teamId', teamId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePreset', 'id', id)
            // verify required parameter 'permissionPresetDto' is not null or undefined
            assertParamExists('updatePreset', 'permissionPresetDto', permissionPresetDto)
            const localVarPath = `/teams/{teamId}/permission-presets/{id}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(permissionPresetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionPresetsResourceApi - functional programming interface
 * @export
 */
export const PermissionPresetsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionPresetsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreset(teamId: string, permissionPresetDto: PermissionPresetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionPresetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreset(teamId, permissionPresetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePreset(teamId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePreset(teamId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresets(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionPresetDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresets(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreset(teamId: string, id: string, permissionPresetDto: PermissionPresetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionPresetDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreset(teamId, id, permissionPresetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PermissionPresetsResourceApi - factory interface
 * @export
 */
export const PermissionPresetsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionPresetsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreset(teamId: string, permissionPresetDto: PermissionPresetDto, options?: any): AxiosPromise<PermissionPresetDto> {
            return localVarFp.createPreset(teamId, permissionPresetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePreset(teamId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePreset(teamId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresets(teamId: string, options?: any): AxiosPromise<Array<PermissionPresetDto>> {
            return localVarFp.getPresets(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} id 
         * @param {PermissionPresetDto} permissionPresetDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreset(teamId: string, id: string, permissionPresetDto: PermissionPresetDto, options?: any): AxiosPromise<PermissionPresetDto> {
            return localVarFp.updatePreset(teamId, id, permissionPresetDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PermissionPresetsResourceApi - object-oriented interface
 * @export
 * @class PermissionPresetsResourceApi
 * @extends {BaseAPI}
 */
export class PermissionPresetsResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} teamId 
     * @param {PermissionPresetDto} permissionPresetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionPresetsResourceApi
     */
    public createPreset(teamId: string, permissionPresetDto: PermissionPresetDto, options?: AxiosRequestConfig) {
        return PermissionPresetsResourceApiFp(this.configuration).createPreset(teamId, permissionPresetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionPresetsResourceApi
     */
    public deletePreset(teamId: string, id: string, options?: AxiosRequestConfig) {
        return PermissionPresetsResourceApiFp(this.configuration).deletePreset(teamId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionPresetsResourceApi
     */
    public getPresets(teamId: string, options?: AxiosRequestConfig) {
        return PermissionPresetsResourceApiFp(this.configuration).getPresets(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {string} id 
     * @param {PermissionPresetDto} permissionPresetDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionPresetsResourceApi
     */
    public updatePreset(teamId: string, id: string, permissionPresetDto: PermissionPresetDto, options?: AxiosRequestConfig) {
        return PermissionPresetsResourceApiFp(this.configuration).updatePreset(teamId, id, permissionPresetDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PosResourceApi - axios parameter creator
 * @export
 */
export const PosResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {PopmenuDeltaUpdateDesignResponse} popmenuDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPopmenuChangeSolvedInDesignId: async (restaurantId: string, changeId: string, popmenuDeltaUpdateDesignResponse: PopmenuDeltaUpdateDesignResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('addPopmenuChangeSolvedInDesignId', 'restaurantId', restaurantId)
            // verify required parameter 'changeId' is not null or undefined
            assertParamExists('addPopmenuChangeSolvedInDesignId', 'changeId', changeId)
            // verify required parameter 'popmenuDeltaUpdateDesignResponse' is not null or undefined
            assertParamExists('addPopmenuChangeSolvedInDesignId', 'popmenuDeltaUpdateDesignResponse', popmenuDeltaUpdateDesignResponse)
            const localVarPath = `/pos/popmenu/restaurants/{restaurantId}/changes/{changeId}/design`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)))
                .replace(`{${"changeId"}}`, encodeURIComponent(String(changeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(popmenuDeltaUpdateDesignResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSquareChangeSolvedInDesignId: async (restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('addSquareChangeSolvedInDesignId', 'restaurantId', restaurantId)
            // verify required parameter 'changeId' is not null or undefined
            assertParamExists('addSquareChangeSolvedInDesignId', 'changeId', changeId)
            // verify required parameter 'toastDeltaUpdateDesignResponse' is not null or undefined
            assertParamExists('addSquareChangeSolvedInDesignId', 'toastDeltaUpdateDesignResponse', toastDeltaUpdateDesignResponse)
            const localVarPath = `/pos/square/restaurants/{restaurantId}/changes/{changeId}/design`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)))
                .replace(`{${"changeId"}}`, encodeURIComponent(String(changeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toastDeltaUpdateDesignResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToastChangeSolvedInDesignId: async (restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('addToastChangeSolvedInDesignId', 'restaurantId', restaurantId)
            // verify required parameter 'changeId' is not null or undefined
            assertParamExists('addToastChangeSolvedInDesignId', 'changeId', changeId)
            // verify required parameter 'toastDeltaUpdateDesignResponse' is not null or undefined
            assertParamExists('addToastChangeSolvedInDesignId', 'toastDeltaUpdateDesignResponse', toastDeltaUpdateDesignResponse)
            const localVarPath = `/pos/toast/restaurants/{restaurantId}/changes/{changeId}/design`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)))
                .replace(`{${"changeId"}}`, encodeURIComponent(String(changeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toastDeltaUpdateDesignResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {TreezDeltaUpdateDesignResponse} treezDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreezChangeSolvedInDesignId: async (restaurantId: string, changeId: string, treezDeltaUpdateDesignResponse: TreezDeltaUpdateDesignResponse, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('addTreezChangeSolvedInDesignId', 'restaurantId', restaurantId)
            // verify required parameter 'changeId' is not null or undefined
            assertParamExists('addTreezChangeSolvedInDesignId', 'changeId', changeId)
            // verify required parameter 'treezDeltaUpdateDesignResponse' is not null or undefined
            assertParamExists('addTreezChangeSolvedInDesignId', 'treezDeltaUpdateDesignResponse', treezDeltaUpdateDesignResponse)
            const localVarPath = `/pos/treez/restaurants/{restaurantId}/changes/{changeId}/design`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)))
                .replace(`{${"changeId"}}`, encodeURIComponent(String(changeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treezDeltaUpdateDesignResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PopmenuAuthReqDto} popmenuAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPopmenu: async (popmenuAuthReqDto: PopmenuAuthReqDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'popmenuAuthReqDto' is not null or undefined
            assertParamExists('authPopmenu', 'popmenuAuthReqDto', popmenuAuthReqDto)
            const localVarPath = `/pos/popmenu/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(popmenuAuthReqDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SquareAuthReqDto} squareAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSquare: async (squareAuthReqDto: SquareAuthReqDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'squareAuthReqDto' is not null or undefined
            assertParamExists('authSquare', 'squareAuthReqDto', squareAuthReqDto)
            const localVarPath = `/pos/square/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(squareAuthReqDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingPopmenu: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDesignsUsingPopmenu', 'locationId', locationId)
            const localVarPath = `/pos/popmenu/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingSquare: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDesignsUsingSquare', 'locationId', locationId)
            const localVarPath = `/pos/square/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingToast: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDesignsUsingToast', 'locationId', locationId)
            const localVarPath = `/pos/toast/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingTreez: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getDesignsUsingTreez', 'locationId', locationId)
            const localVarPath = `/pos/treez/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuLocations: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getPopmenuLocations', 'memberId', memberId)
            const localVarPath = `/pos/popmenu/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuPendingChanges: async (restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('getPopmenuPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getPopmenuPendingChanges', 'status', status)
            const localVarPath = `/pos/popmenu/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuRestaurants: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pos/popmenu/restaurants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSquarePendingChanges: async (restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('getSquarePendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getSquarePendingChanges', 'status', status)
            const localVarPath = `/pos/square/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSquareRestaurants: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pos/square/restaurants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToastPendingChanges: async (restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('getToastPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getToastPendingChanges', 'status', status)
            const localVarPath = `/pos/toast/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToastRestaurants: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getToastRestaurants', 'email', email)
            const localVarPath = `/pos/toast/restaurants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreezPendingChanges: async (restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('getTreezPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getTreezPendingChanges', 'status', status)
            const localVarPath = `/pos/treez/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreezRestaurants: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pos/treez/restaurants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePopmenuItems: async (replaceSquareItemDto: Array<ReplaceSquareItemDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceSquareItemDto' is not null or undefined
            assertParamExists('replacePopmenuItems', 'replaceSquareItemDto', replaceSquareItemDto)
            const localVarPath = `/pos/popmenu/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceSquareItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceSquareItems: async (replaceSquareItemDto: Array<ReplaceSquareItemDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceSquareItemDto' is not null or undefined
            assertParamExists('replaceSquareItems', 'replaceSquareItemDto', replaceSquareItemDto)
            const localVarPath = `/pos/square/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceSquareItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ReplaceToastItemDto>} replaceToastItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceToastItems: async (replaceToastItemDto: Array<ReplaceToastItemDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceToastItemDto' is not null or undefined
            assertParamExists('replaceToastItems', 'replaceToastItemDto', replaceToastItemDto)
            const localVarPath = `/pos/toast/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceToastItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTreezItems: async (replaceSquareItemDto: Array<ReplaceSquareItemDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'replaceSquareItemDto' is not null or undefined
            assertParamExists('replaceTreezItems', 'replaceSquareItemDto', replaceSquareItemDto)
            const localVarPath = `/pos/treez/designs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(replaceSquareItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<PopmenuDeltaUpdateResponse>} popmenuDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopmenuPendingChanges: async (restaurantId: string, popmenuDeltaUpdateResponse: Array<PopmenuDeltaUpdateResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('updatePopmenuPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'popmenuDeltaUpdateResponse' is not null or undefined
            assertParamExists('updatePopmenuPendingChanges', 'popmenuDeltaUpdateResponse', popmenuDeltaUpdateResponse)
            const localVarPath = `/pos/popmenu/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(popmenuDeltaUpdateResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<SquareDeltaUpdateResponse>} squareDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSquarePendingChanges: async (restaurantId: string, squareDeltaUpdateResponse: Array<SquareDeltaUpdateResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('updateSquarePendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'squareDeltaUpdateResponse' is not null or undefined
            assertParamExists('updateSquarePendingChanges', 'squareDeltaUpdateResponse', squareDeltaUpdateResponse)
            const localVarPath = `/pos/square/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(squareDeltaUpdateResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<ToastDeltaUpdateResponse>} toastDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToastPendingChanges: async (restaurantId: string, toastDeltaUpdateResponse: Array<ToastDeltaUpdateResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('updateToastPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'toastDeltaUpdateResponse' is not null or undefined
            assertParamExists('updateToastPendingChanges', 'toastDeltaUpdateResponse', toastDeltaUpdateResponse)
            const localVarPath = `/pos/toast/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toastDeltaUpdateResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<TreezDeltaUpdateResponse>} treezDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreezPendingChanges: async (restaurantId: string, treezDeltaUpdateResponse: Array<TreezDeltaUpdateResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restaurantId' is not null or undefined
            assertParamExists('updateTreezPendingChanges', 'restaurantId', restaurantId)
            // verify required parameter 'treezDeltaUpdateResponse' is not null or undefined
            assertParamExists('updateTreezPendingChanges', 'treezDeltaUpdateResponse', treezDeltaUpdateResponse)
            const localVarPath = `/pos/treez/restaurants/{restaurantId}/changes`
                .replace(`{${"restaurantId"}}`, encodeURIComponent(String(restaurantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(treezDeltaUpdateResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PosResourceApi - functional programming interface
 * @export
 */
export const PosResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PosResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {PopmenuDeltaUpdateDesignResponse} popmenuDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPopmenuChangeSolvedInDesignId(restaurantId: string, changeId: string, popmenuDeltaUpdateDesignResponse: PopmenuDeltaUpdateDesignResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPopmenuChangeSolvedInDesignId(restaurantId, changeId, popmenuDeltaUpdateDesignResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSquareChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSquareChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToastChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToastChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {TreezDeltaUpdateDesignResponse} treezDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTreezChangeSolvedInDesignId(restaurantId: string, changeId: string, treezDeltaUpdateDesignResponse: TreezDeltaUpdateDesignResponse, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTreezChangeSolvedInDesignId(restaurantId, changeId, treezDeltaUpdateDesignResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PopmenuAuthReqDto} popmenuAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPopmenu(popmenuAuthReqDto: PopmenuAuthReqDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPopmenu(popmenuAuthReqDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SquareAuthReqDto} squareAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authSquare(squareAuthReqDto: SquareAuthReqDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authSquare(squareAuthReqDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignsUsingPopmenu(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignsUsingPopmenu(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignsUsingSquare(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignsUsingSquare(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignsUsingToast(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignsUsingToast(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesignsUsingTreez(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DesignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesignsUsingTreez(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopmenuLocations(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopmenuLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopmenuLocations(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopmenuPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopmenuDeltaUpdate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopmenuPendingChanges(restaurantId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopmenuRestaurants(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopmenuRestaurantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopmenuRestaurants(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSquarePendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SquareDeltaUpdate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSquarePendingChanges(restaurantId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSquareRestaurants(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SquareRestaurantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSquareRestaurants(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToastPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToastDeltaUpdate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToastPendingChanges(restaurantId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToastRestaurants(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToastRestaurantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToastRestaurants(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreezPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreezDeltaUpdate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreezPendingChanges(restaurantId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreezRestaurants(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TreezRestaurantDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreezRestaurants(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacePopmenuItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacePopmenuItems(replaceSquareItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceSquareItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceSquareItems(replaceSquareItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<ReplaceToastItemDto>} replaceToastItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceToastItems(replaceToastItemDto: Array<ReplaceToastItemDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceToastItems(replaceToastItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceTreezItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceTreezItems(replaceSquareItemDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<PopmenuDeltaUpdateResponse>} popmenuDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePopmenuPendingChanges(restaurantId: string, popmenuDeltaUpdateResponse: Array<PopmenuDeltaUpdateResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePopmenuPendingChanges(restaurantId, popmenuDeltaUpdateResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<SquareDeltaUpdateResponse>} squareDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSquarePendingChanges(restaurantId: string, squareDeltaUpdateResponse: Array<SquareDeltaUpdateResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSquarePendingChanges(restaurantId, squareDeltaUpdateResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<ToastDeltaUpdateResponse>} toastDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToastPendingChanges(restaurantId: string, toastDeltaUpdateResponse: Array<ToastDeltaUpdateResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToastPendingChanges(restaurantId, toastDeltaUpdateResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<TreezDeltaUpdateResponse>} treezDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreezPendingChanges(restaurantId: string, treezDeltaUpdateResponse: Array<TreezDeltaUpdateResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreezPendingChanges(restaurantId, treezDeltaUpdateResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PosResourceApi - factory interface
 * @export
 */
export const PosResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PosResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {PopmenuDeltaUpdateDesignResponse} popmenuDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPopmenuChangeSolvedInDesignId(restaurantId: string, changeId: string, popmenuDeltaUpdateDesignResponse: PopmenuDeltaUpdateDesignResponse, options?: any): AxiosPromise<void> {
            return localVarFp.addPopmenuChangeSolvedInDesignId(restaurantId, changeId, popmenuDeltaUpdateDesignResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSquareChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: any): AxiosPromise<void> {
            return localVarFp.addSquareChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToastChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: any): AxiosPromise<void> {
            return localVarFp.addToastChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {string} changeId 
         * @param {TreezDeltaUpdateDesignResponse} treezDeltaUpdateDesignResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTreezChangeSolvedInDesignId(restaurantId: string, changeId: string, treezDeltaUpdateDesignResponse: TreezDeltaUpdateDesignResponse, options?: any): AxiosPromise<void> {
            return localVarFp.addTreezChangeSolvedInDesignId(restaurantId, changeId, treezDeltaUpdateDesignResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PopmenuAuthReqDto} popmenuAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPopmenu(popmenuAuthReqDto: PopmenuAuthReqDto, options?: any): AxiosPromise<void> {
            return localVarFp.authPopmenu(popmenuAuthReqDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SquareAuthReqDto} squareAuthReqDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSquare(squareAuthReqDto: SquareAuthReqDto, options?: any): AxiosPromise<void> {
            return localVarFp.authSquare(squareAuthReqDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingPopmenu(locationId: number, options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getDesignsUsingPopmenu(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingSquare(locationId: number, options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getDesignsUsingSquare(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingToast(locationId: number, options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getDesignsUsingToast(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesignsUsingTreez(locationId: number, options?: any): AxiosPromise<Array<DesignDto>> {
            return localVarFp.getDesignsUsingTreez(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuLocations(memberId: number, options?: any): AxiosPromise<Array<PopmenuLocationDto>> {
            return localVarFp.getPopmenuLocations(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: any): AxiosPromise<Array<PopmenuDeltaUpdate>> {
            return localVarFp.getPopmenuPendingChanges(restaurantId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopmenuRestaurants(options?: any): AxiosPromise<Array<PopmenuRestaurantDto>> {
            return localVarFp.getPopmenuRestaurants(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSquarePendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: any): AxiosPromise<Array<SquareDeltaUpdate>> {
            return localVarFp.getSquarePendingChanges(restaurantId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSquareRestaurants(options?: any): AxiosPromise<Array<SquareRestaurantDto>> {
            return localVarFp.getSquareRestaurants(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToastPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: any): AxiosPromise<Array<ToastDeltaUpdate>> {
            return localVarFp.getToastPendingChanges(restaurantId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToastRestaurants(email: string, options?: any): AxiosPromise<Array<ToastRestaurantDto>> {
            return localVarFp.getToastRestaurants(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreezPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: any): AxiosPromise<Array<TreezDeltaUpdate>> {
            return localVarFp.getTreezPendingChanges(restaurantId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreezRestaurants(options?: any): AxiosPromise<Array<TreezRestaurantDto>> {
            return localVarFp.getTreezRestaurants(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePopmenuItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: any): AxiosPromise<void> {
            return localVarFp.replacePopmenuItems(replaceSquareItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceSquareItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: any): AxiosPromise<void> {
            return localVarFp.replaceSquareItems(replaceSquareItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ReplaceToastItemDto>} replaceToastItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceToastItems(replaceToastItemDto: Array<ReplaceToastItemDto>, options?: any): AxiosPromise<void> {
            return localVarFp.replaceToastItems(replaceToastItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceTreezItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: any): AxiosPromise<void> {
            return localVarFp.replaceTreezItems(replaceSquareItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<PopmenuDeltaUpdateResponse>} popmenuDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopmenuPendingChanges(restaurantId: string, popmenuDeltaUpdateResponse: Array<PopmenuDeltaUpdateResponse>, options?: any): AxiosPromise<void> {
            return localVarFp.updatePopmenuPendingChanges(restaurantId, popmenuDeltaUpdateResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<SquareDeltaUpdateResponse>} squareDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSquarePendingChanges(restaurantId: string, squareDeltaUpdateResponse: Array<SquareDeltaUpdateResponse>, options?: any): AxiosPromise<void> {
            return localVarFp.updateSquarePendingChanges(restaurantId, squareDeltaUpdateResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<ToastDeltaUpdateResponse>} toastDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToastPendingChanges(restaurantId: string, toastDeltaUpdateResponse: Array<ToastDeltaUpdateResponse>, options?: any): AxiosPromise<void> {
            return localVarFp.updateToastPendingChanges(restaurantId, toastDeltaUpdateResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} restaurantId 
         * @param {Array<TreezDeltaUpdateResponse>} treezDeltaUpdateResponse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreezPendingChanges(restaurantId: string, treezDeltaUpdateResponse: Array<TreezDeltaUpdateResponse>, options?: any): AxiosPromise<void> {
            return localVarFp.updateTreezPendingChanges(restaurantId, treezDeltaUpdateResponse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PosResourceApi - object-oriented interface
 * @export
 * @class PosResourceApi
 * @extends {BaseAPI}
 */
export class PosResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} restaurantId 
     * @param {string} changeId 
     * @param {PopmenuDeltaUpdateDesignResponse} popmenuDeltaUpdateDesignResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public addPopmenuChangeSolvedInDesignId(restaurantId: string, changeId: string, popmenuDeltaUpdateDesignResponse: PopmenuDeltaUpdateDesignResponse, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).addPopmenuChangeSolvedInDesignId(restaurantId, changeId, popmenuDeltaUpdateDesignResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {string} changeId 
     * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public addSquareChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).addSquareChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {string} changeId 
     * @param {ToastDeltaUpdateDesignResponse} toastDeltaUpdateDesignResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public addToastChangeSolvedInDesignId(restaurantId: string, changeId: string, toastDeltaUpdateDesignResponse: ToastDeltaUpdateDesignResponse, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).addToastChangeSolvedInDesignId(restaurantId, changeId, toastDeltaUpdateDesignResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {string} changeId 
     * @param {TreezDeltaUpdateDesignResponse} treezDeltaUpdateDesignResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public addTreezChangeSolvedInDesignId(restaurantId: string, changeId: string, treezDeltaUpdateDesignResponse: TreezDeltaUpdateDesignResponse, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).addTreezChangeSolvedInDesignId(restaurantId, changeId, treezDeltaUpdateDesignResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PopmenuAuthReqDto} popmenuAuthReqDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public authPopmenu(popmenuAuthReqDto: PopmenuAuthReqDto, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).authPopmenu(popmenuAuthReqDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SquareAuthReqDto} squareAuthReqDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public authSquare(squareAuthReqDto: SquareAuthReqDto, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).authSquare(squareAuthReqDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getDesignsUsingPopmenu(locationId: number, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getDesignsUsingPopmenu(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getDesignsUsingSquare(locationId: number, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getDesignsUsingSquare(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getDesignsUsingToast(locationId: number, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getDesignsUsingToast(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getDesignsUsingTreez(locationId: number, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getDesignsUsingTreez(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getPopmenuLocations(memberId: number, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getPopmenuLocations(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getPopmenuPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getPopmenuPendingChanges(restaurantId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getPopmenuRestaurants(options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getPopmenuRestaurants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getSquarePendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getSquarePendingChanges(restaurantId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getSquareRestaurants(options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getSquareRestaurants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getToastPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getToastPendingChanges(restaurantId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getToastRestaurants(email: string, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getToastRestaurants(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {'APPROVED' | 'PENDING' | 'DISMISSED'} status 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getTreezPendingChanges(restaurantId: string, status: 'APPROVED' | 'PENDING' | 'DISMISSED', options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getTreezPendingChanges(restaurantId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public getTreezRestaurants(options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).getTreezRestaurants(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public replacePopmenuItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).replacePopmenuItems(replaceSquareItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public replaceSquareItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).replaceSquareItems(replaceSquareItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ReplaceToastItemDto>} replaceToastItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public replaceToastItems(replaceToastItemDto: Array<ReplaceToastItemDto>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).replaceToastItems(replaceToastItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<ReplaceSquareItemDto>} replaceSquareItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public replaceTreezItems(replaceSquareItemDto: Array<ReplaceSquareItemDto>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).replaceTreezItems(replaceSquareItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {Array<PopmenuDeltaUpdateResponse>} popmenuDeltaUpdateResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public updatePopmenuPendingChanges(restaurantId: string, popmenuDeltaUpdateResponse: Array<PopmenuDeltaUpdateResponse>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).updatePopmenuPendingChanges(restaurantId, popmenuDeltaUpdateResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {Array<SquareDeltaUpdateResponse>} squareDeltaUpdateResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public updateSquarePendingChanges(restaurantId: string, squareDeltaUpdateResponse: Array<SquareDeltaUpdateResponse>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).updateSquarePendingChanges(restaurantId, squareDeltaUpdateResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {Array<ToastDeltaUpdateResponse>} toastDeltaUpdateResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public updateToastPendingChanges(restaurantId: string, toastDeltaUpdateResponse: Array<ToastDeltaUpdateResponse>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).updateToastPendingChanges(restaurantId, toastDeltaUpdateResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} restaurantId 
     * @param {Array<TreezDeltaUpdateResponse>} treezDeltaUpdateResponse 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PosResourceApi
     */
    public updateTreezPendingChanges(restaurantId: string, treezDeltaUpdateResponse: Array<TreezDeltaUpdateResponse>, options?: AxiosRequestConfig) {
        return PosResourceApiFp(this.configuration).updateTreezPendingChanges(restaurantId, treezDeltaUpdateResponse, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrintResourceApi - axios parameter creator
 * @export
 */
export const PrintResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCoupon: async (params: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'params' is not null or undefined
            assertParamExists('applyCoupon', 'params', params)
            const localVarPath = `/print/stripe/apply/coupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent1: async (params: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'params' is not null or undefined
            assertParamExists('createPaymentIntent1', 'params', params)
            const localVarPath = `/print/stripe/payment-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPaymentMethod: async (email: string, memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getDefaultPaymentMethod', 'email', email)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getDefaultPaymentMethod', 'memberId', memberId)
            const localVarPath = `/print/stripe/payment-method/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentIntent: async (params: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'params' is not null or undefined
            assertParamExists('getPaymentIntent', 'params', params)
            const localVarPath = `/print/stripe/payment-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods: async (email: string, memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getPaymentMethods', 'email', email)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getPaymentMethods', 'memberId', memberId)
            const localVarPath = `/print/stripe/payment-methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} coupon 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUsedCoupon: async (coupon: string, memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coupon' is not null or undefined
            assertParamExists('saveUsedCoupon', 'coupon', coupon)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('saveUsedCoupon', 'memberId', memberId)
            const localVarPath = `/print/stripe/apply/coupon/used`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (coupon !== undefined) {
                localVarQueryParameter['coupon'] = coupon;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultPaymentMethod: async (email: string, memberId: number, paymentMethodId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('setDefaultPaymentMethod', 'email', email)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('setDefaultPaymentMethod', 'memberId', memberId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('setDefaultPaymentMethod', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/print/stripe/payment-method/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }

            if (paymentMethodId !== undefined) {
                localVarQueryParameter['paymentMethodId'] = paymentMethodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPaymentIntent: async (paymentIntentId: string, paymentMethodId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paymentIntentId' is not null or undefined
            assertParamExists('submitPaymentIntent', 'paymentIntentId', paymentIntentId)
            // verify required parameter 'paymentMethodId' is not null or undefined
            assertParamExists('submitPaymentIntent', 'paymentMethodId', paymentMethodId)
            const localVarPath = `/print/stripe/payment-intent/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paymentIntentId !== undefined) {
                localVarQueryParameter['paymentIntentId'] = paymentIntentId;
            }

            if (paymentMethodId !== undefined) {
                localVarQueryParameter['paymentMethodId'] = paymentMethodId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentIntent: async (params: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'params' is not null or undefined
            assertParamExists('updatePaymentIntent', 'params', params)
            const localVarPath = `/print/stripe/payment-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrintResourceApi - functional programming interface
 * @export
 */
export const PrintResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrintResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyCoupon(params: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyCoupon(params, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPaymentIntent1(params: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPaymentIntent1(params, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultPaymentMethod(email: string, memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultPaymentMethod(email, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentIntent(params: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentIntent(params, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentMethods(email: string, memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentMethods(email, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} coupon 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUsedCoupon(coupon: string, memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUsedCoupon(coupon, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultPaymentMethod(email: string, memberId: number, paymentMethodId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultPaymentMethod(email, memberId, paymentMethodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPaymentIntent(paymentIntentId: string, paymentMethodId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPaymentIntent(paymentIntentId, paymentMethodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentIntent(params: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentIntent(params, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrintResourceApi - factory interface
 * @export
 */
export const PrintResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrintResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCoupon(params: string, options?: any): AxiosPromise<string> {
            return localVarFp.applyCoupon(params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentIntent1(params: string, options?: any): AxiosPromise<string> {
            return localVarFp.createPaymentIntent1(params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPaymentMethod(email: string, memberId: number, options?: any): AxiosPromise<string> {
            return localVarFp.getDefaultPaymentMethod(email, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentIntent(params: string, options?: any): AxiosPromise<string> {
            return localVarFp.getPaymentIntent(params, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentMethods(email: string, memberId: number, options?: any): AxiosPromise<string> {
            return localVarFp.getPaymentMethods(email, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} coupon 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUsedCoupon(coupon: string, memberId: number, options?: any): AxiosPromise<void> {
            return localVarFp.saveUsedCoupon(coupon, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} memberId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultPaymentMethod(email: string, memberId: number, paymentMethodId: string, options?: any): AxiosPromise<string> {
            return localVarFp.setDefaultPaymentMethod(email, memberId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {string} paymentMethodId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPaymentIntent(paymentIntentId: string, paymentMethodId: string, options?: any): AxiosPromise<string> {
            return localVarFp.submitPaymentIntent(paymentIntentId, paymentMethodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentIntent(params: string, options?: any): AxiosPromise<string> {
            return localVarFp.updatePaymentIntent(params, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrintResourceApi - object-oriented interface
 * @export
 * @class PrintResourceApi
 * @extends {BaseAPI}
 */
export class PrintResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public applyCoupon(params: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).applyCoupon(params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public createPaymentIntent1(params: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).createPaymentIntent1(params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public getDefaultPaymentMethod(email: string, memberId: number, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).getDefaultPaymentMethod(email, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public getPaymentIntent(params: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).getPaymentIntent(params, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public getPaymentMethods(email: string, memberId: number, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).getPaymentMethods(email, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} coupon 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public saveUsedCoupon(coupon: string, memberId: number, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).saveUsedCoupon(coupon, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} memberId 
     * @param {string} paymentMethodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public setDefaultPaymentMethod(email: string, memberId: number, paymentMethodId: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).setDefaultPaymentMethod(email, memberId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} paymentIntentId 
     * @param {string} paymentMethodId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public submitPaymentIntent(paymentIntentId: string, paymentMethodId: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).submitPaymentIntent(paymentIntentId, paymentMethodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrintResourceApi
     */
    public updatePaymentIntent(params: string, options?: AxiosRequestConfig) {
        return PrintResourceApiFp(this.configuration).updatePaymentIntent(params, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StreamResourceApi - axios parameter creator
 * @export
 */
export const StreamResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamLocations: async (streamAuthorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'streamAuthorization' is not null or undefined
            assertParamExists('getStreamLocations', 'streamAuthorization', streamAuthorization)
            const localVarPath = `/public/stream/v1/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (streamAuthorization !== undefined && streamAuthorization !== null) {
                localVarHeaderParameter['StreamAuthorization'] = String(streamAuthorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TokenRequestDto} tokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamOAuthToken: async (tokenRequestDto: TokenRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequestDto' is not null or undefined
            assertParamExists('getStreamOAuthToken', 'tokenRequestDto', tokenRequestDto)
            const localVarPath = `/public/stream/v1/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStreamWebhook: async (streamAuthorization: string, requestBody: { [key: string]: object; }, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'streamAuthorization' is not null or undefined
            assertParamExists('handleStreamWebhook', 'streamAuthorization', streamAuthorization)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('handleStreamWebhook', 'requestBody', requestBody)
            const localVarPath = `/public/stream/v1/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (streamAuthorization !== undefined && streamAuthorization !== null) {
                localVarHeaderParameter['StreamAuthorization'] = String(streamAuthorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStreamWebhook1: async (streamAuthorization: string, locationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'streamAuthorization' is not null or undefined
            assertParamExists('handleStreamWebhook1', 'streamAuthorization', streamAuthorization)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('handleStreamWebhook1', 'locationId', locationId)
            const localVarPath = `/public/stream/v1/locations/connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['location_id'] = locationId;
            }

            if (streamAuthorization !== undefined && streamAuthorization !== null) {
                localVarHeaderParameter['StreamAuthorization'] = String(streamAuthorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StreamResourceApi - functional programming interface
 * @export
 */
export const StreamResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StreamResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamLocations(streamAuthorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamLocations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamLocations(streamAuthorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TokenRequestDto} tokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStreamOAuthToken(tokenRequestDto: TokenRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStreamOAuthToken(tokenRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStreamWebhook(streamAuthorization: string, requestBody: { [key: string]: object; }, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStreamWebhook(streamAuthorization, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleStreamWebhook1(streamAuthorization: string, locationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StreamLocationConnection>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleStreamWebhook1(streamAuthorization, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StreamResourceApi - factory interface
 * @export
 */
export const StreamResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StreamResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamLocations(streamAuthorization: string, options?: any): AxiosPromise<StreamLocations> {
            return localVarFp.getStreamLocations(streamAuthorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TokenRequestDto} tokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStreamOAuthToken(tokenRequestDto: TokenRequestDto, options?: any): AxiosPromise<Token> {
            return localVarFp.getStreamOAuthToken(tokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {{ [key: string]: object; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStreamWebhook(streamAuthorization: string, requestBody: { [key: string]: object; }, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.handleStreamWebhook(streamAuthorization, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} streamAuthorization 
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleStreamWebhook1(streamAuthorization: string, locationId: string, options?: any): AxiosPromise<StreamLocationConnection> {
            return localVarFp.handleStreamWebhook1(streamAuthorization, locationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StreamResourceApi - object-oriented interface
 * @export
 * @class StreamResourceApi
 * @extends {BaseAPI}
 */
export class StreamResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} streamAuthorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamResourceApi
     */
    public getStreamLocations(streamAuthorization: string, options?: AxiosRequestConfig) {
        return StreamResourceApiFp(this.configuration).getStreamLocations(streamAuthorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TokenRequestDto} tokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamResourceApi
     */
    public getStreamOAuthToken(tokenRequestDto: TokenRequestDto, options?: AxiosRequestConfig) {
        return StreamResourceApiFp(this.configuration).getStreamOAuthToken(tokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} streamAuthorization 
     * @param {{ [key: string]: object; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamResourceApi
     */
    public handleStreamWebhook(streamAuthorization: string, requestBody: { [key: string]: object; }, options?: AxiosRequestConfig) {
        return StreamResourceApiFp(this.configuration).handleStreamWebhook(streamAuthorization, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} streamAuthorization 
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StreamResourceApi
     */
    public handleStreamWebhook1(streamAuthorization: string, locationId: string, options?: AxiosRequestConfig) {
        return StreamResourceApiFp(this.configuration).handleStreamWebhook1(streamAuthorization, locationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TeamsResourceApi - axios parameter creator
 * @export
 */
export const TeamsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamLocation: async (teamId: string, accountLocationDto: Array<AccountLocationDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamLocation', 'teamId', teamId)
            // verify required parameter 'accountLocationDto' is not null or undefined
            assertParamExists('createTeamLocation', 'accountLocationDto', accountLocationDto)
            const localVarPath = `/teams/{teamId}/locations`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamUsers: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getAllTeamUsers', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/users/all`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLocations: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamLocations', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/locations`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLocationsWithLogos: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamLocationsWithLogos', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/locations/withLogos`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamOwner: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamOwner', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/owner`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsers: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamUsers', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/users`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersWithOwner: async (teamId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamUsersWithOwner', 'teamId', teamId)
            const localVarPath = `/teams/{teamId}/users/owner`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTeamLocation: async (teamId: string, accountLocationDto: Array<AccountLocationDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('validateTeamLocation', 'teamId', teamId)
            // verify required parameter 'accountLocationDto' is not null or undefined
            assertParamExists('validateTeamLocation', 'accountLocationDto', accountLocationDto)
            const localVarPath = `/teams/{teamId}/locations/validate`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountLocationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsResourceApi - functional programming interface
 * @export
 */
export const TeamsResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamLocation(teamId, accountLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTeamUsers(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountMemberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTeamUsers(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamLocations(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamLocations(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamLocationsWithLogos(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountLocationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamLocationsWithLogos(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamOwner(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamOwner(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUsers(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountMemberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUsers(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUsersWithOwner(teamId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccountMemberDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUsersWithOwner(teamId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTeamLocation(teamId, accountLocationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TeamsResourceApi - factory interface
 * @export
 */
export const TeamsResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: any): AxiosPromise<void> {
            return localVarFp.createTeamLocation(teamId, accountLocationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTeamUsers(teamId: string, options?: any): AxiosPromise<Array<AccountMemberDto>> {
            return localVarFp.getAllTeamUsers(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLocations(teamId: string, options?: any): AxiosPromise<Array<AccountLocationDto>> {
            return localVarFp.getTeamLocations(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLocationsWithLogos(teamId: string, options?: any): AxiosPromise<Array<AccountLocationDto>> {
            return localVarFp.getTeamLocationsWithLogos(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamOwner(teamId: string, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.getTeamOwner(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsers(teamId: string, options?: any): AxiosPromise<Array<AccountMemberDto>> {
            return localVarFp.getTeamUsers(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersWithOwner(teamId: string, options?: any): AxiosPromise<Array<AccountMemberDto>> {
            return localVarFp.getTeamUsersWithOwner(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} teamId 
         * @param {Array<AccountLocationDto>} accountLocationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: any): AxiosPromise<void> {
            return localVarFp.validateTeamLocation(teamId, accountLocationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsResourceApi - object-oriented interface
 * @export
 * @class TeamsResourceApi
 * @extends {BaseAPI}
 */
export class TeamsResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} teamId 
     * @param {Array<AccountLocationDto>} accountLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public createTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).createTeamLocation(teamId, accountLocationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getAllTeamUsers(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getAllTeamUsers(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getTeamLocations(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getTeamLocations(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getTeamLocationsWithLogos(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getTeamLocationsWithLogos(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getTeamOwner(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getTeamOwner(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getTeamUsers(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getTeamUsers(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public getTeamUsersWithOwner(teamId: string, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).getTeamUsersWithOwner(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} teamId 
     * @param {Array<AccountLocationDto>} accountLocationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsResourceApi
     */
    public validateTeamLocation(teamId: string, accountLocationDto: Array<AccountLocationDto>, options?: AxiosRequestConfig) {
        return TeamsResourceApiFp(this.configuration).validateTeamLocation(teamId, accountLocationDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TextBlockResourceApi - axios parameter creator
 * @export
 */
export const TextBlockResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/v1/text-blocks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (textBlockDto: TextBlockDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'textBlockDto' is not null or undefined
            assertParamExists('create', 'textBlockDto', textBlockDto)
            const localVarPath = `/v1/text-blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textBlockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/text-blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/text-blocks/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByName: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getByName', 'name', name)
            const localVarPath = `/v1/text-blocks/name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteNotices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/text-blocks/site-notices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByContent: async (query: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchByContent', 'query', query)
            const localVarPath = `/v1/text-blocks/search/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (textBlockDto: TextBlockDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'textBlockDto' is not null or undefined
            assertParamExists('update', 'textBlockDto', textBlockDto)
            const localVarPath = `/v1/text-blocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(textBlockDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextBlockResourceApi - functional programming interface
 * @export
 */
export const TextBlockResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextBlockResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(textBlockDto: TextBlockDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(textBlockDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextBlockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByName(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByName(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteNotices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextBlockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteNotices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchByContent(query: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextBlockDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchByContent(query, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(textBlockDto: TextBlockDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(textBlockDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TextBlockResourceApi - factory interface
 * @export
 */
export const TextBlockResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextBlockResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(textBlockDto: TextBlockDto, options?: any): AxiosPromise<TextBlockDto> {
            return localVarFp.create(textBlockDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id?: number, options?: any): AxiosPromise<TextBlockDto> {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options?: any): AxiosPromise<Array<TextBlockDto>> {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByName(name: string, options?: any): AxiosPromise<TextBlockDto> {
            return localVarFp.getByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteNotices(options?: any): AxiosPromise<Array<TextBlockDto>> {
            return localVarFp.getSiteNotices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchByContent(query: string, options?: any): AxiosPromise<Array<TextBlockDto>> {
            return localVarFp.searchByContent(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TextBlockDto} textBlockDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(textBlockDto: TextBlockDto, options?: any): AxiosPromise<TextBlockDto> {
            return localVarFp.update(textBlockDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextBlockResourceApi - object-oriented interface
 * @export
 * @class TextBlockResourceApi
 * @extends {BaseAPI}
 */
export class TextBlockResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public _delete(id: number, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TextBlockDto} textBlockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public create(textBlockDto: TextBlockDto, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).create(textBlockDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public get(id?: number, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public getAll(options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public getByName(name: string, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).getByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public getSiteNotices(options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).getSiteNotices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public searchByContent(query: string, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).searchByContent(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TextBlockDto} textBlockDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextBlockResourceApi
     */
    public update(textBlockDto: TextBlockDto, options?: AxiosRequestConfig) {
        return TextBlockResourceApiFp(this.configuration).update(textBlockDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersResourceApi - axios parameter creator
 * @export
 */
export const UsersResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvite: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserInvite', 'id', id)
            const localVarPath = `/public/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteUserDto: Array<InviteUserDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserDto' is not null or undefined
            assertParamExists('inviteUser', 'inviteUserDto', inviteUserDto)
            const localVarPath = `/users/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerDto: RegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDto' is not null or undefined
            assertParamExists('register', 'registerDto', registerDto)
            const localVarPath = `/public/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('removeUser', 'memberId', memberId)
            const localVarPath = `/users/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('revokeInvitation', 'memberId', memberId)
            const localVarPath = `/users/invites/{memberId}`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeUser: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('revokeUser', 'memberId', memberId)
            const localVarPath = `/users/{memberId}/revoke`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitationEmail: async (memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('sendInvitationEmail', 'memberId', memberId)
            const localVarPath = `/users/invites/{memberId}/resend`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTeamUsers: async (inviteUserDto: Array<InviteUserDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserDto' is not null or undefined
            assertParamExists('validateTeamUsers', 'inviteUserDto', inviteUserDto)
            const localVarPath = `/users/invite/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersResourceApi - functional programming interface
 * @export
 */
export const UsersResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInvite(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountMemberDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInvite(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteUserDto: Array<InviteUserDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(inviteUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerDto: RegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUser(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUser(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitation(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitation(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeUser(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeUser(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvitationEmail(memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvitationEmail(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateTeamUsers(inviteUserDto: Array<InviteUserDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateTeamUsers(inviteUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersResourceApi - factory interface
 * @export
 */
export const UsersResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvite(id: string, options?: any): AxiosPromise<AccountMemberDto> {
            return localVarFp.getUserInvite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(inviteUserDto: Array<InviteUserDto>, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.inviteUser(inviteUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerDto: RegisterDto, options?: any): AxiosPromise<string> {
            return localVarFp.register(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser(memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeUser(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeInvitation(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeUser(memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.revokeUser(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitationEmail(memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.sendInvitationEmail(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<InviteUserDto>} inviteUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateTeamUsers(inviteUserDto: Array<InviteUserDto>, options?: any): AxiosPromise<void> {
            return localVarFp.validateTeamUsers(inviteUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersResourceApi - object-oriented interface
 * @export
 * @class UsersResourceApi
 * @extends {BaseAPI}
 */
export class UsersResourceApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public getUserInvite(id: string, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).getUserInvite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<InviteUserDto>} inviteUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public inviteUser(inviteUserDto: Array<InviteUserDto>, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).inviteUser(inviteUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDto} registerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public register(registerDto: RegisterDto, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).register(registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public removeUser(memberId: string, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).removeUser(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public revokeInvitation(memberId: string, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).revokeInvitation(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public revokeUser(memberId: string, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).revokeUser(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public sendInvitationEmail(memberId: string, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).sendInvitationEmail(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<InviteUserDto>} inviteUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersResourceApi
     */
    public validateTeamUsers(inviteUserDto: Array<InviteUserDto>, options?: AxiosRequestConfig) {
        return UsersResourceApiFp(this.configuration).validateTeamUsers(inviteUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * YextResourceApi - axios parameter creator
 * @export
 */
export const YextResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} locationId 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuTile: async (locationId: number, yextMenuTileRequest: YextMenuTileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('createMenuTile', 'locationId', locationId)
            // verify required parameter 'yextMenuTileRequest' is not null or undefined
            assertParamExists('createMenuTile', 'yextMenuTileRequest', yextMenuTileRequest)
            const localVarPath = `/yext/locations/{locationId}/menus`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(yextMenuTileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteListingPhoto: async (locationId: number, slot: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteListingPhoto', 'locationId', locationId)
            // verify required parameter 'slot' is not null or undefined
            assertParamExists('deleteListingPhoto', 'slot', slot)
            const localVarPath = `/yext/locations/{locationId}/photos/{slot}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"slot"}}`, encodeURIComponent(String(slot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuTile: async (locationId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteMenuTile', 'locationId', locationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMenuTile', 'id', id)
            const localVarPath = `/yext/locations/{locationId}/menus/{id}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getListings', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/listings`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getProfile', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/profile`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports: async (locationId: number, days?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getReports', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/reports`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getStatus', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/status`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategories: async (entityType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/yext/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listListingPhotos: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listListingPhotos', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/photos`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberImages: async (memberId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('listMemberImages', 'memberId', memberId)
            const localVarPath = `/yext/members/{memberId}/images`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenuTiles: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('listMenuTiles', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/menus`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [memberId] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listingsAccess: async (memberId?: number, ownerId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/yext/listings-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (memberId !== undefined) {
                localVarQueryParameter['memberId'] = memberId;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('publish', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/publish`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushMenuFromDesign: async (locationId: number, designId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('pushMenuFromDesign', 'locationId', locationId)
            // verify required parameter 'designId' is not null or undefined
            assertParamExists('pushMenuFromDesign', 'designId', designId)
            const localVarPath = `/yext/locations/{locationId}/menu/design/{designId}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"designId"}}`, encodeURIComponent(String(designId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('reopen', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/reopen`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} yextProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDraft: async (locationId: number, yextProfileDto: YextProfileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('saveDraft', 'locationId', locationId)
            // verify required parameter 'yextProfileDto' is not null or undefined
            assertParamExists('saveDraft', 'yextProfileDto', yextProfileDto)
            const localVarPath = `/yext/locations/{locationId}/draft`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(yextProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {YextListingPhotoRequest} yextListingPhotoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setListingPhoto: async (locationId: number, slot: string, yextListingPhotoRequest: YextListingPhotoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('setListingPhoto', 'locationId', locationId)
            // verify required parameter 'slot' is not null or undefined
            assertParamExists('setListingPhoto', 'slot', slot)
            // verify required parameter 'yextListingPhotoRequest' is not null or undefined
            assertParamExists('setListingPhoto', 'yextListingPhotoRequest', yextListingPhotoRequest)
            const localVarPath = `/yext/locations/{locationId}/photos/{slot}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"slot"}}`, encodeURIComponent(String(slot)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(yextListingPhotoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} [yextProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncLocation: async (locationId: number, yextProfileDto?: YextProfileDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('syncLocation', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/sync`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(yextProfileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStatus: async (locationId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('syncStatus', 'locationId', locationId)
            const localVarPath = `/yext/locations/{locationId}/sync-status`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuTile: async (locationId: number, id: number, yextMenuTileRequest: YextMenuTileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateMenuTile', 'locationId', locationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMenuTile', 'id', id)
            // verify required parameter 'yextMenuTileRequest' is not null or undefined
            assertParamExists('updateMenuTile', 'yextMenuTileRequest', yextMenuTileRequest)
            const localVarPath = `/yext/locations/{locationId}/menus/{id}`
                .replace(`{${"locationId"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(yextMenuTileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMemberImages: async (memberId: number, locationId: number, inlineObject?: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('uploadMemberImages', 'memberId', memberId)
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('uploadMemberImages', 'locationId', locationId)
            const localVarPath = `/yext/members/{memberId}/images`
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YextResourceApi - functional programming interface
 * @export
 */
export const YextResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YextResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} locationId 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMenuTile(locationId: number, yextMenuTileRequest: YextMenuTileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextMenuTileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMenuTile(locationId, yextMenuTileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteListingPhoto(locationId: number, slot: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteListingPhoto(locationId, slot, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMenuTile(locationId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMenuTile(locationId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListings(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextListingsViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListings(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReports(locationId: number, days?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextReportsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReports(locationId, days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatus(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatus(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCategories(entityType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YextCategoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCategories(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listListingPhotos(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YextListingPhotoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listListingPhotos(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMemberImages(memberId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMemberImages(memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMenuTiles(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YextMenuTileDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMenuTiles(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [memberId] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listingsAccess(memberId?: number, ownerId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextListingsAccessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listingsAccess(memberId, ownerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publish(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextPublishResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publish(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushMenuFromDesign(locationId: number, designId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextSyncResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushMenuFromDesign(locationId, designId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopen(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextSyncResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopen(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} yextProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDraft(locationId: number, yextProfileDto: YextProfileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextSyncStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveDraft(locationId, yextProfileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {YextListingPhotoRequest} yextListingPhotoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setListingPhoto(locationId: number, slot: string, yextListingPhotoRequest: YextListingPhotoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextListingPhotoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setListingPhoto(locationId, slot, yextListingPhotoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} [yextProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncLocation(locationId: number, yextProfileDto?: YextProfileDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextSyncResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncLocation(locationId, yextProfileDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncStatus(locationId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextSyncStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncStatus(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMenuTile(locationId: number, id: number, yextMenuTileRequest: YextMenuTileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YextMenuTileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMenuTile(locationId, id, yextMenuTileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadMemberImages(memberId: number, locationId: number, inlineObject?: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberImageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMemberImages(memberId, locationId, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * YextResourceApi - factory interface
 * @export
 */
export const YextResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YextResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {number} locationId 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMenuTile(locationId: number, yextMenuTileRequest: YextMenuTileRequest, options?: any): AxiosPromise<YextMenuTileDto> {
            return localVarFp.createMenuTile(locationId, yextMenuTileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteListingPhoto(locationId: number, slot: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteListingPhoto(locationId, slot, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMenuTile(locationId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMenuTile(locationId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListings(locationId: number, options?: any): AxiosPromise<YextListingsViewDto> {
            return localVarFp.getListings(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(locationId: number, options?: any): AxiosPromise<YextProfileDto> {
            return localVarFp.getProfile(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReports(locationId: number, days?: number, options?: any): AxiosPromise<YextReportsDto> {
            return localVarFp.getReports(locationId, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatus(locationId: number, options?: any): AxiosPromise<YextStatusDto> {
            return localVarFp.getStatus(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [entityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCategories(entityType?: string, options?: any): AxiosPromise<Array<YextCategoryDto>> {
            return localVarFp.listCategories(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listListingPhotos(locationId: number, options?: any): AxiosPromise<Array<YextListingPhotoDto>> {
            return localVarFp.listListingPhotos(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberImages(memberId: number, options?: any): AxiosPromise<Array<MemberImageDto>> {
            return localVarFp.listMemberImages(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMenuTiles(locationId: number, options?: any): AxiosPromise<Array<YextMenuTileDto>> {
            return localVarFp.listMenuTiles(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [memberId] 
         * @param {number} [ownerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listingsAccess(memberId?: number, ownerId?: number, options?: any): AxiosPromise<YextListingsAccessDto> {
            return localVarFp.listingsAccess(memberId, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(locationId: number, options?: any): AxiosPromise<YextPublishResultDto> {
            return localVarFp.publish(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} designId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushMenuFromDesign(locationId: number, designId: string, options?: any): AxiosPromise<YextSyncResultDto> {
            return localVarFp.pushMenuFromDesign(locationId, designId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen(locationId: number, options?: any): AxiosPromise<YextSyncResultDto> {
            return localVarFp.reopen(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} yextProfileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDraft(locationId: number, yextProfileDto: YextProfileDto, options?: any): AxiosPromise<YextSyncStatusDto> {
            return localVarFp.saveDraft(locationId, yextProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {string} slot 
         * @param {YextListingPhotoRequest} yextListingPhotoRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setListingPhoto(locationId: number, slot: string, yextListingPhotoRequest: YextListingPhotoRequest, options?: any): AxiosPromise<YextListingPhotoDto> {
            return localVarFp.setListingPhoto(locationId, slot, yextListingPhotoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {YextProfileDto} [yextProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncLocation(locationId: number, yextProfileDto?: YextProfileDto, options?: any): AxiosPromise<YextSyncResultDto> {
            return localVarFp.syncLocation(locationId, yextProfileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStatus(locationId: number, options?: any): AxiosPromise<YextSyncStatusDto> {
            return localVarFp.syncStatus(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} locationId 
         * @param {number} id 
         * @param {YextMenuTileRequest} yextMenuTileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMenuTile(locationId: number, id: number, yextMenuTileRequest: YextMenuTileRequest, options?: any): AxiosPromise<YextMenuTileDto> {
            return localVarFp.updateMenuTile(locationId, id, yextMenuTileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} memberId 
         * @param {number} locationId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMemberImages(memberId: number, locationId: number, inlineObject?: InlineObject, options?: any): AxiosPromise<Array<MemberImageDto>> {
            return localVarFp.uploadMemberImages(memberId, locationId, inlineObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YextResourceApi - object-oriented interface
 * @export
 * @class YextResourceApi
 * @extends {BaseAPI}
 */
export class YextResourceApi extends BaseAPI {
    /**
     * 
     * @param {number} locationId 
     * @param {YextMenuTileRequest} yextMenuTileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public createMenuTile(locationId: number, yextMenuTileRequest: YextMenuTileRequest, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).createMenuTile(locationId, yextMenuTileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {string} slot 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public deleteListingPhoto(locationId: number, slot: string, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).deleteListingPhoto(locationId, slot, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public deleteMenuTile(locationId: number, id: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).deleteMenuTile(locationId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public getListings(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).getListings(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public getProfile(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).getProfile(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public getReports(locationId: number, days?: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).getReports(locationId, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public getStatus(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).getStatus(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [entityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public listCategories(entityType?: string, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).listCategories(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public listListingPhotos(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).listListingPhotos(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public listMemberImages(memberId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).listMemberImages(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public listMenuTiles(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).listMenuTiles(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [memberId] 
     * @param {number} [ownerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public listingsAccess(memberId?: number, ownerId?: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).listingsAccess(memberId, ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public publish(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).publish(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {string} designId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public pushMenuFromDesign(locationId: number, designId: string, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).pushMenuFromDesign(locationId, designId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public reopen(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).reopen(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {YextProfileDto} yextProfileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public saveDraft(locationId: number, yextProfileDto: YextProfileDto, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).saveDraft(locationId, yextProfileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {string} slot 
     * @param {YextListingPhotoRequest} yextListingPhotoRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public setListingPhoto(locationId: number, slot: string, yextListingPhotoRequest: YextListingPhotoRequest, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).setListingPhoto(locationId, slot, yextListingPhotoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {YextProfileDto} [yextProfileDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public syncLocation(locationId: number, yextProfileDto?: YextProfileDto, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).syncLocation(locationId, yextProfileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public syncStatus(locationId: number, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).syncStatus(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} locationId 
     * @param {number} id 
     * @param {YextMenuTileRequest} yextMenuTileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public updateMenuTile(locationId: number, id: number, yextMenuTileRequest: YextMenuTileRequest, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).updateMenuTile(locationId, id, yextMenuTileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} memberId 
     * @param {number} locationId 
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YextResourceApi
     */
    public uploadMemberImages(memberId: number, locationId: number, inlineObject?: InlineObject, options?: AxiosRequestConfig) {
        return YextResourceApiFp(this.configuration).uploadMemberImages(memberId, locationId, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }
}


